/** Русский словарь (ТЗ §5.1). Язык интерфейса по умолчанию. */
export const ru: Record<string, string> = {
  'app.title': 'CRM/ERP',
  'app.loading': 'Загрузка…',
  'app.error': 'Что-то пошло не так',
  'app.retry': 'Повторить',

  'auth.signIn': 'Войти',
  'auth.signOut': 'Выйти',
  'auth.signingIn': 'Входим…',
  'auth.required': 'Требуется вход',
  'auth.failed': 'Не удалось войти',
  'auth.signingOut': 'Выходим…',
  'auth.logoutFailed': 'Локальная сессия закрывается, но сервер входа не подтвердил выход. Повторите вход и выход при восстановлении соединения.',
  'auth.retry': 'Войти заново',
  'auth.stateExpired': 'Состояние входа устарело или относится к другой вкладке. Начните вход заново.',
  'auth.cancelled': 'Вход отменён или доступ не разрешён.',
  'auth.networkError': 'Не удалось связаться с сервером входа. Проверьте соединение и повторите.',
  'auth.exchangeFailed': 'Не удалось завершить вход. Начните заново; если ошибка повторится, обратитесь к администратору.',

  'nav.section.sales': 'Продажи',
  'nav.section.billing': 'Финансы',
  'nav.section.warehouse': 'Склад',
  'nav.section.hr': 'Кадры',

  'nav.leads': 'Лиды',
  'nav.deals': 'Сделки',
  'nav.counterparties': 'Контрагенты',
  'nav.quotes': 'Коммерческие предложения',
  'nav.products': 'Номенклатура',
  'nav.invoices': 'Счета',
  'nav.documents': 'Первичные документы',
  'nav.contracts': 'Договоры',
  'nav.stock': 'Остатки',
  'nav.receipts': 'Приёмка',
  'nav.shipments': 'Отгрузки',
  'nav.picking': 'Сборка',
  'nav.stocktakes': 'Инвентаризация',
  'nav.transfers': 'Перемещения',
  'nav.employees': 'Сотрудники',
  'nav.departments': 'Оргструктура',
  'nav.vacancies': 'Вакансии',
  'nav.leaves': 'Отпуска',
  'nav.kpi': 'KPI',

  'palette.placeholder': 'Раздел, команда или поиск по CRM…',
  'palette.empty': 'Ничего не найдено',
  'nav.sections': 'Разделы',
  'nav.collapse': 'Свернуть меню',
  'nav.expand': 'Развернуть меню',
  'topbar.searchLabel': 'Поиск и команды, Ctrl+K',
  'topbar.notifications': 'Уведомления: {count} новых',
  'topbar.theme': 'Тема оформления',
  'topbar.locale': 'Язык интерфейса',
  'topbar.profile': 'Профиль',
  'palette.hint': 'Ctrl+K — палитра команд',
  'palette.sections': 'Разделы',
  'palette.actions': 'Действия',
  'palette.records': 'Найдено в CRM',
  'palette.searching': 'Ищем…',
  'palette.searchFailed': 'Поиск не удался — разделы по-прежнему доступны',
  'topbar.search': 'Найти раздел, команду или запись',
  'search.type.sales.counterparty': 'Клиент',
  'search.type.sales.contact': 'Контакт',
  'search.type.sales.deal': 'Сделка',
  'search.type.billing.invoice': 'Счёт',
  'search.type.sales.lead': 'Лид',
  'search.type.support.ticket': 'Обращение',
  'search.type.comment': 'Комментарий',
  'search.type.email': 'Письмо',
  'search.state.overdue': 'Просрочен',
  'search.state.paid': 'Оплачен',
  'search.state.cancelled': 'Отменён',
  'search.state.won': 'Выиграна',
  'search.state.lost': 'Проиграна',

  'search.placeholder': 'Поиск по системе',
  'search.empty': 'Ничего не найдено',
  'search.minLength': 'Введите хотя бы {count} символа',

  'theme.light': 'Светлая тема',
  'theme.dark': 'Тёмная тема',
  'theme.system': 'Как в системе',
  'locale.ru': 'Русский',
  'locale.en': 'English',

  'access.denied': 'Нет доступа к этому разделу',
  'access.deniedHint': 'Обратитесь к администратору, если раздел нужен для работы',
  'page.notFound': 'Страница не найдена',
  'page.placeholder': 'Раздел появится в следующих задачах',

  'list.columns': 'Колонки',
  'list.resetColumns': 'Сбросить к стандартным',
  'list.groupBy': 'Группировка',
  'list.tools': 'Ещё: представления, группировка, сегменты, импорт и выгрузка',
  'pager.label': 'Страницы списка',
  'pager.prev': 'Назад',
  'pager.next': 'Вперёд',
  'pager.range': 'Строки {from}–{to}',
  'pager.of': 'из {total}',
  'pager.empty': 'Нет строк',
  'pager.size': 'Строк на странице:',
  'list.noGrouping': 'Без группировки',
  'list.empty': 'Ничего не найдено',
  'list.loaded': 'Загружено строк: {count}',
  'list.more': 'Показать ещё',
  'list.selectRow': 'Выбрать строку',
  'list.selectPage': 'Выбрать все строки на странице',

  'filter.column': 'Колонка',
  'filter.operator': 'Условие',
  'filter.value': 'Значение',
  'filter.valueList': 'Значения через запятую',
  'filter.add': 'Добавить фильтр',
  'filter.remove': 'Убрать фильтр',
  'filter.op.eq': 'равно',
  'filter.op.ne': 'не равно',
  'filter.op.gt': 'больше',
  'filter.op.gte': 'больше или равно',
  'filter.op.lt': 'меньше',
  'filter.op.lte': 'меньше или равно',
  'filter.op.contains': 'содержит',
  'filter.op.starts_with': 'начинается с',
  'filter.op.between': 'в диапазоне',
  'filter.op.in': 'один из',
  'filter.op.is_null': 'не заполнено',
  'filter.op.is_not_null': 'заполнено',

  'view.picker': 'Представление',
  'view.none': 'Без представления',
  'view.name': 'Название представления',
  'view.save': 'Сохранить как',
  'view.update': 'Обновить',
  'view.delete': 'Удалить',
  'view.makeDefault': 'Открывать по умолчанию',
  'view.shareIt': 'Общее',
  'view.shared': 'общее',
  'view.broken': 'Представление не читается: сохраните его заново',

  'export.csv': 'Выгрузить CSV',
  'export.running': 'Готовим файл…',

  'import.title': 'Импорт из CSV',
  'import.file': 'Файл импорта',
  'import.template': 'Скачать шаблон',
  'import.columns': 'Колонки файла: {columns}',
  'import.required': 'Обязательные: {columns}',
  'import.running': 'Загружаем…',
  'import.result': 'Загружено {imported} из {total}, отклонено {failed}',
  'import.line': 'Строка',
  'import.column': 'Колонка',
  'import.reason': 'Причина',
  'import.found': 'В файле {rows} строк и {columns} колонок. Укажите, какая колонка файла идёт в какое поле',
  'import.mapping': 'Сопоставление колонок',
  'import.field': 'Поле',
  'import.fileColumn': 'Колонка файла',
  'import.example': 'Пример из первой строки',
  'import.skip': '— не загружать —',
  'import.unmapped': 'Не сопоставлены обязательные поля: {fields}',
  'import.run': 'Загрузить {rows} строк',
  'bulk.newResponsible': 'Новый ответственный',
  'bulk.reassign': 'Назначить',
  'bulk.newStage': 'Новый этап',
  'bulk.move': 'Перенести',
  'bulk.domainResult': 'Изменено {affected} из {requested}.',
  'bulk.skipped': 'Пропущены: {reasons}',
  'bulk.byFilter': 'Действия со всеми по фильтру ({count})',

  'bulk.selected': 'Выбрано строк: {count}',
  'bulk.clear': 'Снять выделение',
  'bulk.delete': 'Удалить',
  'bulk.deleted': 'Удалено {affected} из {requested} выбранных',

  'column.id': 'ID',
  'column.name': 'Название',
  'column.kind': 'Тип',
  'column.inn': 'ИНН',
  'column.kpp': 'КПП',
  'column.email': 'Почта',
  'column.phone': 'Телефон',
  'column.relation': 'Отношение',
  'column.industry': 'Отрасль',
  'column.credit_limit': 'Кредитный лимит',
  'column.is_blocked': 'Заблокирован',
  'column.responsible_employee_id': 'Ответственный',
  'column.created_at': 'Создано',
  'column.number': 'Номер',
  'column.title': 'Заголовок',
  'column.tags': 'Теги',
  'column.amount': 'Сумма',
  'column.currency': 'Валюта',
  'column.status': 'Статус',
  'column.probability': 'Вероятность',
  'column.stage_id': 'Стадия',
  'column.funnel_id': 'Воронка',
  'column.counterparty_id': 'Контрагент',
  'column.expected_close_on': 'Ожидаемое закрытие',
  'column.closed_at': 'Закрыта',
  'column.department_id': 'Подразделение',
  'column.sku': 'Артикул',
  'column.product_type': 'Вид номенклатуры',
  'column.vat_rate': 'Ставка НДС',
  'column.barcode': 'Штрихкод',
  'column.category_id': 'Категория',
  'column.weight_kg': 'Вес, кг',
  'column.min_stock': 'Мин. остаток',
  'column.is_active': 'Активен',

  'list.open': 'Открыть',

  'card.tab.main': 'Основное',
  'card.tab.related': 'Связанные',
  'card.tab.history': 'История',
  'card.tab.attachments': 'Вложения',

  'card.section.general': 'Общее',
  'card.section.requisites': 'Реквизиты',
  'card.section.contacts': 'Контакты',
  'card.section.finance': 'Финансовые условия',
  'card.section.money': 'Деньги',
  'card.section.pipeline': 'Воронка',
  'card.section.logistics': 'Логистика',
  'card.section.service': 'Служебное',

  'card.edit': 'Редактировать',
  'card.save': 'Сохранить',
  'card.saving': 'Сохраняем…',
  'card.cancel': 'Отменить',
  'card.back': 'Назад',
  'card.saved': 'Сохранено',
  'card.savedPartially':
    'Записано полей: {applied}. На поле «{field}» сохранение остановилось: {reason}',
  'card.noRecord': 'Запись не загружена',
  'card.gone': 'Записи больше нет: её удалили или она вышла из области видимости',
  'card.notAffected': 'Строка не изменилась: её удалили либо она вне области видимости',
  'card.noVersion':
    'Защиты от параллельной правки нет: сервер не отдаёт версию записи. '
    + 'Расхождение будет обнаружено сравнением полей перед записью, но окно между '
    + 'проверкой и записью остаётся.',

  'card.error.number': 'Ожидается число',
  'card.error.date': 'Ожидается дата',
  'card.error.uuid': 'Ожидается идентификатор',
  'card.error.boolean': 'Ожидается «да» или «нет»',

  'card.conflict.title': 'Запись изменена параллельно',
  'card.conflict.explain':
    'Пока карточка была открыта, эти поля изменил кто-то другой. '
    + 'Выберите по каждому, чьё значение верно: автоматического победителя у расхождения нет.',
  'card.conflict.detected': 'Сервер отверг запись из-за параллельной правки',
  'card.conflict.field': 'Поле',
  'card.conflict.theirs': 'На сервере',
  'card.conflict.mine': 'Ваше значение',
  'card.conflict.decision': 'Решение',
  'card.conflict.takeTheirs': 'Взять серверное',
  'card.conflict.keepMine': 'Оставить своё',
  'card.conflict.discard': 'Отменить правку и перечитать',
  'card.conflict.otherFields': 'Изменились поля, которых нет на этом экране',

  'card.related.missing': 'Связанные сущности пока не показываются',
  'card.related.reason':
    'REST над бизнес-логикой выводится в тикетах #67 и #68; читать связи пока нечем.',
  'card.attachments.missing': 'Вложения пока не показываются',
  'card.attachments.reason': 'Хранилища файлов в системе нет.',
  'card.attachments.upload': 'Прикрепить файл',
  'card.attachments.empty': 'Вложений нет',
  'card.attachments.name': 'Файл',
  'card.attachments.size': 'Размер',
  'card.attachments.status': 'Проверка',
  'card.attachments.action': 'Действие',
  'card.attachments.download': 'Скачать',
  'card.attachments.unavailable': 'Недоступен',
  'card.attachments.status.pending': 'Ожидает антивируса',
  'card.attachments.status.clean': 'Проверен',
  'card.attachments.status.infected': 'Заражён',
  'card.attachments.status.failed': 'Ошибка проверки',
  'card.contract.attachments.show': 'Скан договора',
  'card.contract.attachments.hide': 'Скрыть скан договора',

  // --- карточка контрагента, тикет #70 ---
  'common.yes': 'да',

  'card.tab.contacts': 'Контакты',
  'card.tab.interactions': 'Взаимодействия',
  'card.tab.finance': 'Финансы',

  'card.cp.contacts.empty': 'Контактных лиц не заведено',
  'card.cp.contact.name': 'Имя',
  'card.cp.contact.role': 'Должность',
  'card.cp.contact.primary': 'основной',
  'card.cp.contact.consent': 'Согласие на ПДн',
  // Не пустая ячейка: звонить человеку без согласия нельзя, и молчание об этом
  // перекладывает нарушение на того, кто просто открыл карточку.
  'card.cp.contact.noConsent': 'нет',
  // Флаг под контактом читается без подписи колонки — нужна полная фраза.
  'card.cp.contact.noConsentFlag': 'Нет согласия на ПДн',

  'card.cp.accounts.title': 'Банковские реквизиты',
  'card.cp.accounts.empty': 'Банковских счетов не заведено',
  'card.cp.account.bank': 'Банк',
  'card.cp.account.bik': 'БИК',
  'card.cp.account.number': 'Счёт',
  'card.cp.account.primary': 'основной',

  'card.cp.timeline.count': 'Касаний с клиентом: {count}',
  'card.cp.timeline.empty': 'Взаимодействий не записано',
  'card.cp.timeline.overdue': 'просрочено',

  'activity.type.call': 'Звонок',
  'activity.type.email': 'Письмо',
  'activity.type.meeting': 'Встреча',
  'activity.type.task': 'Задача',
  'activity.type.note': 'Заметка',

  'card.cp.finance.empty': 'Финансовых данных нет',
  // Названо вслух, а не спрятано: исчезнувшая вкладка читалась бы как «у клиента нет
  // финансов», то есть как факт о клиенте, а не как отсутствие права у смотрящего.
  'card.cp.finance.needsBilling':
    'Нужно право на чтение счетов (billing.invoice): долг клиента — данные биллинга.',

  'card.cp.credit.unlimited': 'без лимита',
  'card.cp.credit.debt': 'Текущий долг',
  'card.cp.credit.available': 'Доступно',
  'card.cp.credit.terms': 'Отсрочка платежа',
  'card.cp.credit.termsDays': '{days} дн.',
  'card.cp.credit.exceeded': 'Кредитный лимит превышен: долг {debt} при лимите {limit}',
  'card.cp.blocked': 'Контрагент заблокирован: {reason}',

  'card.cp.ageing.title': 'Дебиторка по срокам',
  'card.cp.ageing.none': 'Задолженности нет',
  'card.cp.ageing.current': 'Срок не наступил',
  'card.cp.ageing.d30': 'до 30 дн.',
  'card.cp.ageing.d60': '31–60 дн.',
  'card.cp.ageing.d90': '61–90 дн.',
  'card.cp.ageing.d90plus': 'свыше 90 дн.',
  'card.cp.ageing.total': 'Итого по валюте',

  'card.cp.contracts.title': 'Договоры',
  'card.cp.contracts.empty': 'Договоров не заведено',
  'card.cp.contract.number': 'Номер',
  'card.cp.contract.type': 'Вид',
  'card.cp.contract.valid': 'Действует',
  'card.cp.contract.lapsed': 'срок истёк',

  'contract.type.sale': 'Поставка',
  'contract.type.purchase': 'Закупка',
  'contract.type.service': 'Услуги',
  'contract.type.agency': 'Агентский',
  'contract.type.storage': 'Хранение',
  'contract.status.draft': 'Черновик',
  'contract.status.active': 'Действует',
  'contract.status.expired': 'Истёк',
  'contract.status.terminated': 'Расторгнут',

  'card.cp.dup.searching': 'Ищем похожие карточки…',
  'card.cp.dup.none': 'Похожих карточек не найдено',
  'card.cp.dup.found': 'Похожих карточек: {count}. Проверьте, не заводите ли дубль.',
  'card.cp.dup.blocking':
    'Контрагент с такой парой ИНН и КПП уже заведён — сохранить не получится.',
  'card.cp.dup.failed': 'Поиск дублей не выполнен. Это не значит, что дублей нет.',
  'card.cp.dup.blocked': 'заблокирован',
  'card.cp.dup.by.inn': 'тот же ИНН',
  'card.cp.dup.by.inn_kpp': 'та же пара ИНН и КПП',
  'card.cp.dup.by.phone': 'тот же телефон',
  'card.cp.dup.by.contact_phone': 'телефон контактного лица',
  'card.cp.dup.by.email': 'та же почта',
  'card.cp.dup.by.contact_email': 'почта контактного лица',

  'list.create': 'Завести',

  'card.cp.create.title': 'Новый контрагент',
  'card.cp.create.submit': 'Завести',
  'card.cp.create.legalName': 'Полное наименование',
  'card.cp.create.legalAddress': 'Юридический адрес',
  'card.cp.create.actualAddress': 'Фактический адрес',
  'card.cp.create.blocked': 'Сначала откройте существующую карточку или измените КПП',

  'counterparty.kind.legal': 'Юрлицо',
  'counterparty.kind.sole_trader': 'ИП',
  'counterparty.kind.individual': 'Физлицо',

  // ---------------------------------------------------------- доска сделок (#71)

  'deals.mode': 'Форма представления',
  'deals.mode.table': 'Таблица',
  'deals.mode.board': 'Доска',
  'deals.board.filters': 'Фильтров применено: {count}',

  'board.funnel': 'Воронка',
  'board.noFunnels': 'Активных воронок нет — доску не из чего построить',
  'board.weightedPipeline': 'Взвешенный прогноз: {amount}',
  'board.columnTotals': 'сделок: {count}, сумма: {amount}',
  'board.columnWeighted': 'взвешенно: {amount} ({probability}%)',
  'board.expectedClose': 'закрыть до {date}',
  'board.stuck': 'застряла: {days} дн. при лимите {limit}',
  'board.moveTo': 'Перенести сделку {deal}',

  'card.tab.dealLines': 'Строки',
  'card.tab.stageHistory': 'История стадий',

  'card.deal.lines.empty': 'В сделке нет строк',
  'card.deal.lines.total': 'Итого по строкам',
  'card.deal.line.product': 'Товар',
  'card.deal.line.quantity': 'Кол-во',
  'card.deal.line.price': 'Цена',
  'card.deal.line.discount': 'Скидка',
  'card.deal.line.vat': 'НДС',
  'card.deal.line.total': 'Итого строки',
  'card.deal.line.cost': 'Себестоимость',
  'card.deal.cost.unknown': 'не заполнена',
  'card.deal.margin.title': 'Маржа',
  'card.deal.margin.cost': 'Себестоимость сделки',
  'card.deal.margin.amount': 'Маржа',
  'card.deal.margin.unknown': 'неизвестна: не у всех строк есть себестоимость',
  'card.deal.weighted': 'Взвешенная сумма',

  'card.deal.history.empty': 'Переходов по стадиям не было',
  'card.deal.history.when': 'Когда',
  'card.deal.history.from': 'Откуда',
  'card.deal.history.to': 'Куда',
  'card.deal.history.spent': 'Провела в стадии',
  'card.deal.history.who': 'Кто',
  'card.deal.history.created': 'сделка заведена',
  'card.deal.history.backwards': 'возврат назад',
  'card.deal.history.days': '{days} дн.',
  'card.deal.history.hours': '{hours} ч.',
  'card.deal.history.minutes': '{minutes} мин.',
  'card.deal.history.summary': 'Переходов: {total}, из них возвратов назад: {backwards}',
  // ---------------------------------------------------------------- счета (#72)

  'column.issued_on': 'Выставлен',
  'column.due_on': 'Срок оплаты',

  'card.section.dates': 'Сроки',

  'card.tab.invoiceLines': 'Позиции',
  'card.tab.invoiceSettlements': 'Оплаты',
  'card.tab.invoiceDunning': 'Напоминания',
  'card.tab.invoiceActions': 'Действия',
  'card.tab.receivables': 'Дебиторка',

  'card.inv.missing': 'Счёт не загружен',
  'card.inv.paid': 'Оплачено',
  'card.inv.outstanding': 'Остаток долга',

  'card.inv.lines.empty': 'В счёте нет позиций',
  'card.inv.lines.mismatch':
    'Итог счёта не равен сумме его строк. Клиент складывает строки — покажите это бухгалтеру.',
  'card.inv.lines.lineMismatch':
    'Строк с несходящимся итогом: {count}. НДС начисляется на сумму со скидкой и округляется построчно.',
  'card.inv.line.description': 'Наименование',
  'card.inv.line.quantity': 'Кол-во',
  'card.inv.line.unitPrice': 'Цена',
  'card.inv.line.discount': 'Скидка',
  'card.inv.line.net': 'Сумма со скидкой',
  'card.inv.line.vatRate': 'Ставка НДС',
  'card.inv.line.vatAmount': 'НДС',
  'card.inv.line.total': 'Итого строки',

  'card.inv.total.subtotal': 'Сумма без НДС',
  'card.inv.total.discount': 'Скидка',
  'card.inv.total.vat': 'НДС',
  'card.inv.total.total': 'Итого',

  'card.inv.settlements.empty': 'На этот счёт ничего не разнесено',
  'card.inv.settlements.needsBilling': 'Нужно право на счета',
  'card.inv.settlements.needsPayments': 'Нужно право на платежи, чтобы видеть, чем закрыт счёт',
  'card.inv.settlements.mismatch':
    'Разнесено {allocated}, а на счёте записано {paid}. Цифры разошлись — это порча данных.',
  'card.inv.settlement.payment': 'Платёж',
  'card.inv.settlement.date': 'Дата',
  'card.inv.settlement.method': 'Способ',
  'card.inv.settlement.amount': 'Разнесено',
  'card.inv.settlement.rule': 'Как',
  'card.inv.settlement.actions': 'Действия',
  'card.inv.settlement.remove': 'Снять',
  'card.inv.settlement.orphan': 'платёж не найден',

  'card.inv.allocate.title': 'Разнести оплату',
  'card.inv.allocate.payment': 'Платёж',
  'card.inv.allocate.choose': '— выберите платёж —',
  'card.inv.allocate.amount': 'Сумма',
  'card.inv.allocate.submit': 'Разнести',
  'card.inv.allocate.saving': 'Разносим…',
  'card.inv.allocate.noPayment': 'Не выбран платёж',
  'card.inv.allocate.badAmount': 'Сумма должна быть больше нуля',
  'card.inv.allocate.noAdvances': 'У контрагента нет неразнесённых платежей',
  'card.inv.allocate.notPayable':
    'На этот счёт разносить нельзя: он отменён либо уже закрыт',

  'card.inv.dunning.empty': 'Напоминаний по этому счёту не было',
  'card.inv.dunning.step': 'Ступень',
  'card.inv.dunning.kind': 'Действие',
  'card.inv.dunning.scheduled': 'Назначено',
  'card.inv.dunning.executed': 'Выполнено',
  'card.inv.dunning.result': 'Результат',
  'card.inv.dunning.pending': 'ещё нет',
  'card.inv.dunning.days': '{days} дн. просрочки',

  'card.inv.action.send': 'Отправить счёт',
  'card.inv.action.sent': 'Счёт отправлен',
  'card.inv.action.sendUnavailable': 'Отправить можно только черновик',
  'card.inv.action.cancel': 'Отменить счёт',
  'card.inv.action.cancelled': 'Счёт отменён',
  'card.inv.action.cancelUnavailable': 'Оплаченный или уже отменённый счёт не отменяется',
  'card.inv.action.reason': 'Причина отмены',
  'card.inv.action.reasonRequired':
    'Без причины отменить нельзя: она останется в реестре навсегда',
  'card.inv.action.reissue': 'Повторная выписка',
  'card.inv.action.reissueMissing':
    'Домен её не публикует. Новый счёт взамен старого меняет номер, а номер уже у клиента — отмените счёт и выставьте новый явно.',

  'card.inv.ageing.title': 'Дебиторка по срокам',
  'card.inv.ageing.explain':
    'Срок не наступил — это не просрочка: счёт, выставленный вчера со сроком через месяц, долговой проблемой не является.',
  'card.inv.ageing.none': 'Задолженности нет',
  'card.inv.ageing.notYetDue': 'Срок не наступил',
  'card.inv.ageing.d30': 'До 30 дней',
  'card.inv.ageing.d60': '31–60 дней',
  'card.inv.ageing.d90': '61–90 дней',
  'card.inv.ageing.d90plus': 'Свыше 90 дней',
  'card.inv.ageing.overdue': 'Просрочено',
  'card.inv.ageing.total': 'Всего',

  'card.inv.outstanding.title': 'Открытые счета',
  'card.inv.outstanding.none': 'Открытых счетов нет',
  'card.inv.outstanding.sum': 'Всего к получению: {amount}',

  'card.inv.subs.title': 'Подписки',
  'card.inv.subs.none': 'Подписок нет',
  'card.inv.sub.name': 'Название',
  'card.inv.sub.frequency': 'Периодичность',
  'card.inv.sub.dayOfMonth': 'День списания',
  'card.inv.sub.nextRun': 'Ближайшее списание',
  'card.inv.sub.paused': 'приостановлена',
  'card.inv.sub.active': 'Активна',
  'card.inv.sub.inactive': 'Приостановлена',

  'invoice.status.draft': 'Черновик',
  'invoice.status.sent': 'Отправлен',
  'invoice.status.partially_paid': 'Оплачен частично',
  'invoice.status.paid': 'Оплачен',
  'invoice.status.overdue': 'Просрочен',
  'invoice.status.cancelled': 'Отменён',

  'dunning.kind.email': 'Письмо',
  'dunning.kind.call_task': 'Задача на звонок',
  'dunning.kind.manager_notice': 'Уведомление руководителю',
  'dunning.kind.legal': 'Передача юристам',

  // Коды — из Payment.Method, а не придуманные: непереведённый ключ виден на экране,
  // а лишний перевод несуществующего кода не виден никогда и живёт вечно.
  'payment.method.bank_transfer': 'Банковский перевод',
  'payment.method.acquiring': 'Эквайринг',
  'payment.method.sbp': 'СБП',
  'payment.method.cash': 'Наличные',
  'payment.method.offset': 'Взаимозачёт',
  'payment.method.deposit': 'С депозита',

  // Правил разнесения ровно два (PaymentAllocation.Rule): система нашла или человек
  // назначил. Три прохода автосверки — это способ найти, а не отдельное правило.
  'allocation.rule.auto': 'Автосверка',
  'allocation.rule.manual': 'Вручную',

  'recurring.frequency.monthly': 'Ежемесячно',
  'recurring.frequency.quarterly': 'Ежеквартально',
  'recurring.frequency.yearly': 'Ежегодно',
  'recurring.frequency.weekly': 'Еженедельно',

  // ------------------------------------------------------------------ #73: первичка и договоры

  'card.tab.docLines': 'Строки',
  'card.tab.docSignature': 'Подпись и статус',
  'card.tab.contracts': 'Договоры',
  'card.section.signature': 'Подпись и ЭДО',

  'card.doc.empty': 'Документ не загружен',
  'card.doc.number': 'Номер',
  'card.doc.date': 'Дата',
  'card.doc.status': 'Статус',
  'card.doc.signedAt': 'Подписан',
  'card.doc.subtotal': 'Итого',
  'card.doc.edi': 'ЭДО',
  'card.doc.edi.none': 'Не отправлялся',
  'card.doc.edi.messageId': 'Идентификатор сообщения оператора',
  'card.doc.reissuedFrom': 'Причина перевыпуска',
  'card.doc.reissues': 'Чем заменён',
  'card.doc.reissues.empty': 'Документ не перевыпускался',
  'card.doc.reissue.reason': 'Причина перевыпуска',

  'card.doc.lines.empty': 'В документе нет строк',
  'card.doc.lines.mismatch': 'Итог документа не сходится с суммой его строк',
  'card.doc.lines.lineMismatch': 'Строк с расхождением арифметики: {count}',
  'card.doc.line.description': 'Наименование',
  'card.doc.line.quantity': 'Количество',
  'card.doc.line.price': 'Цена',
  'card.doc.line.vatRate': 'Ставка НДС',
  'card.doc.line.vat': 'НДС',
  'card.doc.line.total': 'Сумма с НДС',

  // «Не подписан» и «подпись не сходится» — разные факты, и у них разные строки:
  // общая формулировка выставила бы каждый черновик подделанным.
  'card.doc.sign.unsigned': 'Документ не подписан',
  'card.doc.sign.unknown': 'Состояние подписи неизвестно',
  'card.doc.sign.intact': 'Подпись сходится с содержимым документа',
  'card.doc.sign.mismatch': 'Содержимое изменено после подписания',
  'card.doc.sign.mismatchExplained':
    'Хеш строк не совпадает с тем, что зафиксировала подпись: документ на экране — не тот, который подписывали.',
  'card.doc.sign.signedHash': 'Хеш при подписании',
  'card.doc.sign.currentHash': 'Хеш сейчас',

  'card.doc.status.draft': 'Черновик',
  'card.doc.status.issued': 'Выставлен',
  'card.doc.status.signed': 'Подписан',
  'card.doc.status.cancelled': 'Аннулирован',

  'card.doc.action.issue': 'Выставить',
  'card.doc.action.sign': 'Подписать',
  'card.doc.action.edi': 'Отметить отправку по ЭДО',
  'card.doc.action.cancel': 'Аннулировать',
  'card.doc.action.reissue': 'Перевыпустить',

  'card.contract.empty': 'Договоров с этим контрагентом нет',
  'card.contract.number': 'Номер',
  'card.contract.type': 'Вид',
  'card.contract.status': 'Статус',
  'card.contract.signedOn': 'Подписан',
  'card.contract.validUntil': 'Действует до',
  'card.contract.openEnded': 'Бессрочно',
  'card.contract.amount': 'Сумма',
  'card.contract.paymentTerms': 'Отсрочка, дней',
  'card.contract.usableToday': 'Заказ сегодня',
  'card.contract.usable': 'Можно',
  'card.contract.notUsable': 'Нельзя',
  'card.contract.prolongTo': 'Продлить до',
  'card.contract.terminateReason': 'Причина расторжения',
  // Пробел назван на экране: пустое поле «причина» читалось бы как «расторгли без причины».
  'card.contract.gaps':
    'Причина расторжения хранится только в журнале приложения — колонки под неё в схеме нет. Скан договора недоступен: файлового хранилища в проекте нет.',

  'card.contract.type.sale': 'Продажа',
  'card.contract.type.purchase': 'Закупка',
  'card.contract.type.service': 'Услуги',
  'card.contract.type.storage': 'Хранение',
  'card.contract.type.agency': 'Агентский',

  'card.contract.status.draft': 'Черновик',
  'card.contract.status.active': 'Действует',
  'card.contract.status.expired': 'Истёк',
  'card.contract.status.terminated': 'Расторгнут',

  'card.contract.action.activate': 'Ввести в действие',
  'card.contract.action.prolong': 'Продлить',
  'card.contract.action.terminate': 'Расторгнуть',
  // --- склад: карточки документов (#74) ---
  'card.tab.whReceiptLines': 'Строки',
  'card.tab.whDiscrepancies': 'Расхождения',
  'card.tab.whShipmentLines': 'Состав',
  'card.tab.whPacking': 'Упаковочный лист',
  'card.tab.whRoute': 'Маршрут',
  'card.tab.whCountSheet': 'Лист пересчёта',
  'card.tab.whVariances': 'Сличительная ведомость',
  'card.tab.whApproval': 'Утверждение',
  'card.tab.whReservations': 'Резервы',
  'card.tab.whTransferLines': 'Строки',
  'card.tab.whActions': 'Действия',

  'card.section.quantity': 'Количество',

  'card.wh.status': 'Статус',
  'card.wh.noUpdateRight': 'Нет права изменять документ',
  'card.wh.line.product': 'Товар',
  'card.wh.line.batch': 'Партия',
  'card.wh.line.cell': 'Ячейка',
  'card.wh.line.quantity': 'Количество',

  'card.wh.receipt.expected': 'Ожидается',
  'card.wh.receipt.accepted': 'Принято',
  'card.wh.receipt.rejected': 'Брак',
  'card.wh.receipt.reason': 'Причина',
  'card.wh.receipt.discrepancy': 'Расхождение',
  'card.wh.receipt.noLines': 'Строк нет: внеплановую приёмку наберёт кладовщик сканером',
  'card.wh.receipt.noDiscrepancies': 'Расхождений нет: принято столько, сколько ожидалось',
  'card.wh.receipt.hasDiscrepancies': 'Есть расхождения',
  'card.wh.receipt.start': 'Передать в работу',
  'card.wh.receipt.started': 'Приёмка передана в работу',
  'card.wh.receipt.startUnavailable': 'Передать в работу можно только черновик',
  'card.wh.receipt.cancel': 'Отменить приёмку',
  'card.wh.receipt.cancelled': 'Приёмка отменена',
  'card.wh.receipt.cancelUnavailable':
    'Проведённую приёмку отменяют возвратом поставщику, а не отменой документа',
  'card.wh.receipt.countingOnTerminal': 'Пересчёт строк делается на терминале сбора данных',

  'card.wh.ship.posted': 'Проведена',
  'card.wh.ship.notPosted': 'Не проведена',
  'card.wh.ship.handedOver': 'Передана перевозчику',
  'card.wh.ship.notHandedOver': 'Не передана',
  'card.wh.ship.delivered': 'Доставлена',
  'card.wh.ship.notDelivered': 'Не доставлена',
  'card.wh.ship.carrier': 'Перевозчик',
  'card.wh.ship.tracking': 'Трек-номер',
  'card.wh.ship.packages': 'Мест',
  'card.wh.ship.packageNo': 'Место',
  'card.wh.ship.noLines': 'Состав отгрузки пуст',
  'card.wh.ship.notPacked': 'Отгрузка ещё не упакована: упаковка идёт на терминале',
  'card.wh.ship.handOver': 'Передача перевозчику',
  'card.wh.ship.carrierCode': 'Код перевозчика',
  'card.wh.ship.handOverSubmit': 'Передать перевозчику',
  'card.wh.ship.handedOverDone': 'Заявка перевозчику отправлена',
  'card.wh.ship.handOverNeedsPosting': 'Сначала отгрузку надо провести: передаётся уже списанный товар',
  'card.wh.ship.alreadyHandedOver': 'Уже передана: повторная заявка приведёт второго курьера',
  'card.wh.ship.markDelivered': 'Отметка доставки',
  'card.wh.ship.deliveredAt': 'Момент доставки',
  'card.wh.ship.markDeliveredSubmit': 'Отметить доставку',
  'card.wh.ship.deliveredDone': 'Доставка отмечена',
  'card.wh.ship.deliveredHint':
    'Момент берётся от перевозчика: пустое поле означает «сейчас»',
  'card.wh.ship.deliverNeedsHandOver': 'Отгрузка ещё не передана перевозчику',
  'card.wh.ship.alreadyDelivered': 'Доставка уже отмечена',
  'card.wh.ship.packingOnTerminal': 'Упаковка и проведение делаются на терминале сбора данных',

  'card.wh.pick.mode': 'Режим',
  'card.wh.pick.stops': 'Остановок в маршруте',
  'card.wh.pick.shortages': 'Недоборы',
  'card.wh.pick.shortageNotice':
    'В задании есть недоборы: товара не оказалось на полке — повод пересчитать ячейку',
  'card.wh.pick.routeOrder': '№',
  'card.wh.pick.required': 'Нужно',
  'card.wh.pick.picked': 'Отобрано',
  'card.wh.pick.noLines': 'Строк в задании нет',
  'card.wh.pick.assign': 'Назначение сборщика',
  'card.wh.pick.assignee': 'Сотрудник',
  'card.wh.pick.assigneeHint':
    'Идентификатор сотрудника: справочника с фильтром по складу пока нет',
  'card.wh.pick.assignSubmit': 'Назначить',
  'card.wh.pick.assigned': 'Сборщик назначен',
  'card.wh.pick.cancel': 'Отмена задания',
  'card.wh.pick.cancelHint': 'Отмена снимет резервы, которые задание держало',
  'card.wh.pick.cancelSubmit': 'Отменить задание',
  'card.wh.pick.cancelled': 'Задание отменено',
  'card.wh.pick.cancelUnavailable': 'Завершённое или отменённое задание не отменяется',

  'card.wh.stocktake.scope': 'Охват',
  'card.wh.stocktake.blind': 'Слепой пересчёт',
  'card.wh.stocktake.blindNotice':
    'Слепой пересчёт: ожидаемое количество не показывается никому, включая офис',
  'card.wh.stocktake.expected': 'Ожидается',
  'card.wh.stocktake.counted': 'Посчитано',
  'card.wh.stocktake.variance': 'Расхождение',
  'card.wh.stocktake.kind': 'Тип',
  'card.wh.stocktake.comment': 'Комментарий',
  'card.wh.stocktake.surplus': 'Излишек',
  'card.wh.stocktake.shortage': 'Недостача',
  'card.wh.stocktake.noLines': 'Лист пересчёта пуст',
  'card.wh.stocktake.noVariances': 'Расхождений нет: пересчёт сошёлся с учётом',
  'card.wh.stocktake.approve': 'Утвердить результаты',
  'card.wh.stocktake.approved': 'Утверждено, корректировок: {count}',
  'card.wh.stocktake.approveWarning':
    'Утверждение изменит остаток: корректировка применяется разницей к текущему количеству',
  'card.wh.stocktake.approveNeedsCounting': 'Пересчёт ещё не завершён',
  'card.wh.stocktake.alreadyApproved': 'Результаты уже утверждены',
  'card.wh.stocktake.needsApproveRight':
    'Утверждение требует отдельного права: оно меняет остаток, то есть деньги на балансе',
  'card.wh.stocktake.approvedAt': 'Утверждено',
  'card.wh.stocktake.notApproved': 'Не утверждено',
  'card.wh.stocktake.adjustments': 'Проведённые корректировки',
  'card.wh.stocktake.noAdjustments': 'Корректировок не потребовалось: пересчёт сошёлся',
  'card.wh.stocktake.before': 'Было',
  'card.wh.stocktake.after': 'Стало',
  'card.wh.stocktake.delta': 'Разница',
  'card.wh.stocktake.cancel': 'Отменить инвентаризацию',
  'card.wh.stocktake.cancelled': 'Инвентаризация отменена',

  'card.wh.stock.order': 'Заказ',
  'card.wh.stock.expires': 'Действует до',
  'card.wh.stock.noExpiry': 'До отгрузки',
  'card.wh.stock.noReservations': 'Резервов нет: весь остаток свободен',

  'card.wh.transfer.dispatched': 'Отправлено',
  'card.wh.transfer.notDispatched': 'Не отправлено',
  'card.wh.transfer.received': 'Принято',
  'card.wh.transfer.notReceived': 'Не принято',
  'card.wh.transfer.sent': 'Отправлено',
  'card.wh.transfer.accepted': 'Принято',
  'card.wh.transfer.loss': 'Потеря в пути',
  'card.wh.transfer.lossNotice':
    'Есть потери в пути: это претензия к перевозчику, а не недостача склада-получателя',
  'card.wh.transfer.noLines': 'Строк в перемещении нет',
  'card.wh.transfer.dispatch': 'Отправка',
  'card.wh.transfer.dispatchHint':
    'Отправка спишет товар с остатка склада-отправителя: он уже в машине, а не на полке',
  'card.wh.transfer.dispatchSubmit': 'Отправить',
  'card.wh.transfer.dispatchedDone': 'Перемещение отправлено',
  'card.wh.transfer.alreadyDispatched': 'Уже отправлено: товар в пути',
  'card.wh.transfer.cancel': 'Отменить перемещение',
  'card.wh.transfer.cancelledDone': 'Перемещение отменено',
  'card.wh.transfer.cancelUnavailable': 'Отправленное перемещение отменить нельзя: товар в пути',
  'card.wh.transfer.receiptOnTerminal': 'Приём перемещения делается на терминале получателя',

  'warehouse.receipt.status.draft': 'Черновик',
  'warehouse.receipt.status.in_progress': 'В работе',
  'warehouse.receipt.status.completed': 'Завершена',
  'warehouse.receipt.status.cancelled': 'Отменена',

  'warehouse.shipment.status.draft': 'Черновик',
  'warehouse.shipment.status.packed': 'Упакована',
  'warehouse.shipment.status.posted': 'Проведена',
  'warehouse.shipment.status.shipped': 'Отгружена',
  'warehouse.shipment.status.delivered': 'Доставлена',
  'warehouse.shipment.status.cancelled': 'Отменена',

  'warehouse.pick.status.created': 'Создано',
  'warehouse.pick.status.assigned': 'Назначено',
  'warehouse.pick.status.in_progress': 'В работе',
  'warehouse.pick.status.completed': 'Завершено',
  'warehouse.pick.status.cancelled': 'Отменено',
  'warehouse.pick.mode.order': 'По заказу',
  'warehouse.pick.mode.wave': 'Волной',
  'warehouse.pickline.status.pending': 'Ожидает',
  'warehouse.pickline.status.picked': 'Отобрано',
  'warehouse.pickline.status.skipped': 'Пропущено',
  'warehouse.pickline.status.short': 'Недобор',

  'warehouse.stocktake.status.draft': 'Черновик',
  'warehouse.stocktake.status.counting': 'Пересчёт',
  'warehouse.stocktake.status.counted': 'Посчитано',
  'warehouse.stocktake.status.approved': 'Утверждено',
  'warehouse.stocktake.status.cancelled': 'Отменена',
  'warehouse.stocktake.scope.full': 'Весь склад',
  'warehouse.stocktake.scope.zone': 'Зона',
  'warehouse.stocktake.scope.cell': 'Ячейка',
  'warehouse.stocktake.scope.product': 'Товар',

  'warehouse.transfer.status.draft': 'Черновик',
  'warehouse.transfer.status.in_transit': 'В пути',
  'warehouse.transfer.status.received': 'Принято',
  'warehouse.transfer.status.cancelled': 'Отменено',

  'warehouse.reservation.status.active': 'Активен',
  'warehouse.reservation.status.released': 'Снят',
  'warehouse.reservation.status.shipped': 'Отгружен',
  'warehouse.reservation.status.expired': 'Просрочен',

  // ------------------------------------------------------------------ кадры (#75)

  'column.personnel_number': 'Табельный номер',
  'column.last_name': 'Фамилия',
  'column.first_name': 'Имя',
  'column.middle_name': 'Отчество',
  'column.work_email': 'Рабочая почта',
  'column.work_phone': 'Рабочий телефон',
  'column.position_id': 'Должность',
  'column.manager_id': 'Руководитель',
  'column.hired_on': 'Принят',
  'column.terminated_on': 'Уволен',
  'column.birth_date': 'Дата рождения',
  'column.gender': 'Пол',
  'column.organization_id': 'Организация',
  'column.code': 'Код',
  'column.parent_id': 'Вышестоящее',
  'column.path': 'Путь по дереву',
  'column.head_employee_id': 'Руководитель',
  'column.cost_center': 'Центр затрат',
  'column.salary_from': 'Оклад от',
  'column.salary_to': 'Оклад до',
  'column.recruiter_id': 'Рекрутер',
  'column.hiring_manager_id': 'Нанимающий менеджер',
  'column.opened_on': 'Открыта',
  'column.target_close_on': 'Плановое закрытие',
  'column.closed_on': 'Дата закрытия',
  'column.external_source': 'Внешний источник',
  'column.external_id': 'Внешний идентификатор',
  'column.employee_id': 'Сотрудник',
  'column.leave_type': 'Вид отсутствия',
  'column.start_date': 'С',
  'column.end_date': 'По',
  'column.days_count': 'Дней',
  'column.comment': 'Комментарий',
  'column.kpi_id': 'Показатель',
  'column.period_start': 'Период с',
  'column.period_end': 'Период по',
  'column.target_value': 'План',
  'column.actual_value': 'Факт',
  'column.bonus_amount': 'Премия',

  'card.section.assignment': 'Назначение',

  'card.tab.hrAssignments': 'Назначения',
  'card.tab.hrReports': 'Подчинённые',
  'card.tab.hrBalances': 'Отпуска',
  'card.tab.hrKpi': 'KPI',
  'card.tab.hrPersonalData': 'Персональные данные',
  'card.tab.hrActions': 'Действия',
  'card.tab.hrOrgTree': 'Оргструктура',
  'card.tab.hrApproval': 'Согласование',
  'card.tab.hrRoute': 'Маршрут',
  'card.tab.hrTimesheet': 'Табель',
  'card.tab.hrBoard': 'Кандидаты',
  'card.tab.hrFunnel': 'Воронка',
  'card.tab.hrKpiTargets': 'Показатели',

  'card.hr.emp.noAssignments': 'Назначений нет',
  'card.hr.emp.effectiveFrom': 'Действует с',
  'card.hr.emp.effectiveTo': 'Действует по',
  'card.hr.emp.open': 'по настоящее время',
  'card.hr.emp.reason': 'Основание',
  'card.hr.emp.position': 'Должность',
  'card.hr.emp.salary': 'Оклад',
  'card.hr.emp.rate': 'Ставка',
  'card.hr.emp.order': 'Приказ',
  'card.hr.emp.name': 'Сотрудник',
  'card.hr.emp.noReports': 'Прямых подчинённых нет',
  'card.hr.emp.pdnHidden': 'Персональные данные зашифрованы. Каждый просмотр записывается в журнал.',
  'card.hr.emp.pdnReveal': 'Показать персональные данные',
  'card.hr.emp.pdnEmpty': 'Персональные данные не заполнены',
  'card.hr.emp.inn': 'ИНН',
  'card.hr.emp.snils': 'СНИЛС',
  'card.hr.emp.passport': 'Паспорт',
  'card.hr.emp.personalPhone': 'Личный телефон',
  'card.hr.emp.confirmProbation': 'Подтвердить испытательный срок',
  'card.hr.emp.probationConfirmed': 'Испытательный срок подтверждён',
  'card.hr.emp.probationUnavailable': 'Сотрудник не на испытательном сроке',
  'card.hr.emp.needsUpdate': 'Нет права на изменение карточки сотрудника',
  'card.hr.emp.terminateElsewhere': 'Перевод и увольнение оформляются приказом: нужны дата вступления и номер приказа.',

  'card.hr.dept.empty': 'Подразделений нет',
  'card.hr.dept.head': 'Руководитель',
  'card.hr.dept.move': 'Переместить',
  'card.hr.dept.moveTo': 'Новое вышестоящее подразделение',
  'card.hr.dept.moveToRoot': 'пусто — в корень',
  'card.hr.dept.moved': 'Подразделение перемещено вместе с поддеревом',
  'card.hr.dept.needsUpdate': 'Нет права на изменение оргструктуры',

  'card.hr.leave.clashes': 'Кто ещё из отдела отсутствует в эти даты',
  'card.hr.leave.noClashes': 'Пересечений с отпусками коллег нет',
  'card.hr.leave.clashesUnknownDepartment': 'Подразделение сотрудника неизвестно — пересечения показать нечем. Это не значит, что их нет.',
  'card.hr.leave.coverage': 'Отсутствуют {away} из {headcount}, на месте {present}',
  'card.hr.leave.thin': 'Отдел останется без трети состава.',
  'card.hr.leave.approve': 'Согласовать',
  'card.hr.leave.reject': 'Отклонить',
  'card.hr.leave.approved': 'Заявка согласована, дни списаны',
  'card.hr.leave.rejected': 'Заявка отклонена',
  'card.hr.leave.decisionUnavailable': 'Решение принимается по заявке на согласовании',
  'card.hr.leave.needsApprove': 'Нет права согласовывать отсутствия',
  'card.hr.leave.rowMissing': 'Строка заявки не прочитана: без сотрудника и дат пересечения не спросить.',
  'card.hr.leave.noRoute': 'Маршрут пуст: у сотрудника нет руководителя с учётной записью',
  'card.hr.leave.step': 'Шаг',
  'card.hr.leave.stepName': 'Название',
  'card.hr.leave.approver': 'Согласующий',
  'card.hr.leave.approverUser': 'учётная запись {id}',
  'card.hr.leave.approverRole': 'любой из роли {id}',
  'card.hr.leave.noBalances': 'Остатков нет',
  'card.hr.leave.year': 'Год',
  'card.hr.leave.entitled': 'Норма',
  'card.hr.leave.used': 'Использовано',
  'card.hr.leave.carriedOver': 'Перенесено',
  'card.hr.leave.remaining': 'Остаток',
  'card.hr.leave.carryOver': 'Перенести',
  'card.hr.leave.carriedOverDone': 'Дни перенесены на следующий год',
  'card.hr.leave.noTimesheet': 'Табель за период не заполнен',
  'card.hr.leave.day': 'День',
  'card.hr.leave.dayType': 'Вид',
  'card.hr.leave.hours': 'Часов',

  'card.hr.vac.noApplications': 'Откликов нет',
  'card.hr.vac.moveTo': 'Перевести на стадию',
  'card.hr.vac.stageChanged': 'Стадия изменена',
  'card.hr.vac.reject': 'Отказать',
  'card.hr.vac.rejected': 'Отказ зафиксирован',
  'card.hr.vac.reason': 'Причина отказа',
  'card.hr.vac.reasonRequired': 'Без причины отказ не сохраняется: её нечего сказать кандидату и нечего анализировать.',
  'card.hr.vac.revokeConsent': 'Отозвать согласие на ПДн',
  'card.hr.vac.consentRevoked': 'Согласие отозвано, данные обезличены',
  'card.hr.vac.funnel': 'Воронка',
  'card.hr.vac.conversion': 'Конверсия между стадиями',
  'card.hr.vac.stageFrom': 'Со стадии',
  'card.hr.vac.stageTo': 'На стадию',
  'card.hr.vac.entered': 'Дошло',
  'card.hr.vac.moved': 'Прошло дальше',
  'card.hr.vac.percent': 'Конверсия, %',
  'card.hr.vac.timeToFill': 'Срок закрытия',
  'card.hr.vac.stillOpen': 'Вакансия ещё открыта — срок не наступил',
  'card.hr.vac.filledInDays': 'Закрыта за {days} дней',

  'card.hr.kpi.noTargets': 'Целей нет',
  'card.hr.kpi.completion': 'Выполнение, %',
  'card.hr.kpi.metric': 'Показатель',
  'card.hr.kpi.weight': 'Вес',
  'card.hr.kpi.overall': 'Общее выполнение: {percent}%',
  'card.hr.kpi.departmentGoal': 'Это цель подразделения: личного сотрудника у неё нет.',
  'card.hr.kpi.bonusElsewhere': 'Премия считается от премиального фонда, и он задаётся при начислении.',

  'hr.employee.status.active': 'Работает',
  'hr.employee.status.probation': 'Испытательный срок',
  'hr.employee.status.on_leave': 'В отпуске',
  'hr.employee.status.terminated': 'Уволен',

  'hr.assignment.reason.hire': 'Приём',
  'hr.assignment.reason.transfer': 'Перевод',
  'hr.assignment.reason.promotion': 'Повышение',
  'hr.assignment.reason.salary_change': 'Изменение оклада',
  'hr.assignment.reason.termination': 'Увольнение',

  'hr.leave.type.annual': 'Ежегодный',
  'hr.leave.type.unpaid': 'За свой счёт',
  'hr.leave.type.sick': 'Больничный',
  'hr.leave.type.maternity': 'По уходу за ребёнком',
  'hr.leave.type.study': 'Учебный',
  'hr.leave.type.day_off': 'Отгул',

  'hr.leave.status.draft': 'Черновик',
  'hr.leave.status.pending': 'На согласовании',
  'hr.leave.status.approved': 'Согласовано',
  'hr.leave.status.rejected': 'Отклонено',
  'hr.leave.status.cancelled': 'Отменено',

  'hr.timesheet.type.work': 'Работа',
  'hr.timesheet.type.vacation': 'Отпуск',
  'hr.timesheet.type.sick': 'Больничный',
  'hr.timesheet.type.day_off': 'Отгул',
  'hr.timesheet.type.holiday': 'Праздник',
  'hr.timesheet.type.absence': 'Отсутствие',
  'hr.timesheet.type.business_trip': 'Командировка',

  'hr.application.stage.applied': 'Отклик',
  'hr.application.stage.screening': 'Скрининг',
  'hr.application.stage.interview': 'Интервью',
  'hr.application.stage.offer': 'Оффер',
  'hr.application.stage.hired': 'Нанят',
  'hr.application.stage.rejected': 'Отказ',
  // Аналитика и отчёты (#76)
  'nav.section.analytics': 'Аналитика',
  'nav.reportBuilder': 'Конструктор отчётов',
  'nav.salesReports': 'Отчёты по продажам',
  'nav.financeReports': 'Финансовые отчёты',
  'nav.warehouseReports': 'Складские отчёты',
  'nav.reportSchedules': 'Рассылки отчётов',

  'report.empty': 'За выбранный период данных нет',
  'report.period.from': 'С',
  'report.period.to': 'По',
  'report.forbidden': 'Нет права на данные этого отчёта',
  'report.builder.hint':
    'Выберите витрину, измерения и меры. Список полей ограничен реестром: он решает, какие данные доступны отчётности.',
  'report.source': 'Витрина',
  'report.source.choose': 'Выберите витрину',
  'report.noSources': 'Нет ни одной доступной витрины',
  'report.dimensions': 'Измерения',
  'report.measures': 'Меры',
  'report.filters': 'Фильтры',
  'report.measure.field': 'Поле меры',
  'report.measure.choose': 'Выберите поле',
  'report.measure.aggregate': 'Агрегат',
  'report.measure.add': 'Добавить меру',
  'report.filter.field': 'Поле фильтра',
  'report.filter.choose': 'Выберите поле',
  'report.filter.add': 'Добавить фильтр',
  'report.filter.operator': 'Оператор',
  'report.filter.value': 'Значение',
  'report.remove': 'Убрать',
  'report.preview': 'Предпросмотр',
  'report.save': 'Сохранить отчёт',
  'report.saved': 'Отчёт «{name}» сохранён',
  'report.saved.title': 'Сохранённые отчёты',
  'report.saved.empty': 'Сохранённых отчётов пока нет',
  'report.run': 'Запустить',
  'report.export': 'Выгрузить',
  'report.delete': 'Удалить',
  'report.code': 'Код',
  'report.name': 'Название',
  'report.category': 'Категория',
  'report.rows': 'Строк: {count}',
  'report.target.primary': 'основная база',
  'report.target.replica': 'реплика',
  'report.category.sales': 'Продажи',
  'report.category.warehouse': 'Склад',
  'report.category.finance': 'Финансы',
  'report.category.hr': 'Кадры',
  'report.aggregate.sum': 'Сумма',
  'report.aggregate.avg': 'Среднее',
  'report.aggregate.min': 'Минимум',
  'report.aggregate.max': 'Максимум',
  'report.aggregate.count': 'Количество',
  'report.source.pnl': 'Прибыли и убытки',
  'report.source.stock': 'Остатки',
  'report.source.receivables': 'Дебиторка',
  'report.source.consumption': 'Расход товара',
  'report.source.supplier_quality': 'Качество поставщиков',
  'report.source.funnel': 'Воронка продаж',
  'report.source.ltv': 'Ценность клиента',

  'report.tab.funnel': 'Воронка',
  'report.tab.pnl': 'Прибыли и убытки',
  'report.tab.unit': 'Юнит-экономика',
  'report.tab.actual': 'ДДС: факт',
  'report.tab.forecast': 'ДДС: прогноз',
  'report.tab.receivables': 'Дебиторка',
  'report.tab.abc': 'ABC/XYZ',
  'report.tab.dead': 'Неликвид',
  'report.tab.pickers': 'Сборщики',
  'report.tab.suppliers': 'Поставщики',

  'report.funnel.id': 'Воронка',
  'report.funnel.choose': 'Укажите воронку, чтобы построить отчёт',
  'report.funnel.stage': 'Стадия',
  'report.funnel.movedOn': 'Прошли дальше',
  'report.funnel.movedBack': 'Вернулись назад',
  'report.funnel.won': 'Выиграно',
  'report.funnel.lost': 'Проиграно',
  'report.funnel.conversion': 'Конверсия',
  'report.funnel.cycle': 'Цикл сделки',
  'report.funnel.deals': 'Сделок',
  'report.funnel.avgCycle': 'Средний цикл',
  'report.funnel.medianCycle': 'Медианный цикл',
  'report.funnel.losses': 'Причины проигрышей',
  'report.funnel.noReason': 'Причина не указана',

  'report.pnl.dimension': 'Разрез',
  'report.pnl.dimension.PRODUCT': 'По товарам',
  'report.pnl.dimension.PRODUCT_CATEGORY': 'По категориям',
  'report.pnl.dimension.EMPLOYEE': 'По менеджерам',
  'report.pnl.dimension.COUNTERPARTY': 'По контрагентам',
  'report.pnl.dimension.DEPARTMENT': 'По подразделениям',
  'report.pnl.dimension.TERRITORY': 'По территориям',
  'report.pnl.group': 'Разрез',
  'report.pnl.revenue': 'Выручка',
  'report.pnl.cost': 'Себестоимость',
  'report.pnl.margin': 'Маржа',
  'report.pnl.marginPercent': 'Маржа, %',
  'report.pnl.incomplete':
    'Строк без себестоимости: {count}. Маржа по ним не считается — показанная меньше настоящей.',

  'report.unit.channel': 'Канал',
  'report.unit.customers': 'Клиентов',
  'report.unit.spend': 'Затраты',
  'report.unit.cac': 'CAC',
  'report.unit.ltv': 'LTV',
  'report.unit.ratio': 'LTV / CAC',

  'report.cash.item': 'Статья',
  'report.cash.source': 'Источник',
  'report.cash.direction': 'Направление',
  'report.cash.direction.in': 'Поступление',
  'report.cash.direction.out': 'Выплата',
  'report.cash.direction.incoming': 'Поступление',
  'report.cash.direction.outgoing': 'Выплата',
  'report.cash.amount': 'Сумма',
  'report.cash.weighted': 'Взвешенно',
  'report.cash.kind.pipeline': 'Воронка',
  'report.cash.kind.invoice': 'Счета',
  'report.cash.kind.recurring': 'Подписки',

  'report.ageing.counterparty': 'Контрагент',
  'report.ageing.notYetDue': 'Срок не наступил',
  'report.ageing.b0': 'До 30 дней',
  'report.ageing.b31': '31–60 дней',
  'report.ageing.b61': '61–90 дней',
  'report.ageing.b90': 'Более 90 дней',
  'report.ageing.overdue': 'Просрочено',
  'report.ageing.total': 'Всего',

  'report.abc.sku': 'Артикул',
  'report.abc.product': 'Товар',
  'report.abc.cost': 'Оборот',
  'report.abc.cumulative': 'Накопленная доля',
  'report.abc.class': 'Класс',
  'report.abc.variation': 'Коэф. вариации',
  'report.abc.months': 'Месяцев истории',
  'report.abc.turnover': 'Оборачиваемость',
  'report.dead.since': 'Не двигалось с',
  'report.dead.onHand': 'Остаток',
  'report.dead.lastOutbound': 'Последняя отгрузка',
  'report.dead.never': 'Не отгружался ни разу',

  'report.picker.employee': 'Сборщик',
  'report.picker.tasks': 'Заданий',
  'report.picker.lines': 'Строк',
  'report.picker.perHour': 'Строк в час',
  'report.picker.shortfall': 'Недобор, %',

  'report.supplier.name': 'Поставщик',
  'report.supplier.receipts': 'Поставок',
  'report.supplier.rejected': 'Брак',
  'report.supplier.shortfall': 'Недопоставка',
  'report.supplier.defectPercent': 'Брак, %',

  'report.schedule.hint':
    'Расписание в формате cron из пяти полей. Письмо уходит на момент отправки — пропущенные запуски не догоняются.',
  'report.schedule.report': 'Отчёт',
  'report.schedule.chooseReport': 'Выберите отчёт',
  'report.schedule.cron': 'Расписание (cron)',
  'report.schedule.format': 'Формат',
  'report.schedule.recipients': 'Получатели через запятую',
  'report.schedule.lastRun': 'Прошлый запуск',
  'report.schedule.nextRun': 'Следующий запуск',
  'report.schedule.notScheduled': 'Не запланирован',
  'report.schedule.add': 'Добавить рассылку',

  'column.revenue': 'Выручка',
  'column.cost': 'Себестоимость',
  'column.margin': 'Маржа',
  'column.quantity': 'Количество',
  'column.product_id': 'Товар',
  'column.product_category_id': 'Категория товара',
  'column.territory_id': 'Территория',
  'column.product_name': 'Наименование',
  'column.warehouse_id': 'Склад',
  'column.warehouse_code': 'Код склада',
  'column.on_hand': 'Остаток',
  'column.reserved': 'В резерве',
  'column.available': 'Доступно',
  'column.custody_quantity': 'На ответхранении',
  'column.counterparty_name': 'Контрагент',
  'column.outstanding_total': 'Долг всего',
  'column.not_yet_due': 'Срок не наступил',
  'column.bucket_0_30': 'До 30 дней',
  'column.bucket_31_60': '31–60 дней',
  'column.bucket_61_90': '61–90 дней',
  'column.bucket_90_plus': 'Более 90 дней',
  'column.month': 'Месяц',
  'column.cost_amount': 'Стоимость',
  'column.movement_count': 'Движений',
  'column.supplier_id': 'Поставщик',
  'column.supplier_name': 'Поставщик',
  'column.received_on': 'Дата приёмки',
  'column.receipt_count': 'Поставок',
  'column.accepted_quantity': 'Принято',
  'column.rejected_quantity': 'Брак',
  'column.shortfall_quantity': 'Недопоставка',
  'column.from_stage_name': 'Из стадии',
  'column.to_stage_name': 'В стадию',
  'column.direction': 'Направление',
  'column.changed_on': 'Дата перехода',
  'column.transition_count': 'Переходов',
  'column.avg_duration_seconds': 'Среднее время, с',
  'column.lead_source': 'Источник лида',
  'column.utm_source': 'UTM source',
  'column.utm_medium': 'UTM medium',
  'column.acquired_on': 'Дата привлечения',
  'column.lifetime_revenue': 'Выручка за всё время',
  'column.lifetime_margin': 'Маржа за всё время',
  'column.deal_count': 'Сделок',

  // ---------------------------------------------------------------- оплата (#78)
  'nav.section.payments': 'Оплата',
  'nav.reconciliation': 'Сверка платежей',
  'nav.cashBook': 'Кассовая книга',
  'nav.fiscal': 'Фискализация',
  'nav.paymentRegistry': 'Реестр платежей',

  'payments.organization': 'Организация',
  'payments.organization.choose': 'Выберите организацию',
  'payments.account': 'Банковский счёт',
  'payments.account.choose': 'Выберите счёт',

  'payments.reconciliation.hint':
    'Загрузите выписку 1С «Клиент-Банк». Строки станут платежами и разнесутся по счетам автоматически; то, что не легло, останется в списках ниже.',
  'payments.import.file': 'Файл выписки',
  'payments.import.done': 'Выписка загружена: новых строк {imported} из {total}, повторных {duplicates}',
  'payments.import.duplicate': 'Эта выписка уже загружена — те же {total} операций. Повторно ничего не создано.',
  'payments.convertAll': 'Провести всё',
  'payments.convertLine': 'Провести',
  'payments.absorbAdvances': 'Перенести излишек на баланс',
  'payments.convert.done': 'Проведено {converted}, осталось {remaining}',
  'payments.convert.failed': 'Не проведены: {ids}',

  'payments.unprocessedLines': 'Непроведённые строки выписки',
  'payments.unprocessedLines.hint':
    'Банк прислал, платежа ещё нет. Строка не переписывается и не исчезает — она ждёт.',
  'payments.unprocessedLines.empty': 'Вся выписка проведена',
  'payments.needingAttention': 'Платежи без контрагента',
  'payments.needingAttention.hint':
    'Деньги пришли, но плательщик не опознан. Пока строка здесь, платёж не потерян.',
  'payments.needingAttention.empty': 'Все платежи разнесены',

  'payments.cashBook.hint':
    'Журнал append-only: исправление — это обратная проводка рядом с ошибочной, а не правка её.',
  'payments.cashBook.entries': 'Проводки',
  'payments.cashBook.totals': 'Обороты по статьям',
  'payments.cashBook.empty': 'За период проводок нет',
  'payments.cashBook.netFlow': 'Остаток за период:',
  'payments.cashBook.reverses': '(сторно проводки {id})',
  'payments.reverse': 'Сторнировать',
  'payments.reverse.reason': 'Причина сторнирования',

  'payments.fiscal.hint':
    '«Оплачено у нас» и «зарегистрировано в ОФД» — разные факты. Здесь то, что до ОФД не доехало.',
  'payments.fiscal.outstanding': 'чеки, не дошедшие до ОФД',
  'payments.fiscal.empty': 'Все чеки дошли до ОФД',
  'payments.fiscal.retry': 'Повторить все ожидающие ({count})',
  'payments.fiscal.retry.done': 'Отправлено чеков: {count}',
  'payments.fiscal.retry.none':
    'Отправлять нечего: у чеков ещё не наступило время следующей попытки',
  'payments.acquiring.unprocessed': 'Уведомления эквайринга без платежа',
  'payments.acquiring.hint':
    'Журнал ключуется событием: об одной оплате провайдер шлёт несколько уведомлений.',
  'payments.acquiring.empty': 'Неразобранных уведомлений нет',
  'payments.acquiring.signed': 'Подпись проверена',
  'payments.acquiring.unsigned': 'Подпись не проверена',

  'payments.direction.incoming': 'Приход',
  'payments.direction.outgoing': 'Расход',
  'payments.item.sales_revenue': 'Выручка',
  'payments.item.customer_advance': 'Аванс клиента',
  'payments.item.other_income': 'Прочий доход',
  'payments.item.refund_issued': 'Возврат клиенту',
  'payments.item.supplier_payment': 'Оплата поставщику',
  'payments.item.payroll': 'Зарплата',
  'payments.item.taxes': 'Налоги',
  'payments.item.rent': 'Аренда',
  'payments.item.other_expense': 'Прочий расход',
  'payments.receiptKind.sale': 'Приход',
  'payments.receiptKind.refund': 'Возврат',
  'payments.receiptKind.correction': 'Коррекция',
  'payments.receiptStatus.pending': 'Ожидает отправки',
  'payments.receiptStatus.sent': 'Отправлен, ответа нет',
  'payments.receiptStatus.registered': 'Зарегистрирован',
  'payments.receiptStatus.failed': 'Ошибка отправки',
  'payments.receiptStatus.abandoned': 'Попытки исчерпаны',

  'payments.column.statementDate': 'Дата выписки',
  'payments.column.paymentDate': 'Дата платежа',
  'payments.column.paymentDirection': 'Направление',
  'payments.column.paymentAmount': 'Сумма',
  'payments.column.unallocated': 'Не разнесено',
  'payments.column.payer': 'Плательщик',
  'payments.column.paymentPurpose': 'Назначение',
  'payments.column.entryDate': 'Дата проводки',
  'payments.column.cashItem': 'Статья ДДС',
  'payments.column.entryDescription': 'Описание',
  'payments.column.turnover': 'Оборот',
  'payments.column.receiptCreated': 'Пробит',
  'payments.column.receiptKind': 'Вид чека',
  'payments.column.receiptTotal': 'Сумма чека',
  'payments.column.receiptStatus': 'Статус в ОФД',
  'payments.column.receiptAttempts': 'Попыток',
  'payments.column.receiptError': 'Ошибка',
  'payments.column.webhookReceived': 'Получено',
  'payments.column.webhookProvider': 'Провайдер',
  'payments.column.webhookEvent': 'Событие',
  'payments.column.webhookStatus': 'Статус',
  'payments.column.webhookSignature': 'Подпись',

  // Колонки реестров списков (#78). Префикс column.* общий с другими разделами,
  // поэтому имена взяты те, каких нет ни у одной существующей сущности каталога.
  'column.unallocated_amount': 'Не разнесено',
  'column.payer_name': 'Плательщик',
  'column.payer_inn': 'ИНН плательщика',
  'column.payment_date': 'Дата платежа',
  'column.value_date': 'Дата валютирования',
  'column.bank_account_id': 'Банковский счёт',
  // Сквозные механизмы: согласования, задачи, лента, уведомления (#79).
  'nav.section.work': 'Работа',
  'nav.approvals': 'Согласования',
  'nav.tasks': 'Задачи',
  'nav.notifications': 'Уведомления',
  'approvals.title': 'Мои согласования',
  'approvals.queue.empty': 'Ничего не ждёт вашей подписи',
  'approvals.requestedBy': 'Отправил',
  'approvals.requestedAt': 'Отправлено',
  'approvals.step': 'Шаг',
  'approvals.approver': 'Согласующий',
  'approvals.stepStatus': 'Решение',
  'approvals.decidedAt': 'Когда решено',
  'approvals.comment': 'Комментарий',
  'approvals.approve': 'Согласовать',
  'approvals.reject': 'Отклонить',
  'approvals.needComment': 'Отказ требует комментария',
  'approvals.waitingOnSomeoneElse': 'Ждёт решения другого согласующего',
  'approvals.history.empty': 'Согласований по этому документу не было',
  'approvals.status.pending': 'На согласовании',
  'approvals.status.approved': 'Согласовано',
  'approvals.status.rejected': 'Отклонено',
  'approvals.status.cancelled': 'Отозвано',
  'approvals.stepStatus.pending': 'Ожидает',
  'approvals.stepStatus.approved': 'Согласовано',
  'approvals.stepStatus.rejected': 'Отклонено',
  'approvals.stepStatus.skipped': 'Не потребовалось',
  'approvals.entity.quote': 'Коммерческое предложение',
  'approvals.entity.invoice': 'Счёт',
  'approvals.entity.leave': 'Заявление на отпуск',
  'approvals.delegation.title': 'Делегирование права подписи',
  'approvals.delegation.granted': 'Кому я передал',
  'approvals.delegation.received': 'Чью подпись я несу',
  'approvals.delegation.to': 'Кому',
  'approvals.delegation.period': 'Срок',
  'approvals.delegation.reason': 'Основание',
  'approvals.delegation.state': 'Состояние',
  'approvals.delegation.active': 'Действует',
  'approvals.delegation.expired': 'Истекло',
  'approvals.delegation.revoked': 'Отозвано',
  'approvals.delegation.revoke': 'Отозвать',
  'approvals.delegation.openEnded': 'бессрочно',
  'approvals.delegation.none': 'Вы никому не передавали право подписи',
  'approvals.delegation.noneReceived': 'Вам не передавали право подписи',
  'tasks.title': 'Мои задачи',
  'tasks.open': 'В работе',
  'tasks.overdue': 'Просроченные',
  'tasks.overdueBadge': 'просрочено',
  'tasks.empty': 'Открытых задач нет',
  'tasks.subject': 'Задача',
  'tasks.due': 'Срок',
  'tasks.status': 'Статус',
  'tasks.complete': 'Завершить',
  'tasks.status.planned': 'Запланирована',
  'tasks.status.in_progress': 'В работе',
  'tasks.status.done': 'Выполнена',
  'tasks.status.cancelled': 'Отменена',
  'tasks.noEmployeeCard': 'За этой учётной записью не числится карточка сотрудника, поэтому задач у неё нет',
  'card.tab.timeline': 'Лента',
  'card.tab.approvals': 'Согласования',
  'timeline.empty': 'Взаимодействий пока не было',
  'timeline.hasMore': 'Показаны последние события; более ранние — в разделе',
  'timeline.kind.call': 'Звонок',
  'timeline.kind.email': 'Письмо',
  'timeline.kind.meeting': 'Встреча',
  'timeline.kind.task': 'Задача',
  'timeline.kind.note': 'Заметка',
  'timeline.kind.comment': 'Комментарий',
  'timeline.kind.stage': 'Стадия',
  'timeline.stage.created': 'заведена',
  'timeline.stage.backwards': 'возврат',
  'notifications.title': 'Уведомления',
  'notifications.empty': 'Уведомлений нет',
  'notifications.markRead': 'Прочитано',
  'notifications.markAllRead': 'Прочитать все · {count}',
  'notifications.live': 'Живая доставка включена',
  'notifications.offline': 'Связь потеряна: новое появится при следующем открытии',

  // Дашборды и виджеты (#77)
  'nav.dashboards': 'Дашборды',
  'dashboard.hint':
    'Дашборд собирается из сохранённых отчётов. Права проверяются от имени смотрящего: виджет поверх закрытого отчёта откажет, а не покажет чужие цифры.',
  'dashboard.select': 'Дашборд',
  'dashboard.new': 'Новый дашборд',
  'dashboard.newName': 'Название дашборда',
  'dashboard.edit': 'Настроить',
  'dashboard.done': 'Готово',
  'dashboard.delete': 'Удалить дашборд',
  'dashboard.empty': 'Виджетов пока нет — добавьте первый поверх сохранённого отчёта',
  'dashboard.defaultMark': '(по умолчанию)',
  'dashboard.isDefault': 'Показывать при входе',
  'dashboard.isShared': 'Общий дашборд',
  'dashboard.composer': 'Конструктор',
  'dashboard.widget.title': 'Заголовок',
  'dashboard.widget.report': 'Отчёт',
  'dashboard.widget.pickReport': 'Выберите отчёт',
  'dashboard.widget.type': 'Вид',
  'dashboard.widget.width': 'Ширина, колонок',
  'dashboard.widget.refresh': 'Обновлять раз в, секунд',
  'dashboard.widget.add': 'Добавить виджет',
  'dashboard.widget.remove': 'Убрать',
  'dashboard.widget.line': 'Динамика',
  'dashboard.widget.type.kpi': 'Число',
  'dashboard.widget.type.table': 'Таблица',
  'dashboard.widget.type.bar': 'Столбики',
  'dashboard.widget.type.line': 'Линия',
  'dashboard.widget.type.funnel': 'Воронка',
  'dashboard.widget.type.pie': 'Круговая',
  'dashboard.widget.type.gauge': 'Спидометр',
  'dashboard.widget.type.heatmap': 'Тепловая карта',
  // Администрирование (#97)
  'nav.section.admin': 'Администрирование',
  'nav.adminNumbering': 'Нумерация документов',
  'nav.adminThresholds': 'Пороги согласования',
  'nav.adminCurrencies': 'Валюты',
  'nav.adminUnits': 'Единицы измерения',
  'nav.adminSettings': 'Системные настройки',
  'admin.save': 'Сохранить',
  'admin.cancel': 'Отмена',
  'admin.edit': 'Изменить',
  'admin.yes': 'да',
  'admin.no': 'нет',
  'admin.numbering.hint': 'Маска действует со следующего документа. Счётчик не меняется: понижать его значит выпустить дубль. Маска, по которой номера повторятся после сброса, не сохранится.',
  'admin.numbering.documentType': 'Документ',
  'admin.numbering.mask': 'Маска',
  'admin.numbering.reset': 'Сброс счётчика',
  'admin.numbering.next': 'Следующий номер',
  'admin.numbering.notSaved': '(не сохранено)',
  'admin.numbering.preview': 'Проверить',
  'admin.numbering.reset.yearly': 'каждый год',
  'admin.numbering.reset.monthly': 'каждый месяц',
  'admin.numbering.reset.never': 'никогда',
  'admin.threshold.hint': 'Порог проверяется в момент отправки документа: правка действует со следующей отправки, уже отправленные документы не пересогласуются.',
  'admin.threshold.add': 'Добавить порог',
  'admin.threshold.form': 'Порог согласования',
  'admin.threshold.documentType': 'Документ',
  'admin.threshold.name': 'Название',
  'admin.threshold.organization': 'Организация',
  'admin.threshold.allOrganizations': 'Все организации',
  'admin.threshold.minDiscount': 'Скидка от, %',
  'admin.threshold.minAmount': 'Сумма от',
  'admin.threshold.currency': 'Валюта суммы',
  'admin.threshold.approverRole': 'Согласует роль',
  'admin.threshold.approverUser': 'Согласует пользователь',
  'admin.threshold.approver': 'Согласующий',
  'admin.threshold.step': 'Шаг',
  'admin.threshold.escalate': 'Эскалация через, ч',
  'admin.threshold.active': 'Действует',
  'admin.threshold.condition': 'Условие',
  'admin.threshold.discountFrom': 'скидка от {value}%',
  'admin.threshold.amountFrom': 'сумма от {value} {currency}',
  'admin.threshold.or': 'или',
  'admin.currency.hint': 'Код валюты после создания не меняется: на него ссылаются счета, балансы и курсы. Удаления нет по той же причине.',
  'admin.currency.add': 'Добавить валюту',
  'admin.currency.form': 'Валюта',
  'admin.currency.code': 'Код ISO',
  'admin.currency.numericCode': 'Цифровой код',
  'admin.currency.name': 'Название',
  'admin.currency.symbol': 'Символ',
  'admin.currency.minorUnits': 'Знаков после запятой',
  'admin.unit.hint': 'Код единицы не меняется: по нему находят товары импорт и интеграции. Точность — до четырёх знаков, как хранятся количества.',
  'admin.unit.add': 'Добавить единицу',
  'admin.unit.form': 'Единица измерения',
  'admin.unit.code': 'Код',
  'admin.unit.okei': 'ОКЕИ',
  'admin.unit.name': 'Название',
  'admin.unit.kind': 'Вид',
  'admin.unit.precision': 'Знаков после запятой',
  'admin.settings.hint': 'Часовой пояс, рабочее время и организация по умолчанию для всей системы.',
  'admin.settings.notApplied': 'Часовой пояс и напоминание по умолчанию действуют: по ним повторяются задачи и приходят напоминания. Рабочие часы и дни пока только сохраняются — их начнёт читать SLA (#115).',
  'admin.settings.timeZone': 'Часовой пояс',
  'admin.settings.workDayStart': 'Начало рабочего дня',
  'admin.settings.workDayEnd': 'Конец рабочего дня',
  'admin.settings.workDays': 'Рабочие дни',
  'admin.settings.defaultOrganization': 'Организация по умолчанию',
  'admin.documentType.invoice': 'Счёт',
  'admin.documentType.quote': 'Коммерческое предложение',
  'admin.documentType.contract': 'Договор',
  'admin.documentType.act': 'Акт',
  'admin.documentType.upd': 'УПД',
  'admin.documentType.torg12': 'ТОРГ-12',
  'admin.documentType.invoice_factura': 'Счёт-фактура',
  'admin.documentType.deal': 'Сделка',
  'admin.documentType.sales_order': 'Заказ клиента',
  'admin.documentType.purchase_order': 'Заказ поставщику',
  'admin.documentType.goods_receipt': 'Приёмка',
  'admin.documentType.shipment': 'Отгрузка',
  'admin.documentType.pick_task': 'Задание на сборку',
  'admin.documentType.stocktake': 'Инвентаризация',
  'admin.documentType.stock_transfer': 'Перемещение',
  'admin.documentType.stock_write_off': 'Списание',
  'admin.documentType.goods_return': 'Возврат',
  'admin.documentType.hr_order': 'Кадровый приказ',
  'admin.documentType.hr_certificate': 'Справка',
  'admin.documentType.packing_list': 'Упаковочный лист',
  'admin.documentType.revaluation': 'Переоценка',
  'admin.documentType.custody_bill': 'Счёт за хранение',
  'admin.documentType.support_ticket': 'Обращение',
  'admin.unit.kind.piece': 'Штучная',
  'admin.unit.kind.weight': 'Вес',
  'admin.unit.kind.volume': 'Объём',
  'admin.unit.kind.length': 'Длина',
  'admin.unit.kind.area': 'Площадь',
  'admin.unit.kind.time': 'Время',
  'admin.settings.day.1': 'Пн',
  'admin.settings.day.2': 'Вт',
  'admin.settings.day.3': 'Ср',
  'admin.settings.day.4': 'Чт',
  'admin.settings.day.5': 'Пт',
  'admin.settings.day.6': 'Сб',
  'admin.settings.day.7': 'Вс',
  // Контакты и участники сделки (#98)
  'nav.contacts': 'Контакты',
  'contact.add': 'Добавить контакт',
  'contact.create': 'Завести контакт',
  'contact.counterparty': 'Контрагент',
  'contact.deals.title': 'Сделки',
  'contact.deals.empty': 'Контакт не участвует в видимых вам сделках',
  'participant.title': 'Участники',
  'participant.empty': 'Участников пока нет — неизвестно, с кем ведётся сделка',
  'participant.role': 'Роль',
  'participant.primary': 'основной',
  'participant.remove': 'Убрать',
  'participant.add': 'Добавить участника',
  'participant.contact': 'Контакт',
  'participant.chooseContact': 'Выберите контакт контрагента',
  'participant.deleted': 'контакт удалён',
  'participant.noCounterparty': 'У сделки не указан контрагент — участников выбирать не из кого',
  'participant.role.decision_maker': 'Принимает решение',
  'participant.role.economic_buyer': 'Распоряжается бюджетом',
  'participant.role.technical': 'Технический специалист',
  'participant.role.user': 'Пользователь',
  'participant.role.accountant': 'Бухгалтер',
  'participant.role.other': 'Другое',
  'column.job_title': 'Должность',
  'column.mobile_phone': 'Мобильный телефон',
  'column.telegram': 'Telegram',
  'column.is_primary': 'Основной контакт',
  'deal.status.open': 'В работе',
  'deal.status.won': 'Выиграна',
  'deal.status.lost': 'Проиграна',

  'column.legal_name': 'Полное наименование',
  'column.ogrn': 'ОГРН',
  'column.okpo': 'ОКПО',
  'column.legal_address': 'Юридический адрес',
  'column.actual_address': 'Фактический адрес',
  'column.website': 'Сайт',
  'column.payment_terms_days': 'Отсрочка платежа, дн.',
  'column.version': 'Версия',
  'card.section.addresses': 'Адреса',
  'card.section.person': 'Физическое лицо',
  'card.cp.consent': 'Получено согласие на обработку персональных данных',
  'merge.tab': 'Дубли',
  'merge.hint': 'Похожие карточки по ИНН, телефону и почте. Слияние переносит всё в эту карточку, а дубль удаляет.',
  'merge.start': 'Слить сюда',
  'merge.preview': 'Предпросмотр слияния',
  'merge.into': '«{duplicate}» будет слит в «{survivor}» и удалён.',
  'merge.blocked': 'Слить нельзя, пока у дубля есть:',
  'merge.moves': 'Переедет в эту карточку:',
  'merge.nothingMoves': 'У дубля нет связанных записей.',
  'merge.confirm': 'Слить',
  'merge.done': '«{name}» слит в эту карточку',
  'merge.ref.contact.counterparty_id': 'Контактные лица',
  'merge.ref.counterparty_bank_account.counterparty_id': 'Банковские счета',
  'merge.ref.deal.counterparty_id': 'Сделки',
  'merge.ref.quote.counterparty_id': 'Коммерческие предложения',
  'merge.ref.activity.counterparty_id': 'Активности',
  'merge.ref.lead.converted_counterparty_id': 'Лиды',
  'merge.ref.support_ticket.counterparty_id': 'Обращения',
  'merge.ref.client_access_request.counterparty_id': 'Заявки на доступ в кабинет',
  'merge.ref.app_user.counterparty_id': 'Учётные записи кабинета',
  'merge.ref.invoice.counterparty_id': 'Счета',
  'merge.ref.customer_balance.counterparty_id': 'Остаток переплаты',
  'merge.ref.contract.counterparty_id': 'Договоры',
  'merge.ref.recurring_invoice.counterparty_id': 'Регулярные счета',
  'merge.ref.primary_document.counterparty_id': 'Первичные документы',
  'merge.ref.payment.counterparty_id': 'Платежи',
  'merge.ref.payment_intent.counterparty_id': 'Онлайн-оплаты',
  'merge.ref.bank_payment_order.counterparty_id': 'Платёжные поручения',
  'merge.ref.cash_ledger_entry.counterparty_id': 'Кассовые операции',
  'merge.ref.sales_order.counterparty_id': 'Заказы',
  'merge.ref.shipment.counterparty_id': 'Отгрузки',
  'merge.ref.goods_return.counterparty_id': 'Возвраты',
  'merge.ref.purchase_order.supplier_id': 'Заказы поставщику',
  'merge.ref.goods_receipt.supplier_id': 'Приёмки',
  'merge.ref.product_batch.supplier_counterparty_id': 'Партии товара',
  'merge.ref.serial_number.shipped_to_counterparty_id': 'Отгруженные серийные номера',
  'merge.ref.stock.owner_counterparty_id': 'Товар на ответственном хранении',
  'merge.ref.storage_zone.owner_counterparty_id': 'Зоны хранения',
  'merge.ref.cost_layer.owner_counterparty_id': 'Слои себестоимости',
  'merge.ref.custody_tariff.owner_counterparty_id': 'Тарифы хранения',
  'merge.ref.custody_daily_snapshot.owner_counterparty_id': 'Срезы хранения',
  'merge.ref.custody_billing_record.owner_counterparty_id': 'Начисления за хранение',
  'merge.ref.activity.entity_id': 'Записи ленты',
  'merge.ref.entity_comment.entity_id': 'Комментарии',
  'merge.ref.attachment.entity_id': 'Вложения',
  'merge.ref.notification.entity_id': 'Уведомления',
  'merge.ref.onec_link.local_id': 'Связь с 1С',
  'deal.create': 'Новая сделка',
  'deal.create.title': 'Новая сделка',
  'deal.create.submit': 'Завести',
  'deal.close.lost': 'Сделка проиграна',
  'deal.close.won': 'Сделка выиграна',
  'deal.close.reason': 'Причина',
  'deal.close.choose': '— выберите причину —',
  'deal.close.noReason': '— без причины —',
  'deal.close.note': 'Комментарий',
  'deal.close.confirm': 'Закрыть сделку',
  'deal.line.add': 'Добавить позицию',
  'deal.line.remove': 'Удалить',
  'deal.line.priceFromList': 'по прайс-листу',
  'deal.actions.stage': 'Стадия',
  'deal.delete': 'Удалить сделку',
  'deal.delete.confirm': 'Удалить сделку безвозвратно?',
  'card.tab.dealActions': 'Действия',
  'picker.search': 'Начните вводить название',
  'picker.nothing': 'ничего не найдено',
  'picker.results': 'Найденные записи',
  'picker.clear': 'Убрать выбор',
  'nav.adminDealReasons': 'Причины закрытия сделок',
  'nav.adminFunnels': 'Воронки и этапы',
  'nav.adminLeadRules': 'Распределение лидов',
  'nav.adminAudit': 'Журнал аудита',
  'nav.adminTags': 'Теги',
  'nav.adminCustomFields': 'Пользовательские поля',
  'admin.dealReason.hint': 'Причина проигрыша выбирается при закрытии сделки и попадает в отчёт о причинах. Вид и код не меняются; удаления нет — причину выводят из употребления.',
  'admin.dealReason.add': 'Добавить причину',
  'admin.dealReason.form': 'Причина закрытия',
  'admin.dealReason.kind': 'Вид',
  'admin.dealReason.kind.lost': 'Проигрыш',
  'admin.dealReason.kind.won': 'Выигрыш',
  'admin.dealReason.code': 'Код',
  'admin.dealReason.name': 'Название',
  'admin.dealReason.sortOrder': 'Порядок',
  'admin.dealReason.active': 'Действует',
  'admin.funnel.hint': 'Этапы воронки — колонки доски сделок. Изменения видны менеджерам сразу, без релиза. Открытые этапы переставляются перетаскиванием или стрелками; закрывающие всегда в конце. Этап, на котором есть сделки или через который они проходили, удалить нельзя — его переименовывают.',
  'admin.funnel.choose': 'Воронка',
  'admin.funnel.add': 'Добавить воронку',
  'admin.funnel.form': 'Новая воронка',
  'admin.funnel.props': 'Свойства воронки',
  'admin.funnel.code': 'Код',
  'admin.funnel.name': 'Название',
  'admin.funnel.default': 'основная',
  'admin.funnel.active': 'Действует',
  'admin.funnel.inactive': 'отключена',
  'admin.funnel.stages': 'Этапы воронки',
  'admin.funnel.createHint': 'Воронка создаётся с этапами «Новая», «Успешно закрыта» и «Закрыта и не реализована»; остальные добавьте после.',
  'admin.stage.name': 'Этап',
  'admin.stage.code': 'Код',
  'admin.stage.type': 'Тип',
  'admin.stage.type.open': 'открытый',
  'admin.stage.type.won': 'выигрыш',
  'admin.stage.type.lost': 'проигрыш',
  'admin.stage.probability': 'Вероятность, %',
  'admin.stage.sla': 'Срок на этапе, дней',
  'admin.stage.noSla': 'без срока',
  'admin.stage.color': 'Цвет',
  'admin.stage.openDeals': 'Открытых сделок',
  'admin.stage.up': 'Выше',
  'admin.stage.down': 'Ниже',
  'admin.stage.remove': 'Удалить',
  'admin.stage.hasDeals': 'На этапе есть сделки — удалить нельзя',
  'admin.stage.add': 'Добавить этап',
  'admin.stage.form': 'Этап',
  'admin.stage.addForm': 'Новый этап',
  'admin.stage.position': 'Место',
  'admin.stage.first': 'Первым',
  'admin.stage.after': 'После «{name}»',
  'admin.rule.hint': 'Правила применяются по возрастанию приоритета; первое подошедшее назначает ответственного. Правило без условий забирает все лиды. По кругу сотрудники идут в указанном порядке.',
  'admin.rule.add': 'Добавить правило',
  'admin.rule.form': 'Правило распределения',
  'admin.rule.name': 'Название',
  'admin.rule.strategy': 'Стратегия',
  'admin.rule.strategy.round_robin': 'По кругу',
  'admin.rule.strategy.by_load': 'По загрузке',
  'admin.rule.strategy.by_region': 'По территории',
  'admin.rule.strategy.manual': 'Вручную',
  'admin.rule.priority': 'Приоритет',
  'admin.rule.conditions': 'Условия',
  'admin.rule.anyLead': 'любой лид',
  'admin.rule.anySource': 'любой',
  'admin.rule.field.source': 'Источник',
  'admin.rule.field.utmSource': 'utm_source',
  'admin.rule.field.utmCampaign': 'utm_campaign',
  'admin.rule.field.companyName': 'Компания',
  'admin.rule.department': 'Отдел',
  'admin.rule.employees': 'Сотрудники',
  'admin.rule.removeEmployee': 'Убрать',
  'admin.rule.active': 'Действует',
  'admin.rule.delete': 'Удалить',
  'history.empty': 'Изменений не записано',
  'history.more': 'Показать ещё',
  'history.table': 'Журнал изменений',
  'history.when': 'Когда',
  'history.who': 'Кто',
  'history.entity': 'Запись',
  'history.action': 'Действие',
  'history.changes': 'Что изменилось',
  'history.system': 'система',
  'history.hidden': 'скрыто — нет права на поле',
  'history.action.INSERT': 'создание',
  'history.action.UPDATE': 'изменение',
  'history.action.DELETE': 'удаление',
  'history.action.PERMISSIONS': 'права роли',
  'audit.hint': 'Все изменения в системе: кто, когда, что было и что стало. Значения полей без полевого права скрыты и здесь.',
  'audit.filters': 'Фильтры журнала',
  'audit.actor': 'Пользователь',
  'audit.entityType': 'Сущность',
  'audit.action': 'Действие',
  'audit.from': 'С',
  'audit.to': 'По',
  'audit.any': 'любое',
  'audit.apply': 'Показать',
  'audit.reset': 'Сбросить',
  'audit.empty': 'По этим условиям изменений нет',
  'tags.input': 'Тег',
  'tags.add': 'Пометить тегом',
  'tags.remove': 'Снять тег',
  'tags.added': 'Тег «{tag}» поставлен: {affected} из {requested}',
  'tags.removed': 'Тег «{tag}» снят: {affected} из {requested}',
  'segments.title': 'Сегменты',
  'segments.apply': 'Показать сегмент',
  'segments.delete': 'Удалить сегмент',
  'segments.form': 'Новый сегмент',
  'segments.name': 'Название сегмента',
  'segments.shared': 'Общий',
  'segments.save': 'Сохранить',
  'segments.saveCurrent': 'Сохранить фильтр как сегмент',
  'segments.saveAll': 'Сохранить сегмент «все записи»',
  'history.action.TAGS': 'теги',
  'admin.tags.hint': 'Теги заводят менеджеры прямо из списка. Здесь — переименование, цвет и удаление: удалённый тег снимается со всех записей и меняет все сегменты по нему.',
  'admin.tags.name': 'Тег',
  'admin.tags.color': 'Цвет',
  'admin.tags.delete': 'Удалить',
  'card.tab.customFields': 'Доп. поля',
  'customFields.none': 'Дополнительных полей у этой сущности нет',
  'customFields.form': 'Дополнительные поля',
  'customFields.save': 'Сохранить поля',
  'customFields.saved': 'Поля сохранены',
  'customFields.hint': 'Поле появляется на карточках, в колонках и фильтрах списка сразу, без релиза. Код — ключ в базе и имя колонки, его не меняют; удаления нет, есть скрытие — значения остаются.',
  'customFields.entity': 'Сущность',
  'customFields.add': 'Добавить поле',
  'customFields.declare': 'Новое поле',
  'customFields.label': 'Название',
  'customFields.code': 'Код',
  'customFields.type': 'Тип',
  'customFields.type.string': 'строка',
  'customFields.type.number': 'число',
  'customFields.type.date': 'дата',
  'customFields.type.boolean': 'да/нет',
  'customFields.type.enum': 'список выбора',
  'customFields.type.reference': 'ссылка',
  'customFields.type.file': 'файл',
  'customFields.options': 'Варианты (по одному в строке)',
  'customFields.required': 'Обязательное',
  'customFields.order': 'Порядок',
  'customFields.hide': 'Скрыть',
  'deal.create.responsibleMe': 'пусто — ответственным будете вы',
  'picker.failed': 'поиск недоступен',
  'column.source': 'Источник',
  'column.rejection_reason': 'Причина отказа',
  'column.contact_name': 'Контактное лицо',
  'column.company_name': 'Компания',
  'column.first_response_due_at': 'Ответить до',
  'column.first_response_at': 'Первый ответ',
  'column.utm_campaign': 'UTM campaign',
  'column.converted_at': 'Сконвертирован',
  'column.converted_deal_id': 'Сделка',
  'card.section.leadSla': 'Ответственный и сроки',
  'card.section.leadChannel': 'Канал привлечения',
  'card.tab.leadActions': 'Действия',
  'lead.status.new': 'Новый',
  'lead.status.in_progress': 'В работе',
  'lead.status.qualified': 'Квалифицирован',
  'lead.status.converted': 'Сконвертирован',
  'lead.status.rejected': 'Отклонён',
  'lead.source.call': 'Звонок',
  'lead.source.email': 'Письмо',
  'lead.source.website': 'Сайт',
  'lead.source.telegram': 'Telegram',
  'lead.source.referral': 'Рекомендация',
  'lead.source.exhibition': 'Выставка',
  'lead.source.other': 'Другое',
  'lead.actions.status': 'Статус',
  'lead.actions.convert': 'Конвертировать в сделку',
  'lead.actions.qualify': 'Квалифицировать',
  'lead.actions.reject': 'Отклонить',
  'lead.actions.rejectReason': 'Причина отказа',
  'lead.actions.rejectConfirm': 'Отклонить лид',
  'lead.actions.openDeal': 'Открыть сделку',
  'lead.actions.rejectedBecause': 'Отклонён: {reason}',
  'lead.create.title': 'Новый лид',
  'lead.create.submit': 'Завести',
  'lead.create.needContact': 'нужен телефон, почта или ИНН',
  'nav.adminUsers': 'Пользователи',
  'nav.adminRoles': 'Роли и права',
  'admin.users.hint': 'Учётные записи, их сотрудники и роли. Права применяются со следующего запроса пользователя. Пароля здесь нет — вход через Keycloak.',
  'admin.users.search': 'Поиск по логину, ФИО, почте',
  'admin.users.add': 'Добавить пользователя',
  'admin.users.form': 'Новый пользователь',
  'admin.users.username': 'Логин',
  'admin.users.fullName': 'ФИО',
  'admin.users.email': 'Почта',
  'admin.users.employee': 'Сотрудник',
  'admin.users.noEmployee': 'не привязан — «свои» записи у него пусты',
  'admin.users.roles': 'Роли',
  'admin.users.state': 'Состояние',
  'admin.users.notLinked': '(ещё не входил)',
  'admin.users.expired': 'истекла',
  'admin.users.until': 'до {date}',
  'admin.users.until.label': 'До',
  'admin.users.revoke': 'Снять роль',
  'admin.users.assign': 'Выдать',
  'admin.users.chooseRole': '— роль —',
  'admin.users.active': 'Активен',
  'admin.users.blocked': 'Заблокирован',
  'admin.users.block': 'Заблокировать',
  'admin.users.unblock': 'Разблокировать',
  'admin.roles.hint': 'Роли наследуют права предков. Унаследованное снимается только у предка. Права суперадмина не правятся.',
  'admin.roles.add': 'Добавить роль',
  'admin.roles.form': 'Новая роль',
  'admin.roles.code': 'Код',
  'admin.roles.name': 'Название',
  'admin.roles.parent': 'Наследует от',
  'admin.roles.noParent': '— без предка —',
  'admin.roles.holders': 'Держателей',
  'admin.roles.system': 'встроенная',
  'admin.roles.matrix': 'Права',
  'admin.roles.delete': 'Удалить',
  'admin.roles.matrixOf': 'Права роли «{role}»',
  'admin.roles.readOnly': 'Только просмотр',
  'admin.roles.superadminLocked': 'Права суперадмина не правятся: снятое право было бы некому вернуть.',
  'admin.roles.saved': 'Права сохранены',
  'admin.roles.resource': 'Ресурс',
  'admin.roles.action': 'Действие',
  'admin.roles.field': 'Поле',
  'admin.roles.scope': 'Область',
  'admin.roles.inherited': 'Унаследовано',
  'admin.scope.own': 'свои',
  'admin.scope.department': 'отдела',
  'admin.scope.all': 'все',
  'admin.users.unbind': 'Отвязать',

  // Подписи колонок механизма списков, которых не хватало (ListCatalog).
  'column.approved_at': 'Утверждено',
  'column.approved_by': 'Утвердил',
  'column.assignee_employee_id': 'Исполнитель',
  'column.batch_id': 'Партия',
  'column.cancel_reason': 'Причина отмены',
  'column.cancelled_at': 'Отменено',
  'column.carrier': 'Перевозчик',
  'column.cell_id': 'Ячейка',
  'column.completed_at': 'Завершено',
  'column.contract_id': 'Договор',
  'column.contract_type': 'Вид договора',
  'column.converted_counterparty_id': 'Контрагент из лида',
  'column.deal_id': 'Сделка',
  'column.delivered_at': 'Доставлено',
  'column.delivery_address': 'Адрес доставки',
  'column.discount_total': 'Скидка',
  'column.dispatched_at': 'Отправлено',
  'column.document_date': 'Дата документа',
  'column.document_kind': 'Вид документа',
  'column.edi_sent_at': 'Отправлен в ЭДО',
  'column.edi_status': 'Статус ЭДО',
  'column.from_warehouse_id': 'Склад-отправитель',
  'column.gross_weight_kg': 'Брутто, кг',
  'column.handed_over_at': 'Передано перевозчику',
  'column.handling_unit_id': 'Грузовая единица',
  'column.invoice_id': 'Счёт',
  'column.is_blind': 'Слепой пересчёт',
  'column.is_cross_dock': 'Кросс-докинг',
  'column.method': 'Способ оплаты',
  'column.net_weight_kg': 'Нетто, кг',
  'column.order_id': 'Заказ',
  'column.owner_counterparty_id': 'Владелец товара',
  'column.packages_count': 'Мест',
  'column.paid_at': 'Дата оплаты',
  'column.paid_total': 'Оплачено',
  'column.pick_mode': 'Режим отбора',
  'column.posted_at': 'Проведено',
  'column.primary_document_id': 'Первичный документ',
  'column.purchase_order_id': 'Заказ поставщику',
  'column.purpose': 'Назначение платежа',
  'column.received_at': 'Принято',
  'column.received_by': 'Принял',
  'column.reserved_quantity': 'В резерве',
  'column.scope': 'Охват',
  'column.sent_at': 'Отправлено',
  'column.shipment_id': 'Отгрузка',
  'column.shipped_at': 'Отгружено',
  'column.signed_at': 'Подписано',
  'column.signed_on': 'Дата подписания',
  'column.started_at': 'Начато',
  'column.subtotal': 'Сумма без скидки',
  'column.supplier_document_number': 'Номер документа поставщика',
  'column.to_warehouse_id': 'Склад-получатель',
  'column.total': 'Итого',
  'column.tracking_number': 'Трек-номер',
  'column.unit_cost': 'Себестоимость единицы',
  'column.updated_at': 'Изменено',
  'column.valid_from': 'Действует с',
  'column.valid_until': 'Действует до',
  'column.vat_total': 'НДС',
  'column.volume_m3': 'Объём, м³',
  'column.zone_id': 'Зона',

  // Значения перечислений: value.<сущность каталога>.<колонка>.<код>.
  // Ключ по сущности, а не по колонке: в русском род (лид «Новый», сделка «Открыта»).
  'value.sales.counterparty.kind.legal': 'Юридическое лицо',
  'value.sales.counterparty.kind.individual': 'Физическое лицо',
  'value.sales.counterparty.kind.sole_trader': 'ИП',
  'value.sales.counterparty.relation.client': 'Клиент',
  'value.sales.counterparty.relation.supplier': 'Поставщик',
  'value.sales.counterparty.relation.both': 'Клиент и поставщик',
  'value.sales.counterparty.relation.competitor': 'Конкурент',
  'value.sales.counterparty.relation.partner': 'Партнёр',
  'value.sales.deal.status.open': 'Открыта',
  'value.sales.deal.status.won': 'Выиграна',
  'value.sales.deal.status.lost': 'Проиграна',
  'value.sales.product.product_type.goods': 'Товар',
  'value.sales.product.product_type.service': 'Услуга',
  'value.sales.product.product_type.kit': 'Комплект',
  'value.sales.product.product_type.weight_goods': 'Весовой товар',
  'value.sales.lead.status.new': 'Новый',
  'value.sales.lead.status.in_progress': 'В работе',
  'value.sales.lead.status.qualified': 'Квалифицирован',
  'value.sales.lead.status.converted': 'Конвертирован',
  'value.sales.lead.status.rejected': 'Отклонён',
  'value.sales.lead.source.website': 'Сайт',
  'value.sales.lead.source.call': 'Звонок',
  'value.sales.lead.source.email': 'Письмо',
  'value.sales.lead.source.telegram': 'Telegram',
  'value.sales.lead.source.referral': 'Рекомендация',
  'value.sales.lead.source.exhibition': 'Выставка',
  'value.sales.lead.source.other': 'Другое',
  'value.sales.quote.status.draft': 'Черновик',
  'value.sales.quote.status.sent': 'Отправлено',
  'value.sales.quote.status.accepted': 'Принято',
  'value.sales.quote.status.rejected': 'Отклонено',
  'value.sales.quote.status.expired': 'Истекло',
  'value.billing.invoice.status.draft': 'Черновик',
  'value.billing.invoice.status.sent': 'Отправлен',
  'value.billing.invoice.status.partially_paid': 'Частично оплачен',
  'value.billing.invoice.status.paid': 'Оплачен',
  'value.billing.invoice.status.overdue': 'Просрочен',
  'value.billing.invoice.status.cancelled': 'Отменён',
  'value.billing.document.document_kind.act': 'Акт',
  'value.billing.document.document_kind.upd': 'УПД',
  'value.billing.document.document_kind.torg12': 'ТОРГ-12',
  'value.billing.document.document_kind.invoice_factura': 'Счёт-фактура',
  'value.billing.document.status.draft': 'Черновик',
  'value.billing.document.status.issued': 'Выставлен',
  'value.billing.document.status.signed': 'Подписан',
  'value.billing.document.status.cancelled': 'Аннулирован',
  'value.billing.document.edi_status.sent': 'Отправлен',
  'value.billing.contract.contract_type.sale': 'Продажа',
  'value.billing.contract.contract_type.purchase': 'Закупка',
  'value.billing.contract.contract_type.service': 'Услуги',
  'value.billing.contract.contract_type.storage': 'Хранение',
  'value.billing.contract.contract_type.agency': 'Агентский',
  'value.billing.contract.status.draft': 'Черновик',
  'value.billing.contract.status.active': 'Действует',
  'value.billing.contract.status.expired': 'Истёк',
  'value.billing.contract.status.terminated': 'Расторгнут',
  'value.warehouse.receipt.status.draft': 'Черновик',
  'value.warehouse.receipt.status.in_progress': 'В работе',
  'value.warehouse.receipt.status.completed': 'Завершена',
  'value.warehouse.receipt.status.cancelled': 'Отменена',
  'value.warehouse.shipment.status.draft': 'Черновик',
  'value.warehouse.shipment.status.packed': 'Упакована',
  'value.warehouse.shipment.status.shipped': 'Отгружена',
  'value.warehouse.shipment.status.in_transit': 'В пути',
  'value.warehouse.shipment.status.delivered': 'Доставлена',
  'value.warehouse.shipment.status.returned': 'Возвращена',
  'value.warehouse.pick.pick_mode.single': 'По заказу',
  'value.warehouse.pick.pick_mode.wave': 'Волной',
  'value.warehouse.pick.status.new': 'Новое',
  'value.warehouse.pick.status.assigned': 'Назначено',
  'value.warehouse.pick.status.in_progress': 'В работе',
  'value.warehouse.pick.status.completed': 'Завершено',
  'value.warehouse.pick.status.cancelled': 'Отменено',
  'value.warehouse.stocktake.scope.full': 'Весь склад',
  'value.warehouse.stocktake.scope.zone': 'Зона',
  'value.warehouse.stocktake.scope.cell': 'Ячейка',
  'value.warehouse.stocktake.scope.product': 'Товар',
  'value.warehouse.stocktake.status.draft': 'Черновик',
  'value.warehouse.stocktake.status.in_progress': 'В работе',
  'value.warehouse.stocktake.status.counted': 'Посчитана',
  'value.warehouse.stocktake.status.approved': 'Утверждена',
  'value.warehouse.stocktake.status.cancelled': 'Отменена',
  'value.warehouse.transfer.status.draft': 'Черновик',
  'value.warehouse.transfer.status.in_transit': 'В пути',
  'value.warehouse.transfer.status.received': 'Принято',
  'value.warehouse.transfer.status.cancelled': 'Отменено',
  'value.hr.employee.status.active': 'Работает',
  'value.hr.employee.status.probation': 'Испытательный срок',
  'value.hr.employee.status.on_leave': 'В отпуске',
  'value.hr.employee.status.terminated': 'Уволен',
  'value.hr.employee.gender.M': 'Мужской',
  'value.hr.employee.gender.F': 'Женский',
  'value.hr.vacancy.status.draft': 'Черновик',
  'value.hr.vacancy.status.open': 'Открыта',
  'value.hr.vacancy.status.on_hold': 'Приостановлена',
  'value.hr.vacancy.status.closed': 'Закрыта',
  'value.hr.vacancy.status.cancelled': 'Отменена',
  'value.hr.leave.leave_type.annual': 'Ежегодный отпуск',
  'value.hr.leave.leave_type.unpaid': 'За свой счёт',
  'value.hr.leave.leave_type.sick': 'Больничный',
  'value.hr.leave.leave_type.maternity': 'По уходу за ребёнком',
  'value.hr.leave.leave_type.study': 'Учебный отпуск',
  'value.hr.leave.leave_type.day_off': 'Отгул',
  'value.hr.leave.status.draft': 'Черновик',
  'value.hr.leave.status.pending': 'На согласовании',
  'value.hr.leave.status.approved': 'Согласована',
  'value.hr.leave.status.rejected': 'Отклонена',
  'value.hr.leave.status.cancelled': 'Отменена',
  'value.payments.payment.direction.incoming': 'Входящий',
  'value.payments.payment.direction.outgoing': 'Исходящий',
  'value.payments.payment.method.bank_transfer': 'Банковский перевод',
  'value.payments.payment.method.acquiring': 'Эквайринг',
  'value.payments.payment.method.sbp': 'СБП',
  'value.payments.payment.method.cash': 'Наличные',
  'value.payments.payment.method.offset': 'Взаимозачёт',
  'value.payments.payment.method.deposit': 'С депозита',
  'value.payments.payment.status.pending': 'Ожидает',
  'value.payments.payment.status.confirmed': 'Подтверждён',
  'value.payments.payment.status.matched': 'Разнесён',
  'value.payments.payment.status.reversed': 'Сторнирован',
  // board (#board-paging)
  'board.showMore': 'Показать ещё (осталось {count})',
  // card (design)
  // myday & dashboard (design)
  'nav.myDay': 'Мой день',
  // lists & kanban (design)
  'quick.label': 'Быстрые фильтры',
  'quick.token': 'Быстрый',
  'nav.support': 'Обращения',
  'column.subject': 'Тема',
  'column.assigned_user_id': 'Исполнитель',
  'column.first_answer_at': 'Первый ответ',
  'column.resolved_at': 'Решено',
  'column.rating': 'Оценка',
  'value.support.ticket.status.open': 'Ждёт ответа',
  'value.support.ticket.status.answered': 'Отвечено',
  'value.support.ticket.status.resolved': 'Решено',
  'value.support.ticket.status.closed': 'Закрыто',
  'value.support.ticket.kind.question': 'Вопрос',
  'value.support.ticket.kind.claim': 'Претензия',
  'value.support.ticket.kind.request': 'Заявка',
  'value.support.ticket.source.cabinet': 'Из кабинета',
  'value.support.ticket.source.email': 'Из почты',
  'value.support.ticket.source.manual': 'Заведено менеджером',
  'value.support.ticket.source.messenger': 'Из мессенджера',
  'quick.ticketWaiting': 'Ждут ответа',
  'quick.ticketUnassigned': 'Без исполнителя',
  'quick.slaBreached': 'Просрочен ответ',
  'notifications.kind.ticket': 'Обращения клиентов',
  'notifications.kind.message': 'Сообщения клиентов в мессенджерах',
  'inbox.toTicket': 'Создать обращение',
  'support.sections': 'Разделы обращения',
  'support.conversation': 'Переписка с клиентом и заметки',
  'support.tab.conversation': 'Переписка',
  'support.entry.client': 'Клиент',
  'support.entry.manager': 'Ответ клиенту',
  'support.entry.note': 'Заметка — видно только сотрудникам',
  'support.reply.title': 'Ответить',
  'support.reply.mode': 'Что пишем',
  'support.reply.answer': 'Ответ клиенту',
  'support.reply.note': 'Внутренняя заметка',
  'support.reply.answerHint': 'Клиент увидит это в приложении и получит уведомление',
  'support.reply.noteHint': 'Клиент заметку не увидит',
  'support.reply.send': 'Отправить клиенту',
  'support.reply.saveNote': 'Сохранить заметку',
  'support.reply.closed': 'Обращение не открыто: чтобы ответить, откройте его заново',
  'support.action.resolved': 'Решено',
  'support.action.closed': 'Закрыть',
  'support.action.open': 'Открыть заново',
  'support.fact.client': 'Клиент',
  'support.fact.sla': 'Ответить до',
  'support.sla.breached': 'Срок ответа прошёл',
  'support.sla.waiting': 'Ответа ещё не было',
  'support.sla.met': 'Ответили в срок',
  'support.sla.late': 'Ответили с опозданием',
  'support.unassigned': 'Не назначено',
  'support.assign.label': 'Кто ведёт обращение',
  'support.rating': 'Оценка клиента',
  // Разбор обращений ИИ (#132)
  'column.urgent': 'Срочно',
  'column.triage_category': 'Категория',
  'column.triage_tone': 'Тональность',
  'column.triage_urgency': 'Срочность по тексту',
  'value.support.ticket.triage_category.question': 'Вопрос',
  'value.support.ticket.triage_category.claim': 'Претензия',
  'value.support.ticket.triage_category.request': 'Заявка',
  'value.support.ticket.triage_category.return': 'Возврат',
  'value.support.ticket.triage_category.technical': 'Техническая проблема',
  'value.support.ticket.triage_category.billing': 'Счета и оплата',
  'value.support.ticket.triage_category.other': 'Другое',
  'value.support.ticket.triage_tone.neutral': 'Нейтральная',
  'value.support.ticket.triage_tone.dissatisfied': 'Недовольная',
  'value.support.ticket.triage_tone.harsh': 'Резкая',
  'value.support.ticket.triage_urgency.normal': 'Обычная',
  'value.support.ticket.triage_urgency.urgent': 'Срочно',
  'quick.ticketUrgent': 'Срочные',
  'quick.ticketClaims': 'Претензии',
  'support.urgent': 'Срочно',
  'support.urgent.set': 'Пометить срочным',
  'support.urgent.clear': 'Снять пометку «срочно»',
  'support.triage.title': 'Разбор ИИ',
  'support.triage.category': 'Категория',
  'support.triage.tone': 'Тональность',
  'support.triage.urgency': 'Срочность по тексту',
  'support.triage.reason': 'Почему',
  'support.triage.rule': 'Сработало правило',
  'support.triage.kindMismatch': 'Клиент указал «{kind}», по тексту — «{category}»',
  'support.triage.pending': 'Обращение ещё не разобрано: разбор идёт после приёма, обычно за минуту.',
  'support.triage.unavailable': 'Не разобрано: {message}. Обращение идёт обычным путём.',
  'support.triage.failed': 'Не разобрано: провайдер ИИ не ответил ({message}). Повторим автоматически.',
  'support.triage.rejected': 'Не разобрано: ответ модели не по справочнику ({message}). Категория не выдумывается.',
  'support.triage.no_text': 'Не разобрано: в обращении нет текста клиента.',
  'support.triage.stale': 'Последняя реплика клиента не разобрана ({message}); показан разбор предыдущего текста.',
  'nav.supportInsights': 'Сводка по обращениям',
  'nav.adminSupportRouting': 'Маршрутизация обращений',
  'insights.title': 'Сводка по обращениям',
  'insights.intro': 'Темы — категории разбора ИИ; всплеск — категория, в которой обращений не меньше {min} и в {ratio} раза больше, чем за предыдущий период той же длины. Считаются только обращения, которые вам видны.',
  'insights.from': 'С',
  'insights.to': 'По',
  'insights.apply': 'Показать',
  'insights.total': 'Обращений за период',
  'insights.previous': 'За предыдущий период ({from} — {to})',
  'insights.unread': 'Не разобрано ИИ',
  'insights.urgentCount': 'Помечено «срочно»',
  'insights.tones': 'Тональность',
  'insights.themes': 'Темы',
  'insights.col.category': 'Категория',
  'insights.col.count': 'Обращений',
  'insights.col.previous': 'Было',
  'insights.col.share': 'Доля',
  'insights.col.harsh': 'Резких',
  'insights.col.urgent': 'Срочных',
  'insights.spike': 'Всплеск',
  'insights.spikes': 'Всплески: {list}',
  'insights.noSpikes': 'Всплесков нет',
  'insights.empty': 'За период обращений нет',
  'routing.title': 'Маршрутизация обращений',
  'routing.intro': 'Правило срабатывает после разбора обращения ИИ: первое подходящее по приоритету. Неразобранное обращение (ИИ выключен) не совпадает ни с одним правилом и остаётся у ответственного за клиента. Исполнителя, назначенного человеком, и обращение, на которое уже ответили, правило не переназначает — только помечает «срочно».',
  'routing.empty': 'Правил нет — обращения распределяются ответственному за клиента',
  'routing.add': 'Добавить правило',
  'routing.edit': 'Изменить',
  'routing.delete': 'Удалить',
  'routing.save': 'Сохранить',
  'routing.cancel': 'Отмена',
  'routing.name': 'Название',
  'routing.priority': 'Приоритет (меньше — раньше)',
  'routing.active': 'Включено',
  'routing.inactive': 'Выключено',
  'routing.categories': 'Категории',
  'routing.tones': 'Тональность',
  'routing.urgencies': 'Срочность по тексту',
  'routing.any': 'любая',
  'routing.assign': 'Кому',
  'routing.mode.user': 'Сотруднику',
  'routing.mode.department_head': 'Руководителю отдела ответственного',
  'routing.mode.keep': 'Не менять исполнителя',
  'routing.user': 'Сотрудник',
  'routing.markUrgent': 'Пометить «срочно»',
  'routing.conditions': 'Условия',
  'routing.actions': 'Действие',
  'quick.mine': 'Мои',
  'quick.open': 'Открытые',
  'quick.overdue': 'Просроченные',
  'quick.newLeads': 'Новые',
  'quick.unpaid': 'Неоплаченные',
  'quick.reserved': 'Есть резерв',
  'quick.zeroStock': 'Нулевой остаток',
  'list.toolbar': 'Инструменты списка',
  'list.count': '{count} записей',
  'list.rows': '{count} строк',
  'list.searchIn': 'Поиск: {column}',
  'list.groupByValue': 'Группировка: {column}',
  'list.moreActions': 'Ещё: выгрузка, импорт, сегменты',
  'list.importMenu': 'Импорт из CSV…',
  'list.segmentsMenu': 'Сегменты…',
  'list.closePanel': 'Закрыть панель',
  'list.retry': 'Повторить',
  'list.groupEmpty': 'Не заполнено',
  'list.groupExpand': 'Развернуть группу {group}',
  'list.groupCollapse': 'Свернуть группу {group}',
  'list.groupCount': 'позиций: {count}',
  'list.groupsCapped': 'Показаны первые {shown} групп — сузьте фильтр, чтобы увидеть остальные',
  'list.state.forbidden': 'Раздел «{section}» вам недоступен',
  'list.state.error': 'Список не загрузился',
  'list.state.errorHint': 'Сервер не ответил. Не принимайте решения по старым цифрам — повторите запрос.',
  'list.state.noMatch': 'По условиям ничего не найдено',
  'list.state.noMatchHint': 'Условия применены на сервере ко всему списку, а не к странице. Снимите лишние или сбросьте все.',
  'list.state.empty': 'Записей пока нет',
  'list.state.emptyHint': 'Здесь появятся записи, как только их заведут или импортируют.',
  'state.kind.empty': 'Нет данных',
  'state.kind.forbidden': 'Нет доступа',
  'state.kind.setup': 'Не настроено',
  'state.kind.error': 'Ошибка',
  'record.crumbs': 'Путь',
  'record.more': 'Ещё действия',
  'record.tabs': 'Разделы записи',
  'record.facts': 'Ключевые факты',
  'record.notSet': '— не указано',
  'record.irreversible': 'Действие нельзя отменить.',
  'record.copyLink': 'Скопировать ссылку',
  'record.copyFailed': 'Не удалось скопировать: браузер не дал доступа к буферу обмена',
  'record.copyNumber': 'Скопировать номер {number}',
  'record.tab.overview': 'Обзор',
  'record.tab.positions': 'Позиции',
  'record.tab.documents': 'Документы',
  'record.tab.history': 'История',
  'record.history.changes': 'Журнал изменений',
  'record.next.title': 'Следующий шаг',
  'record.next.missing': 'Следующий шаг не назначен',
  'record.next.overdue': 'Просрочено',
  'record.next.done': 'Выполнено',
  'record.next.assign': 'Назначить шаг',
  'record.next.noDue': 'без срока',
  'record.feed.title': 'Лента',
  'record.feed.filter': 'Фильтр ленты',
  'record.feed.filter.all': 'Всё',
  'record.feed.filter.touches': 'Звонки и письма',
  'record.feed.filter.comments': 'Комментарии',
  'record.feed.filter.changes': 'Изменения',
  'record.feed.noneByFilter': 'Событий такого вида нет — выберите «Всё».',
  'record.feed.today': 'Сегодня',
  'record.feed.yesterday': 'Вчера, {date}',
  'record.feed.stage': 'Стадия: {from} → {to}',
  'record.composer.kind': 'Тип записи',
  'record.composer.add': 'Добавить',
  'record.composer.hint': 'Ctrl ↵ — добавить',
  'record.composer.failed': 'Не сохранено: сервер не ответил. Текст остался в поле.',
  'record.composer.due': 'Срок',
  'record.composer.duration': 'Длительность, мин',
  'record.composer.comment': 'Комментарий к сделке',
  'record.composer.call': 'О чём говорили',
  'record.composer.task': 'Что сделать дальше',
  'record.stage.overLimit': '{days} дн. — лимит {limit} превышен',
  'record.stage.withinLimit': '{days} дн. из {limit}',
  'record.state.forbidden.title': 'Эта запись вам недоступна',
  'record.state.forbidden.text': 'Запись существует, но ваша роль её не видит. Доступ выдаёт руководитель или администратор.',
  'record.state.error.title': 'Не удалось открыть запись',
  'record.state.error.text': 'Сервер вернул ошибку при загрузке. Данные не изменены — можно повторить.',
  'record.state.retry': 'Повторить',
  'record.state.toList': 'К списку',
  'record.deal.sections': 'Разделы сделки',
  'record.deal.stages': 'Стадии сделки',
  'record.deal.noClient': 'Клиент не указан',
  'record.deal.nextStage': 'Перевести в «{stage}»',
  'record.deal.closeLost': 'Закрыть как проигранную…',
  'record.deal.delete': 'Удалить сделку',
  'record.deal.delete.title': 'Удалить сделку «{title}»?',
  'record.deal.delete.text': 'Сделка пропадёт из списков, доски и отчётов. Сделку, по которой уже выпущены документы, сервер удалить не даст.',
  'record.deal.fact.amount': 'Сумма',
  'record.deal.fact.positions': 'позиций: {count}',
  'record.deal.fact.probability': 'Вероятность',
  'record.deal.fact.weighted': 'взвеш. {amount}',
  'record.deal.fact.closeOn': 'Срок закрытия',
  'record.deal.fact.responsible': 'Ответственный',
  'record.deal.closedOn': 'закрыта {date}',
  'record.deal.overdueBy': 'Просрочено на {days} дн.',
  'record.deal.dueToday': 'сегодня',
  'record.deal.dueIn': 'через {days} дн.',
  'record.deal.next.missingHint': 'Без задачи сделка не попадёт в «Мой день» ответственного, и о ней никто не вспомнит вовремя.',
  'record.deal.next.error': 'Не удалось загрузить задачи сделки',
  'record.deal.feed.error': 'Не удалось загрузить ленту сделки',
  'record.deal.feed.empty.title': 'Событий пока нет',
  'record.deal.feed.empty.text': 'Добавьте звонок, задачу или комментарий — они появятся здесь.',
  'record.deal.details': 'Сведения',
  'record.deal.positions': 'Позиции',
  'record.deal.positions.empty': 'Позиций нет. Добавьте товары на вкладке «Позиции» — сумма сделки посчитается из них.',
  'record.deal.allPositions': 'Все позиции',
  'record.deal.quotes': 'Коммерческие предложения',
  'record.deal.quotes.empty': 'По сделке КП не выпускались.',
  'record.deal.quotes.error': 'Не удалось загрузить КП сделки',
  'state.forbidden.title': 'Этот блок вам недоступен',
  'state.forbidden.text': 'Нет права на его данные. Если оно нужно для работы, его выдаёт администратор.',
  'state.error.text': 'Сервер не ответил. Остальные блоки актуальны.',
  'state.retry': 'Повторить',
  'myday.newLead': 'Новый лид',
  'myday.allTasks': 'Все задачи',
  'myday.noCard.title': 'У учётной записи нет карточки сотрудника',
  'myday.noCard.text': 'Задачи, сделки и клиенты закрепляются за сотрудником. Пока учётная запись не связана с карточкой, «моего» у неё нет — это не значит, что всё сделано.',
  'myday.facts': 'Сводка дня',
  'myday.fact.overdueTasks': 'просроченные задачи',
  'myday.fact.todayTasks': 'задач на сегодня',
  'myday.fact.todayTasksNext': 'задач на сегодня, следующая в {time}',
  'myday.fact.deals': 'сделки требуют внимания',
  'myday.fact.overdueInvoices': 'просрочено по счетам: {count}',
  'myday.tasks': 'Задачи',
  'myday.period': 'Период',
  'myday.period.today': 'Сегодня',
  'myday.period.week': 'Неделя',
  'myday.tasks.error': 'Задачи не загрузились',
  'myday.tasks.emptyToday': 'На сегодня задач нет',
  'myday.tasks.emptyWeek': 'На неделю задач нет',
  'myday.tasks.emptyText': 'Просроченных тоже нет. Все задачи, включая будущие, — на экране «Мои задачи».',
  'myday.tasks.overdue': 'Просрочено · {count}',
  'myday.tasks.today': 'Сегодня · {count}',
  'myday.tasks.week': 'Ближайшие 7 дней и без срока · {count}',
  'myday.tasks.complete': 'Отметить выполненной: {subject}',
  'myday.overdueBy': 'просрочено {days} дн.',
  'myday.noDue': 'без срока',
  'myday.today': 'сегодня',
  'myday.tomorrow': 'завтра',
  'myday.entity.deal': 'Сделка',
  'myday.entity.lead': 'Лид',
  'myday.entity.counterparty': 'Контрагент',
  'myday.entity.contact': 'Контакт',
  'myday.entity.invoice': 'Счёт',
  'myday.deals': 'Сделки требуют внимания',
  'myday.allDeals': 'Все мои сделки',
  'myday.deals.error': 'Сделки не загрузились',
  'myday.deals.empty': 'Все сделки в порядке',
  'myday.deals.emptyText': 'У каждой открытой сделки есть следующий шаг, и ни одна не стоит на стадии дольше лимита.',
  'myday.deals.deal': 'Сделка',
  'myday.deals.client': 'Клиент',
  'myday.deals.stage': 'Стадия',
  'myday.deals.amount': 'Сумма',
  'myday.deals.issue': 'Что не так',
  'myday.deals.open': 'Открыть',
  'myday.deals.assignStep': 'Назначить шаг',
  'myday.deals.more': 'Показаны {shown} из {total} — остальные в списке сделок',
  'myday.deals.stuck': 'Застряла {days} дн. при лимите {limit}',
  'myday.deals.stuckNoLimit': 'Застряла: {days} дн. на стадии',
  'myday.deals.noStep': 'Нет шага · касаний не было',
  'myday.deals.noStepTouched': 'Нет шага · контакт {days} дн. назад',
  'myday.meetings': 'Встречи',
  'myday.meetings.error': 'Встречи не загрузились',
  'myday.meetings.empty': 'На ближайшую неделю встреч нет.',
  'myday.leads': 'Новые лиды',
  'myday.allLeads': 'Все лиды',
  'myday.leads.error': 'Лиды не загрузились',
  'myday.leads.empty': 'Новых лидов на вас нет.',
  'myday.leads.open': 'Открыть',
  'myday.invoices': 'Счета моих клиентов',
  'myday.allInvoices': 'Все счета',
  'myday.invoices.error': 'Счета не загрузились',
  'myday.invoices.empty': 'Неоплаченных счетов у ваших клиентов нет.',
  'myday.invoices.overdue': 'Просрочено · {amount}',
  'myday.invoices.awaiting': 'Ждут оплаты · {count}',
  'myday.invoices.rest': 'остаток {amount}',
  'myday.invoices.dueOn': 'до {date}',
  'myday.ago.minutes': '{count} мин назад',
  'myday.ago.hours': '{count} ч назад',
  'myday.ago.days': '{count} дн. назад',
  'dash.leader': 'Сводка руководителя',
  'dash.fresh': 'Данные на {time}',
  'dash.saved': 'Мои дашборды',
  'dash.forbidden.title': 'Сводка руководителя вам недоступна',
  'dash.forbidden.text': 'Она показывает согласования, воронку и дебиторку, а прав ни на один из этих источников у вас нет. Свои дашборды из отчётов — ниже.',
  'dash.approvals': 'Ждут вашего решения',
  'dash.approvals.all': 'Все согласования',
  'dash.approvals.error': 'Согласования не загрузились',
  'dash.approvals.empty': 'Согласований, ждущих вас, нет.',
  'dash.approvals.waits': 'ждёт {time}',
  'dash.approvals.step': 'Шаг {step} из {total}',
  'dash.approvals.reject': 'Отклонить…',
  'dash.plan': 'План / факт',
  'dash.plan.setupTitle': 'Плана по компании в системе нет',
  'dash.plan.setupText': 'Цели заводятся в KPI на сотрудников и отделы — сводного плана компании, с которым сравнивать факт, нет. Шкалу с выдуманным планом показывать не будем.',
  'dash.plan.toKpi': 'Открыть KPI',
  'dash.funnel': 'Воронка — открытые сделки',
  'dash.funnel.error': 'Воронка не загрузилась',
  'dash.funnel.noFunnel': 'Воронка не заведена',
  'dash.funnel.noFunnelText': 'Нет ни одной активной воронки продаж — её заводят в администрировании.',
  'dash.funnel.empty': 'Открытых сделок нет',
  'dash.funnel.emptyText': 'В вашей области видимости нет ни одной открытой сделки.',
  'dash.funnel.conversion': '{percent} % переходят дальше в этом месяце',
  'dash.funnel.noConversion': 'в этом месяце стадию никто не проходил',
  'dash.ar': 'Дебиторка по срокам',
  'dash.ar.total': 'всего {amount}',
  'dash.ar.error': 'Отчёт по дебиторке не построился',
  'dash.ar.empty': 'Дебиторки нет',
  'dash.ar.emptyText': 'Неоплаченных счетов в вашей области видимости нет.',
  'dash.ar.notYetDue': 'в срок',
  'dash.ar.bucket0to30': '1–30 дн.',
  'dash.ar.bucket31to60': '31–60',
  'dash.ar.bucket61to90': '61–90',
  'dash.ar.bucket90plus': '90+ дн.',
  'dash.ar.otherCurrencies': 'И в других валютах: {amounts}',
  'dash.ar.top': 'Крупнейшие просрочки',
  'dash.ar.overdue': 'Просрочено',
  'dash.ar.oldest': 'Самый старый долг',
  'dash.stuck': 'Застрявшие сделки',
  'dash.stuck.board': 'Все на канбане',
  'dash.stuck.error': 'Застрявшие сделки не загрузились',
  'dash.stuck.empty': 'Застрявших сделок нет: все стоят на стадиях в пределах лимита.',
  'dash.stuck.emptyPartial': 'Среди просмотренных сделок застрявших нет — но доска отдала не все: проверьте канбан.',
  'dash.stuck.inStage': 'На стадии',
  'dash.stuck.partial': 'Просмотрены первые 200 сделок каждой стадии — застрявших может быть больше, полный список на канбане.',
  'dash.hours': '{count} ч',
  'dash.days': '{count} дн.',
  'filter.title': 'Фильтр',
  'filter.allMustMatch': 'все условия должны выполняться',
  'filter.where': 'Где',
  'filter.and': 'и',
  'filter.clearAll': 'Сбросить всё',
  'filter.applied': 'Условия',
  'filter.removeToken': 'Убрать условие {column}',
  'view.mine': 'Мои',
  'view.sharedGroup': 'Общие',
  'view.empty': 'Сохранённых представлений нет',
  'view.defaultMark': 'по умолч.',
  'view.modified': 'изменено',
  'view.saveCurrent': 'Сохранить как представление',
  'pager.loading': 'Загружаем',
  'pager.start': 'начало списка',
  'bulk.label': 'Действия с выбранными',
  'bulk.deleteAsk': 'Удалить…',
  'bulk.confirmTitle': 'Удалить выбранные записи ({count})?',
  'bulk.confirmText': 'Записи пропадут из списков и отчётов. Удалятся только те, на которые у вас есть право удаления.',
  'column.free_quantity': 'Свободно',
  'stock.noFree': 'нет свободного',
  'board.label': 'Канбан сделок',
  'board.column': 'Стадия {stage}',
  'board.columnCount': 'Сделок в колонке: {count}',
  'board.weightedShort': 'взв. {amount}',
  'board.weightedHint': 'Взвешенная сумма — сумма каждой сделки × её вероятность (у этапа {probability}%)',
  'board.columnMeta': 'вероятность {probability}% · лимит {limit} дн.',
  'board.columnProbability': 'вероятность {probability}%',
  'board.summary': '{count} открытых · {amount} · взвеш. {weighted}',
  'board.dropHere': 'Отпустите — «{stage}»',
  'board.dropZones': 'Закрыть сделку перетаскиванием',
  'board.dropWon': '{stage}',
  'board.dropLost': '{stage} — спросим причину',
  'board.overdue': 'Срок прошёл',
  'board.mine': 'Моя сделка',
  'board.mineShort': 'Я',
  'board.refresh': 'Обновить доску',
  'board.empty': 'На доске нет открытых сделок',
  'board.emptyHint': 'Закрытые сделки на доске не показываются — они в таблице.',
  'board.noFunnelsHint': 'Для доски нужны стадии, вероятности и лимиты дней на стадии. Их задаёт администратор; таблица сделок работает и без воронки.',
  // deal win forecast (#128)
  'board.cardProbability': 'Стадия {probability}%',
  'board.forecastShort': 'по прогнозу {amount}',
  'board.forecastHint': 'Сумма каждой сделки × прогноз модели; взвешенная по стадии — рядом',
  'board.forecastSummary': 'по прогнозу {weighted}',
  'board.forecastPartial': 'прогноз есть у {covered} из {count} сделок',
  'board.forecastColumnPartial': 'прогноз у {covered} из {count}',
  'record.deal.fact.forecast': 'Прогноз модели',
  'nav.forecastModel': 'Прогноз сделок',
  'forecast.short': 'прогноз {probability}',
  'forecast.why': 'Почему: {factors}',
  'forecast.whyTitle': 'Почему такой прогноз',
  'forecast.noFactors': 'Сделка близка к средней — ни один фактор заметно не выделяется',
  'forecast.factorLine': '{factor} — {effect}',
  'forecast.effect.up': 'повышает',
  'forecast.effect.down': 'понижает',
  'forecast.value.none': 'не было',
  'forecast.none.pending': 'прогноз ещё не посчитан',
  'forecast.none.insufficient': 'прогноза нет: мало закрытых сделок',
  'forecast.none.untrained': 'прогноза нет: модель не обучалась',
  'forecast.factor.stage_probability': 'Вероятность стадии: {value}%',
  'forecast.factor.stage_position': 'Место стадии в воронке: {value}',
  'forecast.factor.deal_age_days': 'Возраст сделки: {value} дн.',
  'forecast.factor.days_in_stage': 'На текущей стадии: {value} дн.',
  'forecast.factor.backward_moves': 'Возвратов назад по воронке: {value}',
  'forecast.factor.activities_14d': 'Активностей за 14 дней: {value}',
  'forecast.factor.days_since_activity': 'Дней с последней активности: {value}',
  'forecast.factor.quote_sent': 'КП отправлено: {value}',
  'forecast.factor.from_lead': 'Из лида: {value}',
  'forecast.factor.client_prior_wins': 'Выигранных сделок с клиентом раньше: {value}',
  'forecast.factor.lead_source': 'Источник лида: {value}',
  'forecast.feature.stage_probability': 'Вероятность стадии',
  'forecast.feature.stage_position': 'Место стадии в воронке',
  'forecast.feature.deal_age_days': 'Возраст сделки (лог)',
  'forecast.feature.days_in_stage': 'Дней на стадии (лог)',
  'forecast.feature.backward_moves': 'Возвраты назад по воронке',
  'forecast.feature.activities_14d': 'Активности за 14 дней (лог)',
  'forecast.feature.days_since_activity': 'Дней с последней активности',
  'forecast.feature.quote_sent': 'КП отправлено',
  'forecast.feature.from_lead': 'Сделка из лида',
  'forecast.feature.client_prior_wins': 'Прежние выигрыши клиента (лог)',
  'forecast.feature.lead_source': 'Источник лида: {value}',
  'forecast.model.lead': 'Логистическая регрессия на истории закрытых сделок. Прогноз показывается на доске и в карточке сделки рядом со статической вероятностью стадии, а не вместо неё.',
  'forecast.model.train': 'Обучить заново',
  'forecast.model.training': 'Обучаем…',
  'forecast.model.forbidden': 'Нет доступа к отчёту о модели',
  'forecast.model.none.title': 'Модель ещё не обучалась',
  'forecast.model.none.text': 'Прогнозов нет. Модель обучается раз в неделю или по кнопке; нужно не меньше {min} закрытых сделок с историей стадий.',
  'forecast.model.insufficient.title': 'Модель не обучена: мало данных',
  'forecast.model.insufficient.text': '{message}. Попытка {date}. Прогнозов нет — это не ноль, а отсутствие модели.',
  'forecast.model.summary': 'Обучена {date}: {train} сделок ({trainExamples} снимков) в обучении, {holdout} сделок ({holdoutExamples} снимков) в отложенной выборке — закрытые с {from}. Прогноз у {deals} открытых сделок.',
  'forecast.model.quality': 'Качество на отложенной выборке',
  'forecast.model.col.metric': 'Метрика',
  'forecast.model.col.model': 'Модель',
  'forecast.model.col.baseline': 'Базовая линия: вероятность стадии',
  'forecast.model.auc': 'AUC',
  'forecast.model.aucHint': 'Насколько верно модель ранжирует: 0,5 — как монетка, 1 — без ошибок',
  'forecast.model.logLoss': 'Log-loss',
  'forecast.model.brier': 'Brier',
  'forecast.model.lowerBetter': 'Чем меньше, тем точнее сами цифры',
  'forecast.model.undefined': 'не определён',
  'forecast.model.snapshot': 'Каждая закрытая сделка даёт несколько снимков — в момент входа в стадию и раз в неделю пребывания в ней; признаки считаются только из того, что было известно в момент снимка. Отложенная выборка — последние по дате закрытия сделки, а не случайные. Сумма и скидка в модель не входят: у позиций нет даты появления, и их значение на момент снимка восстановить нельзя.',
  'forecast.model.calibration': 'Калибровка',
  'forecast.model.col.bucket': 'Прогноз',
  'forecast.model.col.examples': 'Снимков',
  'forecast.model.col.predicted': 'Средний прогноз',
  'forecast.model.col.actual': 'Выиграно на деле',
  'forecast.model.winRates': 'Доля выигранных: в обучении {train}, в отложенной выборке {holdout}.',
  'forecast.model.coefficients': 'Вес признаков',
  'forecast.model.col.feature': 'Признак',
  'forecast.model.col.weight': 'Вес (на стандартизованный признак)',
  'forecast.model.col.direction': 'Влияние',
  // company & invoice (design)
  'merge.dialog.title': 'Слить «{duplicate}» в «{survivor}»?',
  'merge.dialog.text': 'Сделки, контакты, лента и черновые счета переедут в эту карточку, а карточка дубля будет удалена.',
  'record.cp.sections': 'Разделы контрагента',
  'record.cp.tab.deals': 'Сделки',
  'record.cp.tab.finance': 'Финансы',
  'record.cp.blocked': 'Заблокирован',
  'record.cp.copyInn': 'Скопировать ИНН {value}',
  'record.cp.copyKpp': 'Скопировать КПП {value}',
  'record.cp.noResponsible': 'Ответственный не назначен',
  'record.cp.newDeal': 'Новая сделка',
  'record.cp.duplicates': 'Дубли и слияние',
  'record.cp.close': 'Закрыть',
  'record.cp.delete': 'Удалить контрагента',
  'record.cp.delete.title': 'Удалить контрагента «{name}»?',
  'record.cp.delete.text': 'Карточка пропадёт из списков. Клиента с открытыми сделками, счетами, договорами или платежами сервер не удалит — такого блокируют.',
  'record.cp.overdueAlert': 'Просрочка {amount}',
  'record.cp.overdueAlertDetails': 'по счетам: {count}, самая давняя — {days} дн.',
  'record.cp.fact.deals': 'Открытые сделки',
  'record.cp.fact.noDeals': 'открытых сделок нет',
  'record.cp.fact.debt': 'Долг',
  'record.cp.fact.noDebt': 'нет',
  'record.cp.fact.overdue': 'просрочено {amount}',
  'record.cp.fact.noOverdue': 'просрочки нет',
  'record.cp.fact.lastContact': 'Последний контакт',
  'record.cp.fact.noContact': 'контактов не было',
  'record.cp.fact.terms': 'Условия оплаты',
  'record.cp.fact.prepayment': 'предоплата',
  'record.cp.fact.deferral': 'отсрочка {days} дн.',
  'record.cp.fact.limit': 'лимит долга {amount}',
  'record.cp.fact.noLimit': 'лимит не задан',
  'record.cp.composer.comment': 'Комментарий к клиенту',
  'record.cp.feed.title': 'Последние события',
  'record.cp.feed.error': 'Не удалось загрузить ленту клиента',
  'record.cp.feed.empty.title': 'Событий пока нет',
  'record.cp.feed.empty.text': 'Звонки, задачи и комментарии по клиенту появятся здесь.',
  'record.cp.openDeals': 'Открытые сделки',
  'record.cp.allDeals': 'Все сделки клиента',
  'record.cp.deal': 'Сделка',
  'record.cp.deals.error': 'Не удалось загрузить сделки клиента',
  'record.cp.deals.empty.title': 'Открытых сделок нет',
  'record.cp.deals.empty.text': 'Начните с новой сделки — она встанет на доску ответственного.',
  'record.cp.deals.more': 'Показаны первые 50 открытых сделок — остальные в списке сделок.',
  'record.cp.debt': 'Задолженность',
  'record.cp.allInvoices': 'Все счета',
  'record.cp.debt.error': 'Не удалось загрузить задолженность',
  'record.cp.debt.none': 'Долга нет — неоплаченных счетов у клиента нет.',
  'record.cp.debt.bar': 'Долг: в срок {current}, просрочено {overdue}',
  'record.cp.debt.current': 'в срок {amount}',
  'record.cp.debt.overdue': 'просрочено {amount}',
  'record.cp.invoice': 'Счёт',
  'record.cp.people': 'Контакты',
  'record.cp.people.error': 'Не удалось загрузить контакты',
  'record.cp.call': 'Позвонить: {name}',
  'record.cp.write': 'Написать: {name}',
  'record.cp.requisites': 'Реквизиты',
  'record.cp.requisites.error': 'Не удалось загрузить реквизиты',
  'record.cp.requisites.empty': 'Реквизиты не заполнены.',
  'record.cp.allFields': 'Все поля',
  'record.cp.fewerFields': 'Кратко',
  'record.cp.innKpp': 'ИНН / КПП',
  'record.cp.contracts': 'Договоры',
  'record.cp.contracts.none': 'Договора нет.',
  'record.cp.contract': 'Договор № {number}',
  'record.cp.validUntil': 'до {date}',
  'record.cp.allDocuments': 'Все',
  'record.cp.credit': 'Кредит и условия',
  'record.cp.finance.error': 'Не удалось загрузить финансы клиента',
  'record.cp.primaryDocuments': 'Первичные документы',
  'record.cp.documents.error': 'Не удалось загрузить документы',
  'record.cp.documents.empty': 'Первичных документов по клиенту нет.',
  'record.inv.title': 'Счёт',
  'record.inv.sections': 'Разделы счёта',
  'record.inv.tab.payments': 'Оплаты',
  'record.inv.client': 'Клиент',
  'record.inv.deal': 'сделка',
  'record.inv.contract': 'договор',
  'record.inv.open': 'открыть',
  'record.inv.issued': 'выставлен {date}',
  'record.inv.payBy': 'оплатить до',
  'record.inv.overdueDays': 'Просрочен {days} дн.',
  'record.inv.overdueBy': 'просрочено {days} дн.',
  'record.inv.awaiting': 'Ждёт оплаты',
  'record.inv.awaitingDays': 'Ждёт оплаты · {days} дн.',
  'record.inv.dueToday': 'срок сегодня',
  'record.inv.dueIn': 'срок через {days} дн.',
  'record.inv.settled': 'оплачен полностью',
  'record.inv.allocate': 'Разнести оплату',
  'record.inv.allocated': 'Оплата разнесена на счёт.',
  'record.inv.deallocated': 'Разнесение снято: сумма вернулась платежу и счёту.',
  'record.inv.cancel': 'Отменить счёт',
  'record.inv.cancelContinue': 'Отменить счёт…',
  'record.inv.cancel.title': 'Отменить счёт {number}?',
  'record.inv.cancel.text': 'Счёт останется в реестре отменённым с причиной: «{reason}».',
  'record.inv.cancelledBecause': 'Счёт отменён. Причина: {reason}',
  'record.inv.amounts': 'Суммы счёта',
  'record.inv.total': 'Сумма с НДС',
  'record.inv.vatSub': 'НДС {amount}',
  'record.inv.paidPercent': 'Оплачено {percent} %',
  'record.inv.advanceHint': 'У клиента есть неразнесённый платёж № {number} от {date}: остаток {amount}.',
  'record.inv.allocateHere': 'Разнести {amount} на этот счёт',
  'record.inv.vatPerLine': 'НДС считается построчно, на сумму со скидкой',
  'record.inv.payments': 'Оплаты и разнесение',
  'record.inv.allPayments': 'Все оплаты',
  'record.inv.payments.error': 'Не удалось загрузить оплаты по счёту',
  'record.inv.payments.emptyDue': 'Срок оплаты — {date}.',
  'record.inv.paymentAmount': 'Сумма платежа',
  'record.inv.toThisInvoice': 'На этот счёт',
  'record.inv.paymentLeft': 'Остаток платежа',
  'record.inv.dispatches': 'Отправки и напоминания',
  'record.inv.sent': 'Счёт отправлен клиенту',
  'record.inv.notSent': 'Счёт ещё не отправлен',
  'record.inv.dunning.error': 'Не удалось загрузить напоминания',
  'record.inv.dunning.done': 'выполнено {at}',
  'record.inv.dunning.planned': 'запланировано на {date}',
  'record.inv.composer.comment': 'Комментарий к счёту',
  'record.inv.feed.error': 'Не удалось загрузить ленту счёта',
  'record.inv.feed.empty': 'Событий по счёту пока нет',
  'record.inv.details': 'Поля счёта',
  'record.inv.primaryDocuments': 'Первичные документы',
  'record.inv.documents.error': 'Не удалось загрузить документы счёта',
  'record.inv.documents.empty': 'По счёту документы не выпускались.',

  // --- payments & service screens (BankRecon, Cashbook, Fiscal, Err403/404, Login, CreateRecord) ---
  'payments.forbidden.hint': 'Раздел закрыт правами вашей роли. Данные существуют — их не показывают этой роли; доступ выдаёт администратор.',
  'payments.error.title': 'Не удалось загрузить данные',
  'payments.retry': 'Повторить',
  'payments.recon.noOrg.title': 'Выберите организацию — у каждой свои счета и выписки',
  'payments.recon.noOrg.text': 'Организации — разные юрлица: свои расчётные счета, свои выписки и своя очередь разбора. Складывать их нельзя.',
  'payments.recon.noAccount.title': 'У организации нет расчётного счёта',
  'payments.recon.noAccount.text': 'Выписку не с чем сопоставить: заведите расчётный счёт организации — тогда сюда можно будет загрузить выписку из «Клиент-Банка».',
  'payments.recon.chooseAccount': 'Выберите расчётный счёт, на который загружаете выписку',
  'payments.recon.accountShort': 'р/с',
  'payments.recon.nothingToPost': 'Проводить нечего: непроведённых строк выписки нет',
  'payments.recon.filter': 'Фильтр по статусу',
  'payments.recon.chip.all': 'Все',
  'payments.recon.status.line': 'Не проведено',
  'payments.recon.status.line.detail': 'банк прислал, платёж ещё не создан',
  'payments.recon.status.attention': 'Требует решения',
  'payments.recon.status.attention.detail': 'плательщик не опознан',
  'payments.recon.search': 'Поиск по строкам выписки',
  'payments.recon.search.placeholder': 'Контрагент, ИНН, № или сумма',
  'payments.recon.filtered.empty': 'Под фильтр ничего не попало',
  'payments.recon.empty.title': 'Очередь разобрана',
  'payments.recon.footnote': 'Строки выписки не редактируются — меняется только разнесение. Назначение платежа целиком — по наведению на текст.',
  'payments.recon.col.date': 'Дата',
  'payments.recon.col.number': '№ док.',
  'payments.recon.col.counterparty': 'Контрагент',
  'payments.recon.col.purpose': 'Назначение платежа',
  'payments.recon.col.in': 'Приход',
  'payments.recon.col.out': 'Расход',
  'payments.recon.col.status': 'Статус',
  'payments.recon.col.action': 'Действие',
  'payments.recon.notFoundByInn': 'Не найден по ИНН {inn}',
  'payments.recon.noInn': 'ИНН в выписке не указан',
  'payments.recon.open': 'Открыть',
  'payments.recon.total': 'Итого в очереди · {count}',
  'payments.recon.total.filtered': 'Итого по фильтру · {count}',
  'payments.recon.postAll.title': 'Провести строки выписки: {count}?',
  'payments.recon.postAll.confirm': 'Провести {count}',
  'payments.recon.postAll.text': 'Каждая строка станет платежом и разнесётся по счетам автоматически. Строки, которые не лягут, останутся в списке — итог назовёт их.',
  'payments.recon.postAll.untouched': 'Платежи «Требует решения» ({count}) не тронем — они останутся в списке.',
  'payments.import.zone': 'Загрузка выписки',
  'payments.import.drop': 'Перетащите файл выписки из «Клиент-Банка»',
  'payments.import.busy': 'Загружаем выписку…',
  'payments.import.format': 'Формат 1CClientBankExchange, файл .txt в UTF-8. Повторы распознаются по номеру, дате, сумме и счёту.',
  'payments.import.choose': 'Выбрать файл',
  'payments.import.more': 'Загрузить ещё',
  'payments.import.at': 'загружено в {time}',
  'payments.cash.noOrg.title': 'Выберите организацию — у каждой своя касса, общий остаток не показывается',
  'payments.cash.noOrg.text': 'Организации — разные юрлица: свои кассы и свои обороты. Складывать их наличные нельзя.',
  'payments.cash.newIncoming': 'Приход в кассу',
  'payments.cash.newOutgoing': 'Расход из кассы',
  'payments.cash.prevDay': 'Предыдущий день',
  'payments.cash.nextDay': 'Следующий день',
  'payments.cash.prevMonth': 'Предыдущий месяц',
  'payments.cash.nextMonth': 'Следующий месяц',
  'payments.cash.date': 'Дата',
  'payments.cash.period': 'Период',
  'payments.cash.day': 'День',
  'payments.cash.month': 'Месяц',
  'payments.cash.currency': 'Валюта кассы: {currency}',
  'payments.cash.currencyLabel': 'Валюта',
  'payments.cash.facts': 'Движение денег за {period}',
  'payments.cash.in': '+ Приход',
  'payments.cash.out': '− Расход',
  'payments.cash.net': '= Сальдо за период',
  'payments.cash.net.hint': 'по данным сервера за {period}',
  'payments.cash.items': 'статей: {count}',
  'payments.cash.empty.title': 'Проводок за {period} нет',
  'payments.cash.empty.text': 'Первая проводка появится здесь и сразу попадёт в кассовую книгу.',
  'payments.cash.col.date': 'Проводка · дата',
  'payments.cash.col.kind': 'Вид',
  'payments.cash.col.item': 'Статья ДДС · основание',
  'payments.cash.col.in': 'Приход',
  'payments.cash.col.out': 'Расход',
  'payments.cash.total': 'Итого за {period} · проводок: {count}',
  'payments.cash.reversedMark': 'сторнирована',
  'payments.cash.rowMenu': 'Действия с проводкой № {id}',
  'payments.cash.byItemIn': 'Приход по статьям',
  'payments.cash.byItemOut': 'Расход по статьям',
  'payments.cash.noIn': 'Поступлений за период не было.',
  'payments.cash.noOut': 'Выдач за период не было.',
  'payments.cash.org': 'Касса',
  'payments.cash.reverse.title': 'Сторнировать проводку № {id}?',
  'payments.cash.reverse.text': 'Журнал не правится: будет записана вторая, обратная проводка, и обе останутся видны. Отменить сторно можно только ещё одной записью.',
  'payments.cash.basis': 'Основание',
  'payments.cash.basis.help': 'Обязательно: необъяснённая ручная проводка — единственное, чего журнал не переваривает.',
  'payments.cash.record': 'Записать',
  'payments.fiscal.retry.nothing': 'Повторять нечего: в очереди только брошенные чеки',
  'payments.fiscal.empty.text': 'Если чек застрянет на пути в ОФД, он появится здесь сам.',
  'payments.fiscal.abandoned.title': 'Брошено чеков: {count} — автоматически они больше не отправляются.',
  'payments.fiscal.abandoned.text': 'Срок передачи в ОФД — 30 дней; такой чек закрывается чеком коррекции.',
  'payments.fiscal.chip.all': 'Все проблемные',
  'payments.fiscal.chip.retrying': 'Ожидает повтора',
  'payments.fiscal.chip.failed': 'Ошибка отправки',
  'payments.fiscal.chip.abandoned': 'Брошен',
  'payments.fiscal.search': 'Поиск чека',
  'payments.fiscal.search.placeholder': 'ФД, сумма, текст ошибки',
  'payments.fiscal.col.receipt': 'Чек / ФД',
  'payments.fiscal.col.created': 'Дата, время',
  'payments.fiscal.col.error': 'Последняя ошибка',
  'payments.fiscal.payment': 'платёж',
  'payments.fiscal.attempts': 'попыток: {count}',
  'payments.fiscal.next': 'следующая {at}',
  'payments.fiscal.noMoreRetries': 'автоматически больше не отправляется',
  'payments.fiscal.footnote': 'Не переданы в ОФД: {count}. Брошенным становится чек, исчерпавший попытки, — автоматически он больше не отправляется.',
  'err.home': 'На стартовую',
  'err.back': 'Назад',
  'err.support': 'Для техподдержки: {code}',
  'err.copy': 'Скопировать код ошибки',
  'err.copied': 'Код скопирован',
  'err.sections': 'Основные разделы',
  'err.requested': 'Запрошено',
  'err.yourRoles': 'Ваши роли',
  'err.403.tip': 'Права выдаёт администратор системы. Проверка на сервере работает независимо от этой страницы.',
  'err.404.kind': 'Не найдено',
  'err.404.lead.before': 'По адресу',
  'err.404.lead.after': 'ничего нет. Обычно причина одна из двух:',
  'err.404.stale': 'Ссылка устарела',
  'err.404.stale.text': 'Раздел переехал или в адресе опечатка — так бывает со ссылками из старых писем и закладок.',
  'err.404.deleted': 'Запись удалена или вам недоступна',
  'err.404.deleted.text': 'Удалённые сделки, счета и контрагенты не открываются по ссылке; чужие записи сервер не показывает вовсе.',
  'err.404.find': 'Найти запись',
  'err.404.find.placeholder': 'Раздел или команда — поиск с любой страницы',
  'auth.signIn.title': 'Вход в систему',
  'auth.signIn.help': 'Почта и пароль вводятся на странице корпоративного входа — CRM пароль не видит.',
  'auth.language': 'Язык интерфейса',
  'auth.logoutFailed.title': 'Выход не подтверждён',
  'create.close': 'Закрыть без сохранения',
  'create.more': 'Ещё поля',
  'create.saving': 'Создаём…',
  'create.saving.note': 'Проверяем и сохраняем…',
  'create.hint.submit': '— создать',
  'create.hint.cancel': '— отмена',
  'create.dup.open': 'Открыть',
  'create.cp.innHelp': '10 цифр — юрлицо, 12 — ИП или физлицо',
  'create.cp.needName': 'Укажите название',
  'create.cp.ogrn': 'ОГРН',
  'create.cp.website': 'Сайт',
  'create.cp.more.hint': '· телефон, почта, сайт, полное наименование, фактический адрес',
  'lead.create.what': 'Что хотят',
  'lead.create.needTitle': 'Опишите, что хотят',
  'lead.create.innHelp': 'Необязательно; ИНН тоже годится как контакт',
  'lead.create.responsibleYou': 'Вы',
  'lead.create.responsibleMe': 'Лид, заведённый вручную, достаётся тому, кто его завёл',
  'deal.create.needTitle': 'Укажите название сделки',
  'deal.create.needFunnel': 'Нет воронки: заведите её в администрировании',
  'deal.create.stageHelp': 'Первая стадия воронки, вероятность {probability} %',
  'deal.create.currencyHelp': 'Пусто — валюта по умолчанию',
  'deal.create.openDeals': 'У клиента уже есть открытые сделки ({count}) — может быть, добавить позиции в одну из них?',
  'deal.create.separate': 'Нет, создать отдельную',
  'deal.create.separateNote': 'Будет отдельная сделка; открытые сделки клиента остаются как есть — все видны в его карточке.',
  // Карточки складских документов на дизайн-системе (Receiving, Shipment, Picking, Inventory, Transfer.dc.html)
  'record.wh.stages': 'Этапы документа',
  'record.wh.details': 'Сведения',
  'record.wh.cancelledEnd': 'Отменён',
  'record.wh.none': 'нет',
  'record.wh.of': '{done} из {total}',
  'record.wh.pieces': '{qty} шт',
  'record.wh.kg': '{qty} кг',
  'record.wh.m3': '{qty} м³',
  'record.wh.days': '{days} дн.',
  'record.wh.total': 'Итого',
  'record.wh.positions': 'Позиций',
  'record.wh.warehouseNamed': 'склад «{name}»',
  'record.wh.rowFilter': 'Какие строки показать',
  'record.wh.filter.all': 'Все',
  'record.wh.filter.withDiff': 'С расхождениями',
  'record.wh.filter.pending': 'В работе',
  'record.wh.rec.title': 'Приёмка',
  'record.wh.rec.sections': 'Разделы приёмки',
  'record.wh.rec.supplier': 'Поставщик',
  'record.wh.rec.noSupplier': 'поставщик не указан',
  'record.wh.rec.supplierDoc': 'документ поставщика № {number}',
  'record.wh.rec.byOrder': 'по заказу поставщику',
  'record.wh.rec.keeper': 'кладовщик {name}',
  'record.wh.rec.start': 'Начать приёмку',
  'record.wh.rec.complete': 'Провести приёмку',
  'record.wh.rec.completed': 'Приёмка проведена: товар поставлен на остаток',
  'record.wh.rec.cancel': 'Отменить приёмку…',
  'record.wh.rec.cancel.title': 'Отменить приёмку {number}?',
  'record.wh.rec.cancel.text': 'Строки и пересчёт останутся в документе, на остаток ничего не поступит.',
  'record.wh.rec.nothingCounted': 'Провести пока нечего: ни одна строка не пересчитана на ТСД.',
  'record.wh.rec.positions': 'Позиций',
  'record.wh.rec.positionsSub': '{counted} пересчитано · {pending} в работе',
  'record.wh.rec.expectedAccepted': 'Ожидалось / принято, шт',
  'record.wh.rec.rejectedSub': 'брак {qty}',
  'record.wh.rec.diffCount': 'Строк с расхождениями: {count}',
  'record.wh.rec.diffSub': 'недостача {shortage} · излишек {surplus} · брак {defect}',
  'record.wh.rec.receivedAt': 'Принята',
  'record.wh.rec.notReceived': 'ещё не проведена',
  'record.wh.rec.lines': 'Строки приёмки',
  'record.wh.rec.difference': 'Разница',
  'record.wh.rec.progress': 'Прогресс',
  'record.wh.rec.total': 'Итого · строк: {count}',
  'record.wh.rec.countedOf': 'пересчитано {counted} из {total}',
  'record.wh.rec.notAccepted': 'ещё не принято',
  'record.wh.rec.shortageBy': '{qty} · недостача',
  'record.wh.rec.surplusBy': '{qty} · излишек',
  'record.wh.rec.mismatch': 'не сходится с ожидаемым',
  'record.wh.rec.matches': 'совпадает',
  'record.wh.rec.empty.title': 'В приёмке нет строк',
  'record.wh.rec.codes': 'Коды маркировки',
  'record.wh.rec.codesMissing': 'Коды сканируются на ТСД. Список отсканированных кодов по приёмке сервер пока не отдаёт — счётчик и дубли здесь не показать.',
  'record.wh.rec.actError': 'Не удалось загрузить акт о расхождениях',
  'record.wh.rec.amount': 'Кол-во',
  'record.wh.rec.moneyMissing': 'Суммы расхождений по закупочным ценам сервер не считает — акт показывает количество.',
  'record.wh.rec.putaway': 'Куда разместить',
  'record.wh.rec.putawayEmpty': 'Размещать нечего.',
  'record.wh.rec.crossDock': 'кросс-док, без размещения',
  'record.wh.rec.confirm.title': 'Провести приёмку?',
  'record.wh.rec.confirm.withDiff': 'Провести с расхождениями?',
  'record.wh.rec.confirm.withDiffAction': 'Провести с расхождениями',
  'record.wh.rec.confirm.diff': 'Недостача {shortage} шт, излишек {surplus} шт, брак {defect} шт.',
  'record.wh.rec.confirm.pending': 'Строк без пересчёта: {count} — по ним на остаток ничего не поступит.',
  'record.wh.rec.confirm.balance': 'Принятый товар встанет на остаток, склад «{warehouse}».',
  'record.wh.rec.confirm.final': 'Проведённую приёмку отменяют только возвратом поставщику.',
  'record.wh.rec.stage.draft': 'Черновик',
  'record.wh.rec.stage.in_progress': 'На приёмке',
  'record.wh.rec.stage.completed': 'Принята',
  'record.wh.rec.stage.countingNow': 'пересчёт на ТСД',
  'record.wh.rec.stage.afterPosting': 'после проведения',
  'record.wh.ship.title': 'Отгрузка',
  'record.wh.ship.sections': 'Разделы отгрузки',
  'record.wh.ship.client': 'Клиент',
  'record.wh.ship.byOrder': 'по заказу',
  'record.wh.ship.post': 'Провести отгрузку',
  'record.wh.ship.posted': 'Отгрузка проведена: остатки списаны, документ выпущен',
  'record.wh.ship.postHint': 'Проведение спишет остатки и выпустит УПД; передача перевозчику — отдельный шаг.',
  'record.wh.ship.packingOnTerminal': 'Отгрузка ещё не упакована: упаковка идёт у стола на терминале, провести можно после неё.',
  'record.wh.ship.confirm.title': 'Провести отгрузку {number}?',
  'record.wh.ship.confirm.text': 'Со склада «{warehouse}» спишется {qty} шт по позициям: {positions}; выпустится УПД.',
  'record.wh.ship.confirm.separate': 'Передача перевозчику — отдельное действие после проведения.',
  'record.wh.ship.returned': 'Возвращена',
  'record.wh.ship.stage.packed': 'Упакована',
  'record.wh.ship.stage.shipped': 'Проведена',
  'record.wh.ship.stage.in_transit': 'Передана перевозчику',
  'record.wh.ship.stage.delivered': 'Доставлена',
  'record.wh.ship.stage.packing': 'упаковка на ТСД',
  'record.wh.ship.stage.packedMeta': 'мест: {count}',
  'record.wh.ship.afterPacking': 'после упаковки',
  'record.wh.ship.afterWeighing': 'после взвешивания',
  'record.wh.ship.gross': 'Вес брутто',
  'record.wh.ship.netSub': 'нетто {qty} кг',
  'record.wh.ship.volume': 'Объём',
  'record.wh.ship.noCarrier': 'не выбран',
  'record.wh.ship.track': 'трек',
  'record.wh.ship.copyTrack': 'Скопировать трек-номер {number}',
  'record.wh.ship.noTrack': 'перевозчик не нумерует отгрузку',
  'record.wh.ship.trackAfterHandOver': 'трек — после передачи',
  'record.wh.ship.items': 'Состав отгрузки',
  'record.wh.ship.noLinesText': 'Строки отгрузки появятся из заказа после резервирования и сборки.',
  'record.wh.ship.placesOf': 'Места',
  'record.wh.ship.placesCount': 'мест: {count}',
  'record.wh.ship.places': 'Грузовые места',
  'record.wh.ship.inside': 'Что внутри',
  'record.wh.ship.packingError': 'Не удалось загрузить упаковочный лист',
  'record.wh.ship.weightNote': 'Брутто {gross} кг, нетто {net} кг — итогом отгрузки. Габариты и вес каждого места сервер не отдаёт.',
  'record.wh.ship.notWeighed': 'Отгрузка ещё не взвешена.',
  'record.wh.ship.handOverHint': 'Заявка уходит перевозчику один раз: повторная привела бы второго курьера.',
  'record.wh.ship.documents': 'Связанные документы',
  'record.wh.ship.order': 'Заказ',
  'record.wh.ship.noDocument': 'УПД ещё нет',
  'record.wh.ship.documentIssued': 'выпущен при проведении',
  'record.wh.ship.documentOnPosting': 'сформируется при проведении',
  'record.wh.pick.title': 'Задание на отбор',
  'record.wh.pick.sections': 'Разделы задания',
  'record.wh.pick.picker': 'сборщик {name}',
  'record.wh.pick.noPicker': 'сборщик не назначен',
  'record.wh.pick.reassign': 'Переназначить сборщика',
  'record.wh.pick.complete': 'Завершить сборку',
  'record.wh.pick.completed': 'Сборка завершена',
  'record.wh.pick.completedShort': 'Сборка завершена, строк с недобором: {count}',
  'record.wh.pick.left': 'Завершить пока нельзя: необработанных строк — {count}. Их подтверждают сканом на ТСД.',
  'record.wh.pick.rows': 'Строк',
  'record.wh.pick.rowsSub': '{taken} взято · {skipped} пропущено · {left} осталось',
  'record.wh.pick.done': 'Собрано',
  'record.wh.pick.doneLabel': 'Обработано строк: {done} из {total}',
  'record.wh.pick.shortSub': 'с недобором: {count}',
  'record.wh.pick.skipped': 'Пропущено',
  'record.wh.pick.skippedTab': 'Пропуски',
  'record.wh.pick.time': 'Время в работе',
  'record.wh.pick.since': 'с {at}',
  'record.wh.pick.notStarted': 'ещё не начато',
  'record.wh.pick.emptyText': 'Маршрут не построен: позиции ещё не зарезервированы на складе.',
  'record.wh.pick.route': 'Маршрут обхода',
  'record.wh.pick.routeFallback': 'маршрут сервера недоступен — строки в порядке задания',
  'record.wh.pick.routeNote': 'Порядок — ряд → стеллаж → ярус, как его строит сервер. Недобор и пропуск не останавливают маршрут.',
  'record.wh.pick.taken': 'Взято {qty}',
  'record.wh.pick.takenOf': 'Взято {picked} из {qty}',
  'record.wh.pick.next': 'Следующая',
  'record.wh.pick.ahead': 'Впереди',
  'record.wh.pick.noSkipped': 'Пропущенных строк нет',
  'record.wh.pick.skippedAt': 'Сборщик пропустил строку в ячейке',
  'record.wh.pick.stockForbidden': 'Где ещё лежит товар, видно с правом на остатки.',
  'record.wh.pick.stockError': 'Не удалось загрузить остатки товара',
  'record.wh.pick.noStockElsewhere': 'На складе этого товара больше нет.',
  'record.wh.pick.elsewhere': 'Где ещё есть товар',
  'record.wh.pick.onBooks': 'По учёту',
  'record.wh.pick.available': 'Можно взять',
  'record.wh.pick.addCellMissing': 'Добавить ячейку в маршрут из офиса нельзя: такой операции нет.',
  'record.wh.pick.pickerPanel': 'Сборщик',
  'record.wh.pick.noPickerText': 'Сборщик не назначен — задание не уйдёт на ТСД.',
  'record.wh.pick.cancel.title': 'Отменить задание {number}?',
  'record.wh.pick.cancel.taken': 'Уже взято строк: {count} — товар вернут в ячейки.',
  'record.wh.pick.cancel.final': 'Отменённое задание нельзя возобновить — только создать новое.',
  'record.wh.st.title': 'Инвентаризация',
  'record.wh.st.sections': 'Разделы инвентаризации',
  'record.wh.st.start': 'Начать пересчёт',
  'record.wh.st.started': 'Пересчёт начат: лист ушёл на терминалы',
  'record.wh.st.startBlocked': 'В инвентаризации нет позиций — пересчитывать нечего.',
  'record.wh.st.finish': 'Завершить пересчёт',
  'record.wh.st.finished': 'Пересчёт завершён: сформирована сличительная ведомость',
  'record.wh.st.finishBlocked': 'Завершить пока нельзя: не посчитано позиций — {count}.',
  'record.wh.st.approve': 'Утвердить результаты…',
  'record.wh.st.positions': 'Позиций в листе',
  'record.wh.st.countedAt': 'пересчёт завершён {at}',
  'record.wh.st.left': 'не посчитано: {count}',
  'record.wh.st.variances': 'Расхождений',
  'record.wh.st.variancesSub': 'недостач {shortages} · излишков {surpluses}',
  'record.wh.st.hidden': 'скрыто',
  'record.wh.st.hiddenUntil': 'до завершения пересчёта',
  'record.wh.st.startedAt': 'Начата',
  'record.wh.st.notStarted': 'ещё не начата',
  'record.wh.st.sheetError': 'Не удалось загрузить лист пересчёта',
  'record.wh.st.emptyText': 'В инвентаризацию не попала ни одна позиция остатка.',
  'record.wh.st.filterUncounted': 'Не посчитаны',
  'record.wh.st.notCounted': 'не посчитано',
  'record.wh.st.sheetNote': 'Количество вводят на ТСД: ячейка → товар → количество.',
  'record.wh.st.sheetDone': 'Пересчёт завершён — расхождения в сличительной ведомости.',
  'record.wh.st.varianceLater': 'Сличительная ведомость откроется после завершения пересчёта.',
  'record.wh.st.varianceError': 'Не удалось загрузить сличительную ведомость',
  'record.wh.st.inPieces': 'в штуках; учётных цен ведомость не несёт',
  'record.wh.st.shortageTotal': 'Недостача · позиций: {count}',
  'record.wh.st.surplusTotal': 'Излишек · позиций: {count}',
  'record.wh.st.confirm.title': 'Утвердить результаты инвентаризации?',
  'record.wh.st.confirm.action': 'Утвердить и изменить остатки',
  'record.wh.st.confirm.totals': 'Остатки склада «{warehouse}» изменятся: недостача {shortage} шт, излишек {surplus} шт.',
  'record.wh.st.confirm.noVariances': 'Расхождений нет — остатки не изменятся.',
  'record.wh.st.confirm.final': 'Отменить можно только новой инвентаризацией.',
  'record.wh.st.cancel.title': 'Отменить инвентаризацию {number}?',
  'record.wh.st.cancel.text': 'Пересчитанное останется в документе, остатки не изменятся.',
  'record.wh.st.stage.draft': 'Подготовка',
  'record.wh.st.stage.in_progress': 'Пересчёт',
  'record.wh.st.stage.counted': 'Сверка',
  'record.wh.st.stage.approved': 'Утверждена',
  'record.wh.st.stage.changesStock': 'остатки изменятся',
  'record.wh.tr.title': 'Перемещение',
  'record.wh.tr.sections': 'Разделы перемещения',
  'record.wh.tr.lossBadge': 'Потери в пути',
  'record.wh.tr.dispatchedMeta': 'отправлено: {at}',
  'record.wh.tr.complete': 'Завершить приёмку',
  'record.wh.tr.completed': 'Приёмка перемещения завершена, потерь нет',
  'record.wh.tr.completedLoss': 'Приёмка завершена, строк с потерями в пути: {count}',
  'record.wh.tr.completeBlocked': 'Завершить пока нельзя: строк ждут пересчёта на ТСД получателя — {count}.',
  'record.wh.tr.positions': 'позиций: {count}',
  'record.wh.tr.received': 'Получено',
  'record.wh.tr.waitingSub': 'ещё {qty} шт ждут приёмки',
  'record.wh.tr.afterDispatch': 'после отправки',
  'record.wh.tr.lossSub': 'строк с потерями: {count}',
  'record.wh.tr.lossOnReceipt': 'фиксируются при приёмке',
  'record.wh.tr.travel': 'В пути',
  'record.wh.tr.onTheWay': 'в пути',
  'record.wh.tr.lines': 'Строки перемещения',
  'record.wh.tr.filterWaiting': 'Ожидают приёмки',
  'record.wh.tr.filterLoss': 'С потерями',
  'record.wh.tr.toCell': 'Ячейка в «{warehouse}»',
  'record.wh.tr.lineStatus': 'Статус строки',
  'record.wh.tr.total': 'Итого · позиций: {count}',
  'record.wh.tr.totalStatus': 'принято {counted} из {total}',
  'record.wh.tr.notSent': 'Не отправлено',
  'record.wh.tr.waiting': 'Ожидает приёмки',
  'record.wh.tr.acceptedWithLoss': 'Принято с потерями',
  'record.wh.tr.emptyText': 'Без строк перемещение нельзя отправить.',
  'record.wh.tr.lossPanel': 'Потери в пути',
  'record.wh.tr.pieces': 'Шт',
  'record.wh.tr.noLossYet': 'По пересчитанным строкам потерь нет.',
  'record.wh.tr.noLossFinal': 'Приёмка завершена без потерь в пути.',
  'record.wh.tr.actMissing': 'Потеря — претензия к перевозчику. Акт о потерях с подписью перевозчика API пока не публикует.',
  'record.wh.tr.dispatch.title': 'Отправить перемещение {number}?',
  'record.wh.tr.dispatch.text': '{qty} шт по позициям: {positions} уйдут из «{from}» в «{to}».',
  'record.wh.tr.cancel.title': 'Отменить перемещение {number}?',
  'record.wh.tr.cancel.text': 'Черновик останется в реестре отменённым; остатки не менялись.',
  'record.wh.tr.stage.draft': 'Черновик',
  'record.wh.tr.stage.in_transit': 'В пути',
  'record.wh.tr.stage.partial': 'Получено частично',
  'record.wh.tr.stage.received': 'Получено',
  // --- HR cards on the design system (Employee/Department/Vacancy/LeaveRequest/EmployeeKpi)
  'record.hr.close': 'Закрыть',
  'record.hr.escHint': 'Esc — закрыть без сохранения',
  'record.hr.days': '{days} дн.',
  'record.hr.details': 'Сведения',
  'record.hr.bonus.open': 'Начислить премию…',
  'record.hr.bonus.title': 'Начислить премию — {name}',
  'record.hr.bonus.subtitle': 'Сумму считает сервер: фонд × коэффициент выполнения KPI за период',
  'record.hr.bonus.from': 'Период с',
  'record.hr.bonus.to': 'по',
  'record.hr.bonus.fund': 'Премиальный фонд',
  'record.hr.bonus.fundHelp': 'Обязательно: фонд — решение о деньгах, умолчания у него нет',
  'record.hr.bonus.calculate': 'Рассчитать',
  'record.hr.bonus.settle': 'Начислить {amount}',
  'record.hr.bonus.preview': 'Расчёт сервера',
  'record.hr.bonus.coefficient': 'коэффициент',
  'record.hr.bonus.settled': 'Премия начислена: {amount}',
  'record.hr.emp.loading': 'Загрузка карточки сотрудника',
  'record.hr.emp.sections': 'Разделы карточки сотрудника',
  'record.hr.emp.manager': 'руководитель',
  'record.hr.emp.managerFact': 'Руководитель',
  'record.hr.emp.personnelNumber': 'Таб. №',
  'record.hr.emp.personnelNumberShort': 'таб. № {number}',
  'record.hr.emp.tenure': 'Стаж в компании',
  'record.hr.emp.tenureLine': 'Стаж в компании {tenure} (с {date})',
  'record.hr.emp.startsOn': 'Выходит {date}',
  'record.hr.emp.notStarted': 'ещё не вышел',
  'record.hr.emp.lessThanMonth': 'меньше месяца',
  'record.hr.emp.years': '{n} г.',
  'record.hr.emp.months': '{n} мес.',
  'record.hr.emp.since': 'с {date}',
  'record.hr.emp.orderNo': 'приказ № {number}',
  'record.hr.emp.leaveLeft': 'Остаток отпуска',
  'record.hr.emp.leaveOthers': 'основной · ещё {days} дн. других видов',
  'record.hr.emp.leaveFailed': 'остаток не загрузился',
  'record.hr.emp.leaveNone': 'остаток за год не начислен',
  'record.hr.emp.transfer': 'Перевести…',
  'record.hr.emp.transferred': 'Перевод оформлен с {date}',
  'record.hr.emp.terminate': 'Уволить…',
  'record.hr.emp.terminateConfirm': 'Уволить',
  'record.hr.emp.terminated': 'Увольнение оформлено, последний день {date}',
  'record.hr.emp.assignments': 'История назначений',
  'record.hr.emp.assignmentsFailed': 'Не удалось загрузить историю назначений',
  'record.hr.emp.noAssignmentsText': 'Назначение появляется при приёме и при каждом переводе.',
  'record.hr.emp.salaryNote': 'оклад — в месяц, до НДФЛ',
  'record.hr.emp.period': 'Период',
  'record.hr.emp.event': 'Событие',
  'record.hr.emp.current': 'Текущее',
  'record.hr.emp.events': 'Кадровые события',
  'record.hr.emp.noEvents': 'Кадровых событий пока нет.',
  'record.hr.emp.reportsFailed': 'Не удалось загрузить подчинённых',
  'record.hr.emp.noReportsText': '{name} не руководит ни отделом, ни группой. Подчинённые появятся, если назначить руководителем в оргструктуре.',
  'record.hr.emp.kpiYear': 'KPI за {year} год',
  'record.hr.pdn.oneCall': 'Сервер расшифровывает все четыре поля одним запросом и пишет одну запись в журнал аудита от вашего имени.',
  'record.hr.pdn.hidesIn': 'Значения скроются через 60 с; повторный показ — новая запись в журнале.',
  'record.hr.pdn.empty': 'не заполнено',
  'record.hr.pdn.failed': 'Не удалось показать персональные данные',
  'record.hr.transfer.overline': 'Кадровое перемещение',
  'record.hr.transfer.title': 'Перевести — {name}',
  'record.hr.transfer.now': 'Сейчас: {position} · {department} · {salary}',
  'record.hr.transfer.date': 'Дата перевода',
  'record.hr.transfer.submit': 'Оформить перевод',
  'record.hr.terminate.title': 'Уволить {name}?',
  'record.hr.terminate.lastDay': 'Последний рабочий день',
  'record.hr.terminate.text': 'Учётная запись будет заблокирована, назначение закрыто последним днём.',
  'record.hr.leave.balances': 'Остатки отпусков',
  'record.hr.leave.balancesNote': 'по календарному году · дни',
  'record.hr.leave.balancesFailed': 'Не удалось загрузить остатки',
  'record.hr.leave.noBalancesText': 'Остаток начисляется кадровиком на год.',
  'record.hr.leave.nearest': 'Ближайшая заявка',
  'record.hr.leave.nearestFailed': 'Не удалось загрузить заявки',
  'record.hr.leave.noNearest': 'Предстоящих заявок на отсутствие нет.',
  'record.hr.leave.workingDays': '{days} раб. дн.',
  'record.hr.leave.openRequest': 'Открыть заявку',
  'record.hr.leave.request': 'Заявка',
  'record.hr.leave.title': '{type} {from} — {to}',
  'record.hr.leave.rowMissingTitle': 'Заявку не прочитать',
  'record.hr.leave.rejectOpen': 'Отклонить…',
  'record.hr.leave.rejectTitle': 'Отклонить заявку {name}?',
  'record.hr.leave.rejectConfirm': 'Отклонить заявку',
  'record.hr.leave.rejectText': 'Заявка закроется со статусом «Отклонено»; сотрудник сможет подать новую.',
  'record.hr.leave.stages': 'Этапы заявки',
  'record.hr.leave.submitted': 'Подана',
  'record.hr.leave.period': 'Период',
  'record.hr.leave.calendarDays': '{days} календарных · выход {back}',
  'record.hr.leave.workingDaysFact': 'Рабочих дней',
  'record.hr.leave.workingNote': 'по производственному календарю',
  'record.hr.leave.balanceAfter': 'Остаток по виду',
  'record.hr.leave.balancesTab': 'Баланс отпусков',
  'record.hr.leave.sections': 'Разделы заявки',
  'record.hr.leave.comment': 'Комментарий сотрудника',
  'record.hr.leave.clashesFailed': 'Не удалось загрузить пересечения',
  'record.hr.leave.clashCount': 'Пересечение с отпусками коллег: {count}',
  'record.hr.leave.overlapLabel': 'Отсутствия коллег отдела в период заявки',
  'record.hr.leave.scaleCaption': 'Сотрудник · дни периода',
  'record.hr.leave.thisRequest': 'эта заявка',
  'record.hr.leave.clash': 'пересечение',
  'record.hr.leave.legendClash': 'пересечение — отсутствуют одновременно',
  'record.hr.leave.legendWeekend': 'серые числа шкалы — суббота и воскресенье',
  'record.hr.leave.routeFailed': 'Не удалось построить маршрут',
  'record.hr.leave.approverUser': 'согласует назначенная учётная запись',
  'record.hr.leave.approverRole': 'согласует любой сотрудник роли',
  'record.hr.leave.waiting': 'Ожидает',
  'record.hr.leave.routeNote': 'Маршрут построен по оргструктуре тем же правилом, что при подаче. Решение принимается одним действием — отметок по шагам сервер не ведёт.',
  'record.hr.leave.timesheetTitle': 'Табель {from} — {to}',
  'record.hr.leave.timesheetFailed': 'Не удалось загрузить табель',
  'record.hr.leave.noTimesheetText': 'Табель заполняется при согласовании заявки.',
  'record.hr.timesheet.code.work': 'Я',
  'record.hr.timesheet.code.vacation': 'ОТ',
  'record.hr.timesheet.code.sick': 'Б',
  'record.hr.timesheet.code.day_off': 'ОГ',
  'record.hr.timesheet.code.holiday': 'В',
  'record.hr.timesheet.code.absence': 'НН',
  'record.hr.timesheet.code.business_trip': 'К',
  'record.hr.dept.loading': 'Загрузка оргструктуры',
  'record.hr.dept.sections': 'Разделы отдела',
  'record.hr.dept.structure': 'Структура',
  'record.hr.dept.staff': 'Сотрудники',
  'record.hr.dept.staffTitle': 'Сотрудники отдела',
  'record.hr.dept.staffFailed': 'Не удалось загрузить сотрудников',
  'record.hr.dept.staffMore': 'Показаны первые 100 — полный состав в списке сотрудников с фильтром по отделу.',
  'record.hr.dept.noStaff': 'В отделе нет сотрудников',
  'record.hr.dept.headcount': 'Численность',
  'record.hr.dept.headcountNote': 'работающие, видимые вам',
  'record.hr.dept.headcountFailed': 'численность не загрузилась',
  'record.hr.dept.children': 'Подотделы',
  'record.hr.dept.openVacancies': 'Открытые вакансии',
  'record.hr.dept.vacanciesFailed': 'Не удалось загрузить вакансии',
  'record.hr.dept.noVacancies': 'Открытых вакансий нет.',
  'record.hr.dept.about': 'Об отделе',
  'record.hr.dept.headMeta': 'руководитель',
  'record.hr.dept.partOf': 'входит в',
  'record.hr.dept.root': 'верхний уровень',
  'record.hr.dept.costCenterMeta': 'центр затрат',
  'record.hr.dept.units': '{count} подразделений',
  'record.hr.dept.unit': 'Подразделение',
  'record.hr.dept.cc': 'ЦЗ',
  'record.hr.dept.expandAll': 'Развернуть всё',
  'record.hr.dept.collapseAll': 'Свернуть всё',
  'record.hr.dept.expand': 'Развернуть: {name}',
  'record.hr.dept.collapse': 'Свернуть: {name}',
  'record.hr.dept.treeNote': 'Численность — работающие сотрудники самого узла, без подотделов. Штатного расписания в системе нет.',
  'record.hr.dept.moveOpen': 'Переместить в другой отдел…',
  'record.hr.dept.moveTitle': 'Переместить «{name}»',
  'record.hr.dept.moveSubtitle': 'Поддерево переносится целиком',
  'record.hr.dept.moveToRoot': 'Перенести в корень',
  'record.hr.vac.sections': 'Разделы вакансии',
  'record.hr.vac.stages': 'Статус вакансии',
  'record.hr.vac.open': 'Открыть для откликов',
  'record.hr.vac.opened': 'Вакансия открыта',
  'record.hr.vac.hold': 'Поставить на паузу',
  'record.hr.vac.held': 'Вакансия на паузе',
  'record.hr.vac.openedOn': 'открыта {date}',
  'record.hr.vac.targetMeta': 'цель — до {date}',
  'record.hr.vac.openFact': 'Открыта',
  'record.hr.vac.candidates': 'Откликов',
  'record.hr.vac.candidatesNote': 'всего, включая отказы',
  'record.hr.vac.salaryRange': 'Вилка оклада',
  'record.hr.vac.hiringManager': 'нанимающий менеджер',
  'record.hr.vac.recruiter': 'рекрутер',
  'record.hr.vac.recruiterShort': 'рекрутер {name}',
  'record.hr.vac.board': 'Кандидаты по этапам найма',
  'record.hr.vac.boardFailed': 'Не удалось загрузить кандидатов',
  'record.hr.vac.noApplicationsText': 'Открытых откликов нет. Отказы и нанятые учтены в воронке.',
  'record.hr.vac.columnEmpty': 'Пусто',
  'record.hr.vac.candidate': 'Кандидат {id}',
  'record.hr.vac.cardActions': 'Действия с откликом',
  'record.hr.vac.moveTo': 'На этап «{stage}»',
  'record.hr.vac.rejectOpen': 'Отказать…',
  'record.hr.vac.rejectTitle': 'Отказ кандидату',
  'record.hr.vac.revokeTitle': 'Отозвать согласие на обработку ПДн?',
  'record.hr.vac.revokeText': 'С кандидатом больше нельзя работать, его данные обезличиваются.',
  'record.hr.vac.funnelTitle': 'Воронка найма',
  'record.hr.vac.funnelNote': 'все отклики, включая отказы',
  'record.hr.vac.funnelFailed': 'Не удалось загрузить воронку',
  'record.hr.vac.funnelEmpty': 'Воронка появится с первым откликом.',
  'record.hr.kpi.title': 'KPI · {subject} · {period}',
  'record.hr.kpi.sections': 'Разделы KPI',
  'record.hr.kpi.stages': 'Этапы KPI за период',
  'record.hr.kpi.stageSet': 'Цель поставлена',
  'record.hr.kpi.stagePeriod': 'Период',
  'record.hr.kpi.stageBonus': 'Премия',
  'record.hr.kpi.notSettled': 'не начислена',
  'record.hr.kpi.bonusHidden': 'скрыто правами',
  'record.hr.kpi.overall': 'Итоговое выполнение',
  'record.hr.kpi.overallNote': 'взвешенное, считает сервер',
  'record.hr.kpi.actualOfTarget': 'факт / план',
  'record.hr.kpi.period': 'Период',
  'record.hr.kpi.periods': 'Цели по периодам',
  'record.hr.kpi.linesTitle': 'Показатели за {period}',
  'record.hr.kpi.lines': 'Показатели',
  'record.hr.kpi.failed': 'Не удалось загрузить KPI',
  'record.hr.kpi.noTargetsText': 'Цели на этот период не поставлены.',
  'record.hr.kpi.noPeriod': 'У цели нет периода',
  'record.hr.kpi.met': 'выполнен',
  'record.hr.kpi.below': 'ниже плана',
  'record.hr.kpi.noFact': 'нет факта',
  'record.hr.kpi.recompute': 'Пересчитать факт',
  'record.hr.kpi.recomputed': 'Пересчитано целей: {count}',
  'record.hr.kpi.setActual': 'Задать факт вручную…',
  'record.hr.kpi.actualSaved': 'Факт сохранён',
  'record.hr.kpi.was': 'Было',
  'record.hr.kpi.becomes': 'Стало',
  'record.hr.kpi.manualHelp': 'Только для показателя без источника: пересчёт его не перезапишет.',
  'record.hr.kpi.bonusTitle': 'Премия',
  // ------------------------------------------------------------------ Карточки продаж и финансов (Lead, Contact, Quote, Product, PrimaryDoc, Contract, Payment .dc.html)
  'record.feed.loadError': 'Не удалось загрузить ленту',
  'record.dur.m': '{m} мин',
  'record.dur.hm': '{h} ч {m} мин',
  'record.dur.dh': '{d} дн. {h} ч',
  'record.lead.sections': 'Разделы лида',
  'record.lead.stages': 'Этапы лида',
  'record.lead.stage.since': 'с {at}',
  'record.lead.qualify': 'Квалифицировать',
  'record.lead.convert': 'Конвертировать в сделку',
  'record.lead.convertContinue': 'Конвертировать в сделку…',
  'record.lead.convert.title': 'Конвертировать лид в сделку',
  'record.lead.convert.text': 'Контрагент, контакт и сделка заводятся одной операцией — всё или ничего. Контрагент ищется по ИНН.',
  'record.lead.convert.noFunnel': 'Нет воронки для сделки',
  'record.lead.responded': 'Ответили клиенту',
  'record.lead.call': 'Позвонить',
  'record.lead.mergeContinue': 'Слить с дублем…',
  'record.lead.merge': 'Слить',
  'record.lead.merge.title': 'Пометить этот лид дублем «{title}»?',
  'record.lead.merge.text': 'Этот лид закроется, но не удалится: его метки останутся в отчётах. Недостающие телефон, почта и ИНН перейдут в исходный лид.',
  'record.lead.rejectContinue': 'Отказать…',
  'record.lead.reject': 'Отказать',
  'record.lead.reject.title': 'Отказать по лиду «{title}»?',
  'record.lead.reject.text': 'Лид закроется со статусом «Отклонён». Клиенту ничего не отправляется.',
  'record.lead.reject.placeholder': 'Что сказал клиент, почему не подходит',
  'record.lead.reject.help': 'Попадает в отчёт об отказах по источникам — по нему решают, продолжать ли кампанию.',
  'record.lead.reject.missing': 'Без причины отказ не сохранить',
  'record.lead.converted': 'Лид сконвертирован: контрагент, контакт и сделка заведены.',
  'record.lead.isDuplicate': 'Лид помечен дублем другого и закрыт.',
  'record.lead.openOriginal': 'Открыть исходный',
  'record.lead.inn': 'ИНН {inn}',
  'record.lead.notCounterparty': 'ещё не контрагент',
  'record.lead.unassigned': 'Не назначен',
  'record.lead.fact.source': 'Источник и канал',
  'record.lead.fact.received': 'Получен',
  'record.lead.fact.sla': 'SLA первого отклика',
  'record.lead.fact.responsible': 'Ответственный',
  'record.lead.fact.territory': 'Территория',
  'record.lead.sla.left': 'Осталось {duration}',
  'record.lead.sla.over': 'Просрочено на {duration}',
  'record.lead.sla.met': 'Ответили за {duration}',
  'record.lead.sla.aria': 'SLA первого отклика: {text}',
  'record.lead.sla.until': 'до {at}',
  'record.lead.sla.breached': 'просрочен',
  'record.lead.sla.done': 'выполнен',
  'record.lead.next.missingHint': 'Пока идёт SLA, у лида должен быть следующий шаг — иначе клиент ждёт ответа, который никто не планирует.',
  'record.lead.composer.comment': 'Комментарий к лиду',
  'record.lead.lastEvents': 'Последние события',
  'record.lead.allFeed': 'Вся лента',
  'record.lead.feed.empty': 'Событий пока нет',
  'record.lead.feed.emptyText': 'Звонки, письма и смена статуса появятся здесь — начните с первого звонка, пока идёт SLA.',
  'record.lead.tab.similar': 'Похожие',
  'record.lead.similar': 'Похожие лиды',
  'record.lead.similar.checked': 'Проверено по ИНН, телефону и почте',
  'record.lead.similar.none': 'Совпадений не найдено',
  'record.lead.similar.noneText': 'Других лидов с этим ИНН, телефоном или почтой нет.',
  'record.lead.similar.error': 'Не удалось проверить совпадения',
  'record.lead.similar.by.phone': 'Возможный дубль: тот же телефон',
  'record.lead.similar.by.email': 'Возможный дубль: та же почта',
  'record.lead.similar.by.inn': 'Возможный дубль: тот же ИНН',
  'record.lead.counterparties': 'Похожие контрагенты',
  'record.lead.counterparties.none': 'Контрагентов с этим ИНН, телефоном или почтой нет — при конвертации будет заведён новый.',
  'record.lead.utm': 'Источник и метки',
  'record.lead.details': 'Сведения',
  'record.contact.sections': 'Разделы контакта',
  'record.contact.call': 'Позвонить',
  'record.contact.mail': 'Написать письмо',
  'record.contact.task': 'Новая задача',
  'record.contact.primary': 'Основной контакт',
  'record.contact.delete': 'Удалить контакт',
  'record.contact.delete.title': 'Удалить контакт «{name}»?',
  'record.contact.delete.text': 'Контакт участвует в сделках: {count}. Пока он участник открытой сделки, сервер удаление отклонит — сначала замените его в сделке. В закрытых сделках удалённый контакт останется помеченным.',
  'record.contact.fact.phones': 'Телефоны',
  'record.contact.mobile': 'мобильный',
  'record.contact.work': 'рабочий',
  'record.contact.fact.last': 'Последний контакт',
  'record.contact.fact.noTouches': 'контактов ещё не было',
  'record.contact.deals': 'Сделки, где он участник',
  'record.contact.deals.empty': 'Контакт пока не участвует в сделках',
  'record.contact.deals.emptyText': 'Добавьте его участником в сделку его компании и укажите роль — тогда звонки с ним будут видны в сделке.',
  'record.contact.col.deal': 'Сделка',
  'record.contact.lastEvents': 'Последние события',
  'record.contact.feed.empty': 'Событий пока нет',
  'record.contact.feed.emptyText': 'Звонки, письма и комментарии по контакту появятся здесь.',
  'record.contact.next.missingHint': 'Назначьте следующий шаг, чтобы разговор не остановился.',
  'record.contact.composer.comment': 'Комментарий к контакту',
  'record.contact.colleagues': 'Коллеги в компании',
  'record.contact.colleagues.none': 'Других контактов у компании нет.',
  'record.contact.colleagues.error': 'Не удалось загрузить коллег',
  'record.contact.callTo': 'Позвонить: {name}',
  'record.contact.mailTo': 'Написать: {name}',
  'record.contact.tab.details': 'Детали',
  'record.contact.details': 'Сведения',
  'record.quote.title': 'Коммерческое предложение',
  'record.quote.sections': 'Разделы КП',
  'record.quote.stages': 'Этапы КП',
  'record.quote.deal': 'сделка',
  'record.quote.dealLink': 'открыть',
  'record.quote.from': 'от {org}',
  'record.quote.needsApproval': 'На согласовании',
  'record.quote.send': 'Отправить клиенту',
  'record.quote.sent': 'КП отправлено клиенту.',
  'record.quote.why.empty': 'Нельзя отправить: в КП нет позиций',
  'record.quote.why.approval': 'Отправить можно после решения по согласованию',
  'record.quote.submitApproval': 'На согласование',
  'record.quote.approval.submitted': 'КП отправлено на согласование.',
  'record.quote.approval.notRequired': 'Пороги не перейдены — согласование не нужно, КП можно отправлять.',
  'record.quote.markAccepted': 'Отметить «Принято»',
  'record.quote.markRejected': 'Отклонено',
  'record.quote.accepted': 'КП принято: счёт появится в биллинге после обработки события.',
  'record.quote.pendingAlert': 'Скидка или сумма перешли порог — отправить клиенту можно после согласования.',
  'record.quote.stage.noLines': 'нет позиций',
  'record.quote.stage.onApproval': 'на согласовании',
  'record.quote.stage.answer': 'Принято / Отклонено',
  'record.quote.stage.until': 'ответ до {date}',
  'record.quote.fact.total': 'Сумма с НДС',
  'record.quote.fact.totalSub': 'без НДС {net} · НДС {vat}',
  'record.quote.fact.discount': 'Скидка',
  'record.quote.fact.discountSub': '{share} % от КП, без НДС',
  'record.quote.noDiscount': 'нет',
  'record.quote.fact.validUntil': 'Действует до',
  'record.quote.fact.sent': 'Отправлено',
  'record.quote.notSent': 'не отправлено',
  'record.quote.locked': 'Содержимое зафиксировано отправкой',
  'record.quote.lockedApproval': 'Правка закрыта на время согласования',
  'record.quote.lines.empty': 'В КП нет позиций',
  'record.quote.lines.emptyText': 'Позиции переносятся из сделки при создании КП. Без позиций КП не отправить.',
  'record.quote.productUnknown': 'Товар не найден',
  'record.quote.col.price': 'Цена без НДС',
  'record.quote.col.discount': 'Скидка',
  'record.quote.col.net': 'Сумма без НДС',
  'record.quote.col.vat': 'НДС',
  'record.quote.col.total': 'Сумма с НДС',
  'record.quote.approval': 'Согласование скидки',
  'record.quote.approval.none': 'Не запрашивалось',
  'record.quote.approval.noneText': 'Согласование по КП не запрашивалось. Порог проверяется при отправке.',
  'record.quote.approval.error': 'Не удалось загрузить согласование',
  'record.quote.approval.byRole': 'Согласующий по роли',
  'record.quote.approval.waiting': 'ждёт решения',
  'record.quote.approval.ahead': 'после предыдущего шага',
  'record.quote.approval.status.pending': 'Ждёт решения',
  'record.quote.approval.status.approved': 'Согласовано',
  'record.quote.approval.status.rejected': 'Отклонено',
  'record.quote.approval.status.cancelled': 'Отозвано',
  'record.quote.approval.step.approved': 'Согласовано',
  'record.quote.approval.step.rejected': 'Отклонено',
  'record.quote.approval.step.skipped': 'Пропущено',
  'record.quote.approval.step.waiting': 'Ждёт',
  'record.quote.approval.step.ahead': 'Впереди',
  'record.quote.tab.details': 'Сведения',
  'record.quote.details': 'Поля КП',
  'record.product.sections': 'Разделы товара',
  'record.product.active': 'Активен',
  'record.product.inactive': 'Снят с продажи',
  'record.product.fact.free': 'Свободно всего',
  'record.product.fact.freeSub': 'из {quantity} · в резерве {reserved}',
  'record.product.noStock': 'остатков нет',
  'record.product.belowMin': 'ниже минимума',
  'record.product.belowMinAlert': 'Свободно {free} при минимуме {min} — пора пополнить запас.',
  'record.product.minNotSet': 'не задан',
  'record.product.stock': 'Остатки по складам',
  'record.product.stock.empty': 'Остатков нет ни на одном складе',
  'record.product.stock.emptyText': 'Остаток появится после приёмки.',
  'record.product.stock.error': 'Не удалось загрузить остатки',
  'record.product.stock.forbidden': 'Остатки складов вам недоступны',
  'record.product.stockTotal': 'Итого',
  'record.product.free': 'Свободно',
  'record.product.tab.details': 'Характеристики',
  'record.product.details': 'Поля товара',
  'record.doc.sections': 'Разделы документа',
  'record.doc.stages': 'Этапы документа',
  'record.doc.from': 'от {date}',
  'record.doc.seller': 'продавец',
  'record.doc.buyer': 'покупатель',
  'record.doc.toInvoice': 'к счёту',
  'record.doc.contract': 'договор',
  'record.doc.stage.draft': 'Черновик',
  'record.doc.stage.issued': 'Выставлен',
  'record.doc.stage.edi': 'Отправлен в ЭДО',
  'record.doc.stage.signed': 'Подписан',
  'record.doc.stage.mismatch': 'подпись не сходится',
  'record.doc.fact.total': 'Сумма с НДС',
  'record.doc.fact.lines': 'строк: {count}',
  'record.doc.fact.vat': 'НДС',
  'record.doc.fact.net': 'без НДС {amount}',
  'record.doc.fact.date': 'Дата документа',
  'record.doc.fact.basis': 'Основание',
  'record.doc.sig.draft': 'Подписать можно после того, как документ будет выставлен.',
  'record.doc.sig.unsignedText': 'Документ выставлен, подписи ещё нет — сверять содержимое пока не с чем.',
  'record.doc.sig.okText': 'Подписан {at} · содержимое не менялось',
  'record.doc.signature': 'Подпись и ЭДО',
  'record.doc.original': 'оригинал',
  'record.doc.tab.lines': 'Строки',
  'record.doc.tab.signatures': 'Подписи и ЭДО',
  'record.doc.lines': 'Строки документа',
  'record.doc.lines.hint': 'цены без НДС · НДС построчно',
  'record.doc.lines.emptyText': 'Строки приходят из отгрузки при выпуске документа.',
  'record.doc.lines.notSigned': 'Текущие строки не совпадают с подписанной версией',
  'record.doc.col.net': 'Без НДС',
  'record.doc.reissueContinue': 'Перевыпустить…',
  'record.doc.reissue.overline': 'Перевыпуск документа',
  'record.doc.reissue.title': 'Перевыпустить {number}',
  'record.doc.reissue.text': 'Перевыпуск к {number} от {date}: новый документ сошлётся на оригинал, оригинал будет аннулирован.',
  'record.doc.reissue.placeholder': 'Что и почему исправлено',
  'record.doc.reissue.help': 'Обязательна: без причины перевыпуск неотличим от постороннего документа с теми же строками.',
  'record.doc.reissue.missing': 'Укажите причину перевыпуска',
  'record.doc.ediContinue': 'Отметить отправку по ЭДО…',
  'record.doc.edi.title': 'Отправка {number} по ЭДО',
  'record.doc.edi.help': 'Идентификатор сообщения у оператора — по нему потом ищут, дошёл ли документ.',
  'record.doc.edi.missing': 'Укажите идентификатор сообщения',
  'record.doc.cancelContinue': 'Аннулировать…',
  'record.doc.cancel.title': 'Аннулировать {number}?',
  'record.doc.cancel.text': 'Документ останется в реестре аннулированным.',
  'record.doc.cancelled': 'Документ аннулирован.',
  'record.doc.reissues.error': 'Не удалось загрузить цепочку замен',
  'record.contract.title': 'Договор {number}',
  'record.contract.sections': 'Разделы договора',
  'record.contract.stages': 'Жизненный цикл договора',
  'record.contract.organization': 'организация {org}',
  'record.contract.currency': 'валюта',
  'record.contract.openFrom': 'с {date}, бессрочный',
  'record.contract.since': 'с {date}',
  'record.contract.until': 'до {date}',
  'record.contract.stage.closed': 'Завершён / Расторгнут',
  'record.contract.fact.term': 'Срок действия',
  'record.contract.daysLeft': 'осталось {days} дн.',
  'record.contract.expiredDays': 'срок истёк {days} дн. назад',
  'record.contract.days': '{days} дн.',
  'record.contract.noAmount': 'без суммы',
  'record.contract.activateContinue': 'Ввести в действие…',
  'record.contract.activate.overline': 'Ввод в действие',
  'record.contract.activate.openHelp': 'Пусто — бессрочный договор',
  'record.contract.activate.missing': 'Укажите дату подписания',
  'record.contract.prolongContinue': 'Продлить…',
  'record.contract.prolong.overline': 'Продление договора',
  'record.contract.prolong.title': 'Продлить договор {number}',
  'record.contract.prolong.current': 'Текущая дата окончания',
  'record.contract.prolong.help': 'Только вперёд: новая дата позже текущей. Сокращение срока — это расторжение.',
  'record.contract.prolong.missing': 'Укажите новую дату окончания',
  'record.contract.terminateContinue': 'Расторгнуть…',
  'record.contract.terminate.title': 'Расторгнуть договор {number}?',
  'record.contract.terminate.text': 'С даты расторжения по договору нельзя оформить заказ. Долги по выставленным счетам не списываются.',
  'record.contract.terminate.date': 'Дата расторжения',
  'record.contract.terminate.help': 'Уходит в журнал: колонки под причину в договоре нет.',
  'record.contract.terminate.missing': 'Укажите дату и причину',
  'record.contract.terminate.irreversible': 'Действие нельзя отменить — возобновить отношения можно только новым договором.',
  'record.contract.terminated': 'Договор расторгнут.',
  'record.contract.tab.documents': 'Документы по договору',
  'record.contract.invoices.empty': 'Счетов по договору нет',
  'record.contract.documents.empty': 'Первичных документов по договору нет',
  'record.contract.documents.error': 'Не удалось загрузить документы',
  'record.contract.documents.forbidden': 'Счета и документы вам недоступны',
  'record.contract.col.date': 'Дата',
  'record.contract.col.total': 'Сумма с НДС',
  'record.contract.col.due': 'К оплате',
  'record.pay.title': 'Платёж',
  'record.pay.sections': 'Разделы платежа',
  'record.pay.stages': 'Этапы обработки платежа',
  'record.pay.stage.pending': 'Ожидает подтверждения',
  'record.pay.stage.confirmed': 'Подтверждён',
  'record.pay.stage.partial': 'Разнесён частично',
  'record.pay.stage.matched': 'Разнесён',
  'record.pay.noPayer': 'Плательщик не распознан',
  'record.pay.purposeQuoted': 'назначение «{purpose}»',
  'record.pay.confirm': 'Подтвердить платёж',
  'record.pay.confirmed': 'Платёж подтверждён — его можно разносить.',
  'record.pay.autoMatch': 'Подобрать счета',
  'record.pay.matched': 'Разнесено на счета: {count}.',
  'record.pay.notMatched': 'Автосверка ничего не подобрала — разнесите вручную.',
  'record.pay.reverseContinue': 'Сторнировать…',
  'record.pay.reverse': 'Сторнировать',
  'record.pay.reverse.title': 'Сторнировать платёж {number}?',
  'record.pay.reverse.text': 'Разнесения на {allocated} будут сняты, суммы вернутся счетам. Строка платежа останется в журнале со статусом «Сторнирован».',
  'record.pay.reversed': 'Платёж сторнирован.',
  'record.pay.reversedText': 'Платёж сторнирован: разнесения сняты.',
  'record.pay.fact.amount': 'Сумма платежа',
  'record.pay.fact.allocated': 'Разнесено',
  'record.pay.fact.unallocated': 'Неразнесённый остаток',
  'record.pay.unallocatedShare': 'не разнесено — {share} %',
  'record.pay.fullyAllocated': 'разнесён полностью',
  'record.pay.fact.account': 'Счёт получателя',
  'record.pay.fact.date': 'Дата платежа',
  'record.pay.valueDate': 'зачислен {date}',
  'record.pay.tab.alloc': 'Разнесение по счетам',
  'record.pay.tab.details': 'Реквизиты платежа',
  'record.pay.details': 'Реквизиты платёжного поручения',
  'record.pay.payerAccount': 'Счёт плательщика',
  'record.pay.alloc.title': 'Неоплаченные счета плательщика',
  'record.pay.alloc.count': 'счетов: {count}',
  'record.pay.alloc.empty': 'У {payer} нет неоплаченных счетов',
  'record.pay.alloc.emptyText': 'Неразнесённый остаток остаётся авансом контрагента и зачтётся в следующий счёт.',
  'record.pay.alloc.noPayer': 'Плательщик не определён',
  'record.pay.alloc.noPayerText': 'Платёж без контрагента разнести нельзя: он в очереди ручной сверки на экране «Сверка с банком».',
  'record.pay.alloc.forbidden': 'Счета вам недоступны',
  'record.pay.alloc.error': 'Не удалось загрузить счета плательщика',
  'record.pay.alloc.notAllocatable': 'Платёж нельзя разносить в его текущем состоянии — например, он ещё не подтверждён.',
  'record.pay.alloc.summary': 'Разнесено {allocated} из {amount} · остаток {left}',
  'record.pay.alloc.advance': 'Остаток {left} останется авансом контрагента.',
  'record.pay.col.invoice': 'Счёт',
  'record.pay.col.total': 'Сумма счёта',
  'record.pay.col.outstanding': 'Остаток долга',
  'record.pay.col.allocate': 'Разнести',
  'record.pay.allocate': 'Разнести',
  'record.pay.amountFor': 'Сумма на счёт {number}',
  // ---------- рабочие и аналитические экраны (партия C: согласования, задачи, уведомления, отчёты, рассылки)
  'wa.cancel': 'Отмена',
  'approvals.lead': 'Решения, которые ждут вас: скидки, отсрочки, документы и заявления, превысившие пороги согласования.',
  'approvals.loading': 'Загрузка согласований',
  'approvals.forbidden.title': 'Раздел «Согласования» вам недоступен',
  'approvals.forbidden.text': 'Согласования доступны ролям с правом утверждения. Если вы замещаете руководителя, попросите его оформить замещение — его очередь появится у вас на время замещения.',
  'approvals.toMyDay': 'В «Мой день»',
  'approvals.error.title': 'Не удалось загрузить очередь согласований',
  'approvals.error.text': 'Сервис согласований не ответил. Решения, принятые до сбоя, сохранены.',
  'approvals.tab.queue': 'Моя очередь',
  'approvals.tab.delegation': 'Замещение',
  'approvals.queue.emptyText': 'Новые запросы придут уведомлением и появятся здесь.',
  'approvals.queue.setupDelegation': 'Настроить замещение',
  'approvals.queue.noMatch': 'Под условия поиска ничего не подошло.',
  'approvals.queue.footer': 'Решение по строке сразу уходит инициатору и следующему шагу цепочки.',
  'approvals.search': 'Поиск по очереди',
  'approvals.searchPlaceholder': 'Документ, клиент, №',
  'approvals.chip.long': 'Ждут дольше суток',
  'approvals.bulk.label': 'Действия с выбранными запросами',
  'approvals.bulk.selected': 'Выбрано {count}',
  'approvals.bulk.approve': 'Согласовать {count}',
  'approvals.bulk.clear': 'Снять выделение',
  'approvals.bulk.hint': 'Отклонять — по одному, с причиной.',
  'approvals.selectAll': 'Выбрать все запросы',
  'approvals.select': 'Выбрать {name}',
  'approvals.col.document': 'Документ',
  'approvals.col.amount': 'Сумма',
  'approvals.col.waits': 'Ждёт',
  'approvals.col.step': 'Шаг цепочки',
  'approvals.col.decision': 'Решение',
  'approvals.waitLong': '{time} — дольше суток',
  'approvals.since': 'с {at}',
  'approvals.stepOf': 'Шаг {step} из {total}',
  'approvals.previousStep': 'до этого — {name} ✓',
  'approvals.rejectOpen': 'Отклонить…',
  'approvals.decideTitle': 'Решение по документу {name}',
  'approvals.commentPlaceholder': 'Например: маржа ниже порога, готов на меньшую скидку при авансе',
  'approvals.needCommentFor': 'Укажите причину отказа — её увидит {name}',
  'approvals.commentHelp': 'Для отказа обязателен, для согласования — по желанию.',
  'approvals.approveWithComment': 'Согласовать с комментарием',
  'approvals.keys': 'Ctrl ↵ — отклонить · Esc — отмена',
  'approvals.byRole': 'согласующий по роли',
  'approvals.leaveDays': '{days} раб. дн.',
  'approvals.wait.minutes': '{count} мин',
  'approvals.wait.hours': '{count} ч',
  'approvals.wait.days': '{count} дн.',
  'approvals.delegation.badge': 'Замещение {period}: {name}',
  'approvals.delegation.error': 'Не удалось загрузить замещения',
  'approvals.delegation.planned': 'Запланировано',
  'approvals.delegation.past': 'Прошлые замещения',
  'approvals.delegation.noPast': 'Прошлых замещений нет.',
  'approvals.delegation.thresholdsNote': 'Пороги, при которых запрос попадает к вам, задаёт администратор в разделе «Пороги согласования». Здесь меняется только то, кто решает в ваше отсутствие.',
  'approvals.delegation.revokeAsk': 'Отозвать…',
  'approvals.delegation.revokeTitle': 'Отозвать замещение — {name}?',
  'approvals.delegation.revokeText': 'Право подписи вернётся к вам сразу. Запись останется в истории: кто подписывал в эти дни, должно быть видно и через год.',
  'approvals.delegation.new': 'Новое замещение',
  'approvals.delegation.noDirectory': 'Выбрать заместителя не из чего',
  'approvals.delegation.noDirectoryText': 'Заместитель — учётная запись, а справочник пользователей открыт только правом «Пользователи». Попросите администратора оформить замещение или выдать это право.',
  'approvals.delegation.toHelp': 'Только действующие учётные записи. Роли заместителю не передаются — только ваша очередь.',
  'approvals.delegation.from': 'С',
  'approvals.delegation.until': 'По',
  'approvals.delegation.untilHelp': 'Пусто — до отзыва.',
  'approvals.delegation.badRange': 'Дата окончания раньше начала',
  'approvals.delegation.info': 'Решения заместителя попадут в историю документов с его именем; принятое заместителем решение отменить нельзя.',
  'approvals.delegation.notify': 'Заместитель увидит вашу очередь с первого дня срока',
  'approvals.delegation.save': 'Сохранить замещение',
  'approvals.delegation.fromOpen': 'с {from}, бессрочно',
  'tasks.lead': 'Ваши открытые задачи. Просроченные всегда сверху; X — отметить выбранную выполненной.',
  'tasks.forbidden.title': 'Задачи вам недоступны',
  'tasks.forbidden.text': 'Нет права на активности. Его выдаёт руководитель или администратор.',
  'tasks.error.title': 'Не удалось загрузить задачи',
  'tasks.error.text': 'Сервер не ответил. Отметки «Выполнено», сделанные до сбоя, сохранены — повторите запрос.',
  'tasks.noEmployeeCard.text': 'Задачи назначаются сотрудникам, а эта учётная запись не связана с карточкой сотрудника — поэтому задач у неё нет и быть не может. Связать учётную запись с сотрудником может администратор.',
  'tasks.segment': 'Период',
  'tasks.seg.all': 'Все открытые',
  'tasks.seg.today': 'Сегодня',
  'tasks.seg.overdue': 'Просрочено',
  'tasks.seg.upcoming': 'Предстоящие',
  'tasks.kind.call': 'Звонки',
  'tasks.kind.meeting': 'Встречи',
  'tasks.kind.email': 'Письма',
  'tasks.kind.task': 'Задачи',
  'tasks.kind.note': 'Заметки',
  'tasks.search': 'Поиск задач',
  'tasks.loading': 'Загрузка задач',
  'tasks.emptyText': 'Просроченных тоже нет. Новые задачи появятся здесь, как только их поставят.',
  'tasks.emptyFiltered': 'Под этот отбор задач нет',
  'tasks.emptyFilteredText': 'Открытые задачи есть в других группах.',
  'tasks.showAll': 'Показать все · {count}',
  'tasks.list': 'Список задач',
  'tasks.group.overdue': 'Просрочено · {count}',
  'tasks.group.today': 'Сегодня · {count}',
  'tasks.group.tomorrow': 'Завтра · {count}',
  'tasks.group.later': 'Позже и без срока · {count}',
  'tasks.overline': 'Задача · {kind}',
  'tasks.overdueFlag': 'срок прошёл',
  'tasks.body': 'Описание',
  'tasks.related': 'Связанная запись',
  'tasks.today': 'Сегодня',
  'tasks.tomorrow': 'Завтра',
  'notifications.lead': 'События по вашим записям, упоминания коллег и сообщения системы. Непрочитанные выделены и отмечены точкой.',
  'notifications.forbidden.title': 'Уведомления вам недоступны',
  'notifications.forbidden.text': 'Нет права на центр уведомлений. Его выдаёт администратор.',
  'notifications.error.title': 'Не удалось загрузить уведомления',
  'notifications.error.text': 'Сервер не ответил. Отметки «Прочитано» не изменились; новые уведомления продолжат приходить.',
  'notifications.show': 'Показать',
  'notifications.seg.all': 'Все',
  'notifications.seg.unread': 'Непрочитанные',
  'notifications.seg.mention': 'Упоминания',
  'notifications.kind.info': 'Система',
  'notifications.kind.warning': 'Предупреждения',
  'notifications.kind.task': 'Задачи',
  'notifications.kind.approval': 'Согласования',
  'notifications.kind.mention': 'Упоминания',
  'notifications.kind.order': 'Заказы',
  'notifications.loading': 'Загрузка уведомлений',
  'notifications.emptyText': 'Новые события появятся здесь сразу — живая доставка не требует обновлять страницу.',
  'notifications.emptyFiltered': 'Новых уведомлений нет',
  'notifications.emptyFilteredText': 'Под этот отбор ничего нет; всего уведомлений — {count}.',
  'notifications.showAll': 'Показать все · {count}',
  'notifications.feed': 'Лента уведомлений',
  'notifications.footer': 'Уведомление открывает запись; ответить на упоминание можно в её обсуждении.',
  'notifications.unreadMark': 'Не прочитано',
  'notifications.open': 'Открыть',
  'notifications.day.today': 'Сегодня · {count}',
  'notifications.day.yesterday': 'Вчера, {date} · {count}',
  'notifications.day.earlier': 'Ранее · {count}',
  'notifications.settings.open': 'Настройки доставки',
  'notifications.settings.title': 'Куда приходят уведомления',
  'notifications.settings.lead': 'В центре уведомлений видно всё и всегда. Почту можно включить по видам — письмо придёт, даже если CRM не открыта.',
  'notifications.settings.loading': 'Загрузка настроек',
  'notifications.settings.address': 'Письма уходят на {address}',
  'notifications.settings.noAddress': 'В учётной записи нет адреса почты — письма отправлять некуда. Адрес указывает администратор.',
  'notifications.settings.mailOff': 'Почта компании сейчас не подключена: письма не уходят и отмечаются отказом. Подключает администратор.',
  'notifications.settings.table': 'Каналы по видам уведомлений',
  'notifications.settings.kind': 'Вид',
  'notifications.settings.inApp': 'В центре',
  'notifications.settings.email': 'На почту',
  'notifications.settings.inAppFor': '{kind}: в центре уведомлений (всегда)',
  'notifications.settings.emailFor': '{kind}: на почту',
  'notifications.settings.save': 'Сохранить',
  'notifications.settings.saved': 'Сохранено',
  'notifications.settings.unsubscribeNote': 'В каждом письме есть ссылка «Отписаться» — она выключает почту по своему виду без входа в систему.',
  'notifications.kind.task_assigned': 'Назначенные задачи',
  'notifications.settings.push': 'Push',
  'notifications.settings.pushFor': '{kind}: push в браузер и на телефон',
  'notifications.settings.pushDevices': 'Push уходит на устройств: {count}',
  'notifications.settings.noPushDevices': 'Push пока некуда доставлять: включите уведомления в браузере ниже или войдите в мобильное приложение.',
  'notifications.push.title': 'Уведомления в браузере',
  'notifications.push.enable': 'Включить уведомления в этом браузере',
  'notifications.push.disable': 'Выключить',
  'notifications.push.on': 'В этом браузере уведомления включены — они придут и при закрытой вкладке CRM.',
  'notifications.push.notConnected': 'Уведомления в браузере не подключены администратором (нет ключей VAPID).',
  'notifications.push.unsupported': 'Этот браузер не умеет push-уведомления (или CRM открыта не по https).',
  'notifications.push.denied': 'Уведомления для сайта CRM запрещены в браузере. Разрешить их можно только в настройках сайта в самом браузере.',
  'notifications.push.failed': 'Не удалось включить уведомления в браузере. Повторите попытку.',
  'notifications.push.devices': 'Мои устройства',
  'notifications.push.disabled': 'отключено: {reason}',
  'notifications.push.remove': 'Удалить устройство {device}',
  'notifications.push.removeShort': 'Удалить',
  'notifications.push.channel.webpush': 'Браузер',
  'notifications.push.channel.fcm': 'Android (FCM)',
  'notifications.push.channel.rustore': 'Android (RuStore)',
  'rk.noValue': 'нет данных',
  'rk.error.text': 'Сервер не ответил. Остальные блоки актуальны.',
  'rk.days': '{days} дн.',
  'rk.quarter': '{q} кв. {year}',
  'rk.period.step': 'Шаг периода',
  'rk.period.month': 'Месяц',
  'rk.period.quarter': 'Квартал',
  'rk.period.year': 'Год',
  'rk.period.prev': 'Предыдущий период',
  'rk.period.next': 'Следующий период',
  'sr.total': 'Итого',
  'sr.cut': 'Разрез',
  'sr.dim.PRODUCT': 'Товар',
  'sr.dim.PRODUCT_CATEGORY': 'Категория',
  'sr.dim.EMPLOYEE': 'Менеджер',
  'sr.dim.COUNTERPARTY': 'Клиент',
  'sr.dim.DEPARTMENT': 'Отдел',
  'sr.dim.TERRITORY': 'Территория',
  'sr.empty.title': 'За {period} данных пока нет',
  'sr.empty.text': 'Отгрузок, сделок и затрат на привлечение за период нет.',
  'sr.empty.prev': 'Открыть {period}',
  'sr.fact.revenue': 'Выручка без НДС',
  'sr.fact.margin': 'Валовая прибыль',
  'sr.fact.marginPct': 'маржа {pct}',
  'sr.fact.won': 'Выиграно сделок',
  'sr.fact.cycle': 'Цикл выигранной сделки',
  'sr.fact.cycleSub': 'медиана · среднее {avg}',
  'sr.fact.lost': 'Проиграно',
  'sr.fact.lostSub': 'на {sum} · чаще всего — {reason}',
  'sr.pnl.title': 'Прибыли и убытки — {cut}',
  'sr.pnl.noVat': 'суммы без НДС',
  'sr.pnl.gross': 'Валовая прибыль',
  'sr.pnl.share': 'Доля выручки',
  'sr.pnl.shareOf': 'Доля выручки {pct}',
  'sr.pnl.unassigned': 'Не указано',
  'sr.pnl.footer': 'Себестоимость — снимок на дату сделки. Маржа строки без себестоимости — прочерк, а не ноль.',
  'sr.pnl.noNames': 'У этого разреза нет своего справочника — строки подписаны идентификатором.',
  'sr.pnl.error': 'P&L не построился',
  'sr.pnl.empty': 'За период продаж нет',
  'sr.funnel.title': 'Конверсия воронки по этапам',
  'sr.funnel.none': 'Воронок нет',
  'sr.funnel.noneText': 'Воронку заводит администратор в разделе «Воронки и этапы».',
  'sr.funnel.error': 'Конверсия не посчитана',
  'sr.funnel.empty': 'В воронке нет этапов',
  'sr.cycle.error': 'Цикл сделки не посчитан',
  'sr.cycle.deals': 'по {count} выигранным сделкам',
  'sr.cycle.perStage': 'Дней на этапе, в среднем',
  'sr.cac.title': 'CAC и LTV/CAC по каналам',
  'sr.cac.error': 'CAC не посчитан',
  'sr.cac.empty': 'Новых клиентов за период нет',
  'sr.cac.new': 'Новых',
  'sr.cac.noChannel': 'Канал не указан',
  'sr.cac.pays': 'окупается',
  'sr.cac.edge': 'на грани',
  'sr.cac.loss': 'не окупается',
  'sr.cac.footer': 'CAC — затраты канала за период ÷ новые клиенты. LTV — по марже, а не по выручке. Канал без затрат — прочерк, а не бесплатные клиенты.',
  'sr.cac.thresholds': 'LTV/CAC от 3 — окупается, от 1 до 3 — на грани, меньше 1 — не окупается.',
  'sr.losses.count': '{count} сделок · {sum}',
  'sr.losses.by': 'Длина полосы',
  'sr.losses.byCount': 'По числу',
  'sr.losses.byAmount': 'По сумме',
  'sr.losses.footer': 'Причину выбирает менеджер при закрытии сделки, из справочника причин.',
  'sr.losses.error': 'Причины проигрыша не загрузились',
  'sr.losses.empty': 'Проигранных сделок за период нет',
  'fr.lead': 'Сколько нам должны и когда, и сколько денег пришло и ожидается. Факт и прогноз — разные ряды и не складываются.',
  'fr.loading': 'Загрузка финансовых отчётов',
  'fr.ar.title': 'Дебиторка по срокам',
  'fr.ar.count': '{count} клиентов',
  'fr.ar.openInvoices': 'Открыть счета',
  'fr.ar.forbidden': 'Дебиторка вам недоступна',
  'fr.ar.error': 'Дебиторка не загрузилась',
  'fr.ar.empty': 'Неоплаченных счетов нет',
  'fr.ar.emptyText': 'Дебиторка появится с первым счётом, оплата по которому ещё не пришла.',
  'fr.ar.mixedCurrency': 'Счета в нескольких валютах: итоги по корзинам не складываются — сложить рубли с евро значит выдумать курс. Суммы видны по каждому клиенту.',
  'fr.ar.overdueFlag': 'Просрочено {sum} · {pct} · {count} клиентов',
  'fr.ar.buckets': 'Дебиторка по корзинам',
  'fr.ar.term': 'Срок',
  'fr.ar.shareBar': 'Доля от всей дебиторки',
  'fr.ar.share': 'Доля',
  'fr.ar.clients': 'Клиентов',
  'fr.ar.totalNote': 'клиент с несколькими счетами может попасть в разные сроки',
  'fr.ar.debtors': 'Должники — по сумме просрочки',
  'fr.ar.noOverdue': 'Просроченных долгов нет.',
  'fr.ar.debtTotal': 'Долг всего',
  'fr.bucket.notYetDue': 'Не наступил срок',
  'fr.dds.title': 'Движение денег',
  'fr.dds.forbidden': 'Движение денег вам недоступно',
  'fr.dds.chooseOrg': 'Выберите организацию',
  'fr.dds.chooseOrgText': 'Деньги считаются по юрлицу. Организаций несколько, и первая попавшаяся показала бы чужие деньги — выберите, чьи смотреть.',
  'fr.dds.legend': 'Обозначения графика',
  'fr.dds.fact': 'Факт по выпискам — {period}',
  'fr.dds.raw': 'Прогноз «сырой» — все ожидаемые платежи, 6 недель',
  'fr.dds.weighted': 'Прогноз «взвешенный» — с вероятностью, 6 недель',
  'fr.dds.factShort': 'факт',
  'fr.dds.rawShort': 'прогноз сырой',
  'fr.dds.weightedShort': 'прогноз взвешенный',
  'fr.dds.thousands': 'тыс. {currency}',
  'fr.dds.factTitle': 'Факт — {period}',
  'fr.dds.planTitle': 'Прогноз на 6 недель',
  'fr.dds.factTable': 'Факт движения денег по статьям',
  'fr.dds.planTable': 'Прогноз поступлений и выплат',
  'fr.dds.factError': 'Факт не загрузился',
  'fr.dds.planError': 'Прогноз не загрузился',
  'fr.dds.factEmpty': 'Движений по счетам за период не было',
  'fr.dds.planEmpty': 'Ожидаемых платежей на 6 недель нет',
  'fr.dds.rawCol': 'Сырой',
  'fr.dds.weightedCol': 'Взвешенный',
  'fr.org.forbidden': 'Список организаций недоступен',
  'fr.org.error': 'Организации не загрузились',
  'wr.lead': 'Что лежит без движения, что держать всегда, а что — под заказ; как работают сборщики и поставщики.',
  'wr.forbidden.title': 'Складские отчёты вам недоступны',
  'wr.forbidden.text': 'Нужны права на остатки, задания на отбор или приёмки. Их выдаёт администратор.',
  'wr.empty.title': 'За {period} отчётов ещё нет',
  'wr.empty.text': 'Движений, отборов и приёмок за период нет. Неликвиды ниже считаются за полгода.',
  'wr.turn.title': 'Оборачиваемость по позициям',
  'wr.turn.footer': 'Медленные — сверху. Оборачиваемость при нулевом остатке — прочерк: закончившийся товар не самый оборачиваемый.',
  'wr.safety': 'страховой запас',
  'wr.abc.title': 'ABC/XYZ-матрица',
  'wr.abc.count': '{count} позиций',
  'wr.abc.error': 'ABC/XYZ не посчитан',
  'wr.abc.empty': 'За период продаж со склада нет',
  'wr.mx.label': 'ABC/XYZ: строки — доля в обороте, колонки — стабильность спроса',
  'wr.xyz.X': 'стабильный спрос',
  'wr.xyz.Y': 'колеблется',
  'wr.xyz.Z': 'разовый спрос',
  'wr.mx.key': 'ключевые',
  'wr.mx.std': 'стандарт',
  'wr.mx.order': 'под заказ',
  'wr.mx.out': 'на вывод',
  'wr.mx.unknown': 'Ещё {count} позиций без истории — меньше двух месяцев продаж, разброс не определить.',
  'wr.dead.title': 'Неликвиды — без движения больше {days} дней',
  'wr.dead.count': '{count} позиций · с {since}',
  'wr.dead.error': 'Неликвиды не загрузились',
  'wr.dead.empty': 'Неликвидов нет',
  'wr.dead.last': 'Последнее движение',
  'wr.dead.days': 'Дней без движения',
  'wr.warehouse': 'Склад',
  'wr.pick.title': 'Производительность сборщиков',
  'wr.pick.error': 'Выработка не посчитана',
  'wr.pick.empty': 'Заданий на отбор за период нет',
  'wr.pick.hours': 'Часов работы',
  'wr.pick.skipped': 'Пропущено строк',
  'wr.sup.title': 'Качество поставщиков',
  'wr.sup.error': 'Качество поставщиков не посчитано',
  'wr.sup.empty': 'Приёмок за период нет',
  'wr.sup.accepted': 'Принято, шт',
  'wr.sup.defect': 'Брак',
  'wr.sup.defectAria': 'Брак {pct}',
  'wr.sup.withDefects': 'Поставок с браком',
  'wr.sup.footer': 'Брак и недопоставка считаются раздельно: это разные претензии к поставщику.',
  'wr.pcs': 'шт',
  'rm.new': 'Новая рассылка',
  'rm.lead': 'Отчёты сами приходят на почту по расписанию, CSV-вложением. Время — по часам сервера.',
  'rm.forbidden.title': 'Управление рассылками вам недоступно',
  'rm.forbidden.text': 'Расписания настраивают роли с правом на отчёты. Если вы получаете отчёт по почте, попросите автора рассылки убрать адрес.',
  'rm.toDashboards': 'К дашбордам',
  'rm.error.title': 'Не удалось загрузить рассылки',
  'rm.error.text': 'Планировщик не ответил. Расписания не изменились — проблема только со списком.',
  'rm.empty.title': 'Рассылок пока нет',
  'rm.empty.text': 'Настройте первую — например, отчёт по продажам каждый понедельник в 8:00.',
  'rm.search': 'Отчёт или адрес',
  'rm.chip.off': 'Выключенные',
  'rm.chip.broken': 'Без следующего запуска',
  'rm.col.when': 'Периодичность',
  'rm.col.recipients': 'Получатели',
  'rm.col.active': 'Включено',
  'rm.col.actions': 'Действия',
  'rm.more': 'и ещё {count}',
  'rm.broken': 'Не запланирован — проверьте расписание',
  'rm.neverRan': 'ещё не запускалась',
  'rm.activeLabel': 'Рассылка «{name}» включена',
  'rm.on': 'Вкл',
  'rm.off': 'Выкл',
  'rm.actions': 'Действия: {name}',
  'rm.edit': 'Изменить',
  'rm.deleteAsk': 'Удалить рассылку…',
  'rm.deleteTitle': 'Удалить рассылку «{name}»?',
  'rm.deleteText': 'Письма по этому расписанию больше не уйдут. Сам отчёт останется.',
  'rm.footer': '{count} рассылок · {active} включено',
  'rm.sheet.overline': 'Рассылка отчёта',
  'rm.sheet.edit': 'Изменить рассылку',
  'rm.close': 'Закрыть',
  'rm.noReports': 'Сохранённых отчётов нет — сначала соберите отчёт в конструкторе.',
  'rm.mode.daily': 'Ежедневно',
  'rm.mode.weekly': 'Еженедельно',
  'rm.mode.monthly': 'Ежемесячно',
  'rm.mode.cron': 'Своё (cron)',
  'rm.days': 'Дни недели',
  'rm.daysRequired': 'Выберите хотя бы один день',
  'rm.dow.1': 'Пн',
  'rm.dow.2': 'Вт',
  'rm.dow.3': 'Ср',
  'rm.dow.4': 'Чт',
  'rm.dow.5': 'Пт',
  'rm.dow.6': 'Сб',
  'rm.dow.0': 'Вс',
  'rm.dayOfMonth': 'Число месяца',
  'rm.dayOfMonthHelp': 'С 1 по 28 — такое число есть в каждом месяце.',
  'rm.time': 'Время',
  'rm.serverTime': 'По часам сервера',
  'rm.cronHelp': 'Пять полей: минута, час, число, месяц, день недели. Проверяется сервером при сохранении.',
  'rm.describe.daily': 'Каждый день в {time}',
  'rm.describe.weekly': 'Каждую неделю: {days} в {time}',
  'rm.describe.monthly': '{day}-го числа каждого месяца в {time}',
  'rm.describe.raw': 'По расписанию {cron}',
  'rm.emailPlaceholder': 'Адрес почты',
  'rm.addEmail': 'Добавить',
  'rm.removeEmail': 'Убрать {email}',
  'rm.recipientsHelp': 'Получатель — учётная запись CRM: отчёт строится его правами, и в файле ровно то, что он увидел бы, выгрузив отчёт сам. Без права на данные отчёта письма ему не будет — причина видна в журнале доставки. Внешние адреса не принимаются.',
  'rm.deliveries': 'Журнал доставки',
  'rm.deliveries.empty': 'Писем ещё не было.',
  'rm.deliveries.rows': 'строк: {count}',
  'rm.deliveries.retry': 'повтор после {when}',
  'rm.delivery.pending': 'в очереди',
  'rm.delivery.sending': 'отправляется',
  'rm.delivery.sent': 'отправлено',
  'rm.delivery.failed': 'не отправлено, будет повтор',
  'rm.delivery.rejected': 'не отправлено',
  'rm.formatHelp': 'XLSX открывается в Excel сразу: суммы числами, даты датами. CSV — текст для любой программы. PDF сервер не формирует.',
  'rm.escHint': 'Esc — закрыть без сохранения',
  'rm.save': 'Сохранить',
  'rm.create': 'Создать рассылку',
  'rb.crumb': 'Конструктор',
  'rb.loading': 'Загрузка конструктора',
  'rb.forbidden.title': 'Конструктор отчётов вам недоступен',
  'rb.forbidden.text': 'Нет права на отчёты. Его выдаёт администратор.',
  'rb.error.title': 'Не удалось загрузить витрины',
  'rb.untitled': 'Новый отчёт',
  'rb.readOnly': 'Только просмотр — сохранять отчёты нельзя',
  'rb.savedAt': 'сохранён {at}',
  'rb.exportCsv': 'Экспорт CSV',
  'rb.needMeasure': 'Добавьте хотя бы одну меру',
  'rb.needName': 'Укажите название и код',
  'rb.menu': 'Ещё действия с отчётом',
  'rb.source.title': 'Источник данных',
  'rb.source.help': '{count} полей',
  'rb.noSourcesText': 'Ни одна витрина вам не открыта: права на источники выдаёт администратор. Форма без источника ничего не построит.',
  'rb.fields': 'Поля витрины',
  'rb.findField': 'Найти поле',
  'rb.fieldsHelp': 'Щелчок или Enter — поле встанет в подходящую строку по типу.',
  'rb.fieldAria': '{name}, {kind}',
  'rb.kind.dim': 'измерение',
  'rb.kind.num': 'мера',
  'rb.kind.flt': 'фильтр',
  'rb.used.dimension': 'измерение',
  'rb.used.measure': 'мера',
  'rb.used.filter': 'фильтр',
  'rb.structure': 'Структура отчёта',
  'rb.structureHint': 'измерения — строки, меры — числа в колонках',
  'rb.reset': 'Сбросить',
  'rb.dimensionsEmpty': 'Без измерений — одна строка итога',
  'rb.removeDimension': 'Убрать измерение {name}',
  'rb.removeMeasure': 'Убрать меру {name}',
  'rb.removeFilter': 'Убрать условие {name}',
  'rb.aggregateFor': 'Агрегат для {name}',
  'rb.sort': 'Сортировка',
  'rb.sortChoose': 'Выберите колонку',
  'rb.sortEmpty': 'Сначала добавьте измерение или меру',
  'rb.sortDirection': 'Сменить направление',
  'rb.removeSort': 'Убрать сортировку',
  'rb.asc': 'по возрастанию',
  'rb.desc': 'по убыванию',
  'rb.preview': 'Предпросмотр',
  'rb.previewError': 'Предпросмотр не построился',
  'rb.forbiddenSourceText': 'У вашей роли нет права на источник этого отчёта. Выберите другую витрину или запросите доступ.',
  'rb.chooseSource': 'Выберите витрину',
  'rb.chooseSourceText': 'Слева — витрины, открытые вашей роли. Или запустите сохранённый отчёт.',
  'rb.noMeasure': 'Добавьте хотя бы одну меру — без неё нечего считать',
  'rb.noMeasureText': 'Измерения задают строки, меры — числа в колонках.',
  'rb.addFirstMeasure': 'Добавить «{name}»',
  'rb.pressPreview': 'Нажмите «Предпросмотр», чтобы построить отчёт',
  'rb.resultEmpty': 'Под условия отчёта данных нет',
  'rb.previewFooter': 'Предпросмотр: первые строки ({count}). Полный результат — в выгрузке сохранённого отчёта.',
  'rb.savedMenu': 'Ещё действия: {name}',
  'rb.deleteTitle': 'Удалить отчёт «{name}»?',
  'rb.deleteText': 'Отчёт пропадёт из списка, его рассылки перестанут уходить.',
  // admin (design)
  'adm.actions': 'Действия',
  'adm.close': 'Закрыть',
  'adm.escHint': 'Esc — закрыть без сохранения',
  'adm.saving': 'Сохраняем…',
  'adm.retry': 'Повторить',
  'adm.on': 'Вкл',
  'adm.off': 'Выкл',
  'adm.enabled': 'Включено',
  'adm.disabled': 'Выключено',
  'adm.enabledColumn': 'Включено',
  'adm.status': 'Статус',
  'adm.resetFilters': 'Сбросить фильтры',
  'adm.resetSearch': 'Сбросить поиск',
  'adm.ofTotal': '{shown} из {total}',
  'adm.ro.title': 'Только просмотр.',
  'adm.ro.text': 'У вашей роли нет права на правку настроек системы. Изменения вносит администратор системы.',
  'adm.state.forbidden.title': 'Раздел вам недоступен',
  'adm.state.forbidden.text': 'У вашей роли нет права на этот раздел администрирования. Если доступ нужен по работе — напишите администратору системы.',
  'adm.state.home': 'На главную',
  'adm.state.error.title': 'Не удалось загрузить данные',
  'adm.state.error.text': 'Сервер не ответил. Сохранённые настройки продолжают действовать — повторите запрос.',
  'adm.savebar': 'Несохранённые изменения',
  'adm.savebar.count': 'Не сохранено изменений: {count}',
  'adm.savebar.reset': 'Отменить изменения',
  'adm.color.gray': 'Серый',
  'adm.color.blue': 'Синий',
  'adm.color.teal': 'Бирюзовый',
  'adm.color.green': 'Зелёный',
  'adm.color.amber': 'Янтарный',
  'adm.color.orange': 'Оранжевый',
  'adm.color.red': 'Красный',
  'adm.color.purple': 'Фиолетовый',
  'adm.color.none': 'без цвета',
  'adm.users.lead': 'Учётные записи для входа в систему: роли и срок их действия, связь с карточкой сотрудника, блокировка. Пароли здесь не хранятся и не показываются — вход идёт через корпоративный сервис.',
  'adm.users.ro': 'Создавать пользователей, выдавать роли и блокировать может только роль с правом на учётные записи.',
  'adm.users.forbidden': 'Список пользователей вам недоступен',
  'adm.users.error': 'Не удалось загрузить пользователей',
  'adm.users.roleFilter': 'Роль',
  'adm.users.roleAll': 'Роль: все',
  'adm.users.status': 'Статус учётной записи',
  'adm.users.status.all': 'Все',
  'adm.users.status.active': 'Активные',
  'adm.users.status.blocked': 'Заблокированные',
  'adm.users.temporary': 'С временными ролями',
  'adm.users.empty': 'Пользователей пока нет',
  'adm.users.emptyFiltered': 'По этим условиям пользователей нет',
  'adm.users.emptyFiltered.text': 'Заблокированные учётные записи видны в списке «Заблокированные» — там же их можно разблокировать.',
  'adm.users.showBlocked': 'Показать заблокированных',
  'adm.users.contact': 'Почта',
  'adm.users.card': 'Карточка сотрудника',
  'adm.users.sso': 'SSO: корпоративный вход',
  'adm.users.external': 'внешняя учётная запись клиента',
  'adm.users.noRoles': 'без ролей',
  'adm.users.actions': 'Действия: {name}',
  'adm.users.grant': 'Выдать роль…',
  'adm.users.revokeRole': 'Снять роль «{role}»',
  'adm.users.lastSuperadmin.revoke': 'Это последний действующий суперадмин. Сначала выдайте роль «Суперадмин» другому пользователю.',
  'adm.users.lastSuperadmin.block': 'Это последний действующий суперадмин: после блокировки администрировать систему будет некому.',
  'adm.users.unlinkSso': 'Отвязать внешнюю учётную запись (SSO)',
  'adm.users.blockConfirm': 'Заблокировать {name}?',
  'adm.users.blockConfirm.text': 'Пользователь не сможет войти в систему. Его записи и история останутся; разблокировать можно из этого же меню.',
  'adm.users.overline': 'Администрирование · Пользователи',
  'adm.users.create': 'Создать пользователя',
  'adm.users.loginHelp': 'По логину первый вход свяжет учётную запись с корпоративным сервисом',
  'adm.users.phone': 'Телефон',
  'adm.users.contactRequired': 'Укажите почту или телефон — хотя бы одно. По ним восстанавливают доступ.',
  'adm.users.rolesHelp': 'Права суммируются по всем ролям. Роль «Суперадмин» здесь не выдаётся — только отдельным действием.',
  'adm.users.addRole': 'Добавить роль',
  'adm.users.removeRole': 'Убрать роль {role}',
  'adm.users.linkEmployee': 'Связать с сотрудником',
  'adm.users.linkEmployeeHelp': 'Отпуска, задачи и «свои» записи возьмутся из карточки сотрудника',
  'adm.users.sheet': 'Пользователь',
  'adm.users.editForm': 'Учётная запись',
  'adm.users.grantTitle': 'Выдать роль — {name}',
  'adm.users.grantForm': 'Выдача роли',
  'adm.users.grantSave': 'Выдать роль',
  'adm.users.now': 'сейчас: {roles}',
  'adm.users.role': 'Роль',
  'adm.users.addsTo': 'Добавится к ролям: {roles}',
  'adm.users.until': 'Действует до',
  'adm.users.untilHelp': 'Временная роль — например, замещение на время отпуска. Пусто — бессрочно.',
  'adm.users.untilNote': 'После {date} роль перестанет действовать сама.',
  'adm.roles.title': 'Роли и матрица прав',
  'adm.roles.lead': 'Что каждая роль может делать с записями каждого раздела и в каком объёме: свои записи, записи отдела или всей компании. Права пользователя с несколькими ролями складываются.',
  'adm.roles.ro': 'Права ролей меняет только роль с правом на роли.',
  'adm.roles.forbidden': 'Роли и права вам недоступны',
  'adm.roles.error': 'Не удалось загрузить роли и права',
  'adm.roles.list': 'Роли',
  'adm.roles.systemNote': 'Встроенные роли нельзя удалить или переименовать',
  'adm.roles.kind.system': 'встроенная',
  'adm.roles.kind.own': 'своя',
  'adm.roles.holders': 'пользователей: {count}',
  'adm.roles.inherits': 'наследует от {code}',
  'adm.roles.copy': 'Копировать роль',
  'adm.roles.rename': 'Переименовать роль',
  'adm.roles.delete': 'Удалить роль',
  'adm.roles.delete.system': 'Встроенную роль удалить нельзя: на неё ссылаются код и сиды.',
  'adm.roles.delete.holders': 'Роль выдана пользователям ({count}). Сначала снимите её у них.',
  'adm.roles.deleteConfirm': 'Удалить роль «{name}»?',
  'adm.roles.deleteConfirm.text': 'Роль и её права удалятся. Код роли останется занятым — завести новую роль с тем же кодом будет нельзя.',
  'adm.roles.more': 'Ещё: переименовать, удалить роль',
  'adm.roles.superadmin.title': 'Встроенная роль «Суперадмин» не редактируется:',
  'adm.roles.discard': 'Отменить несохранённые изменения прав?',
  'adm.roles.empty': 'У роли «{name}» пока нет ни одного права',
  'adm.roles.empty.text': 'Пользователь только с этой ролью увидит пустое меню. Возьмите права похожей роли за основу или отметьте нужные ячейки в матрице вручную.',
  'adm.roles.copyFrom': 'Скопировать права из роли…',
  'adm.roles.copyRights': 'Скопировать',
  'adm.roles.tabs': 'Права роли',
  'adm.roles.tab.records': 'Права на записи',
  'adm.roles.tab.fields': 'Полевые права',
  'adm.roles.tab.users': 'Пользователи роли',
  'adm.roles.legend.none': 'нет права',
  'adm.roles.legend.own': 'где он ответственный',
  'adm.roles.legend.department': 'его отдел и подотделы',
  'adm.roles.legend.all': 'вся компания',
  'adm.roles.legend.changed': 'изменено, не сохранено',
  'adm.roles.noRight': '— нет права',
  'adm.roles.inheritedShort': 'насл.: {scope}',
  'adm.roles.noPermissions': 'В системе нет прав на записи',
  'adm.roles.noFieldRights': 'Полевых прав в системе нет',
  'adm.roles.fields.sub': 'поверх прав на записи: запись видна, а отдельное поле — нет',
  'adm.roles.fields.note': 'Скрытое поле показывается как «Скрыто правами», в выгрузках — пустым.',
  'adm.roles.systemOn': 'Вкл · встроенное',
  'adm.roles.change': '{what}: {from} → {to}',
  'adm.roles.appliesTo': 'Применятся к пользователям роли ({count}) сразу после сохранения',
  'adm.roles.users.forbidden': 'Список пользователей вам недоступен',
  'adm.roles.users.forbidden.text': 'Кому выдана роль, видно с правом на учётные записи.',
  'adm.roles.users.empty': 'Роль пока никому не выдана',
  'adm.roles.users.user': 'Пользователь',
  'adm.roles.users.term': 'Срок роли',
  'adm.roles.users.forever': 'бессрочно',
  'adm.roles.overline': 'Администрирование · Роли',
  'adm.roles.create': 'Создать роль',
  'adm.roles.copyTitle': 'Копия роли «{name}»',
  'adm.roles.copyName': '{name} (копия)',
  'adm.roles.codeHelp': 'Латиница, цифры и _. Код не меняется и не освобождается после удаления.',
  'adm.roles.parentHelp': 'Права предка достаются роли и снимаются только у предка',
  'adm.roles.renameHelp': 'Было: «{name}»',
  'adm.roles.description': 'Описание',
  'adm.roles.group.other': 'Прочее',
  'adm.action.read': 'Чтение',
  'adm.action.create': 'Создание',
  'adm.action.update': 'Правка',
  'adm.action.delete': 'Удаление',
  'adm.action.approve': 'Утверждение',
  'adm.action.export': 'Экспорт',
  'adm.action.import': 'Импорт',
  'adm.resource.system.settings': 'Настройки системы',
  'adm.resource.analytics.report': 'Отчёты',
  'adm.resource.sales.activity': 'Задачи и активности',
  'adm.resource.sales.plan': 'Планы продаж',
  'adm.resource.sales.pricelist': 'Прайс-листы',
  'adm.resource.sales.order': 'Заказы клиентов',
  'adm.resource.payments.payment': 'Платежи',
  'adm.resource.hr.candidate': 'Кандидаты',
  'adm.resource.hr.timesheet': 'Табель',
  'adm.resource.system.comment': 'Комментарии',
  'adm.resource.system.integration': 'Интеграции',
  'adm.resource.warehouse.topology': 'Склады и ячейки',
  'adm.resource.warehouse.writeoff': 'Списания',
  'adm.audit.lead': 'Кто, когда и что изменил в данных и правах. Записи журнала нельзя изменить или удалить — их пишет система.',
  'adm.audit.forbidden': 'Журнал аудита вам недоступен',
  'adm.audit.error': 'Не удалось загрузить журнал',
  'adm.audit.actorPh': 'Пользователь: логин',
  'adm.audit.typeAll': 'Тип записи: все',
  'adm.audit.actionAll': 'Действие: все',
  'adm.audit.none': 'В журнале пока нет записей',
  'adm.audit.empty.text': 'Условия фильтров вместе не дают ни одной записи. Если ищете пропавшую запись — уберите фильтр пользователя: её мог изменить кто-то другой.',
  'adm.audit.details': 'Подробности',
  'adm.audit.what': 'Что',
  'adm.audit.show': 'Показать изменения: {what}',
  'adm.audit.hide': 'Свернуть изменения: {what}',
  'adm.audit.fields': 'полей: {count}',
  'adm.audit.nil': 'пусто',
  'adm.audit.was': 'было:',
  'adm.audit.became': 'стало:',
  'adm.audit.action.INSERT': 'Создание',
  'adm.audit.action.UPDATE': 'Правка',
  'adm.audit.action.DELETE': 'Удаление',
  'adm.audit.action.PERMISSIONS': 'Смена прав',
  'adm.audit.action.TAGS': 'Теги',
  'adm.entity.Deal': 'Сделка',
  'adm.entity.DealItem': 'Позиция сделки',
  'adm.entity.Counterparty': 'Контрагент',
  'adm.entity.Contact': 'Контакт',
  'adm.entity.Lead': 'Лид',
  'adm.entity.Quote': 'Коммерческое предложение',
  'adm.entity.Contract': 'Договор',
  'adm.entity.Invoice': 'Счёт',
  'adm.entity.PrimaryDocument': 'Первичный документ',
  'adm.entity.Payment': 'Платёж',
  'adm.entity.Product': 'Товар',
  'adm.entity.Shipment': 'Отгрузка',
  'adm.entity.GoodsReceipt': 'Приёмка',
  'adm.entity.StockTransfer': 'Перемещение',
  'adm.entity.Stocktake': 'Инвентаризация',
  'adm.entity.Employee': 'Сотрудник',
  'adm.entity.Department': 'Подразделение',
  'adm.entity.LeaveRequest': 'Заявка на отпуск',
  'adm.entity.Vacancy': 'Вакансия',
  'adm.entity.AppUser': 'Пользователь',
  'adm.entity.Role': 'Роль',
  'adm.entity.UserRole': 'Роль пользователя',
  'adm.entity.RolePermission': 'Право роли',
  'adm.entity.SystemSettings': 'Системные настройки',
  'adm.entity.NumberSequence': 'Нумерация',
  'adm.entity.ApprovalThreshold': 'Порог согласования',
  'adm.entity.Currency': 'Валюта',
  'adm.entity.UnitOfMeasure': 'Единица измерения',
  'adm.entity.Funnel': 'Воронка',
  'adm.entity.FunnelStage': 'Этап воронки',
  'adm.entity.LeadDistributionRule': 'Правило распределения',
  'adm.entity.DealReason': 'Причина закрытия',
  'adm.entity.Tag': 'Тег',
  'adm.entity.Segment': 'Сегмент',
  'adm.entity.Activity': 'Активность',
  'adm.entity.Warehouse': 'Склад',
  'adm.settings.lead': 'Общие правила для всей компании: рабочий календарь и значения, которые подставляются в новые документы. Изменения действуют для всех сразу после сохранения.',
  'adm.settings.ro': 'Настройки меняет администратор системы.',
  'adm.settings.forbidden': 'Системные настройки вам недоступны',
  'adm.settings.error': 'Не удалось загрузить настройки',
  'adm.settings.history': 'История изменений',
  'adm.settings.calendar': 'Рабочий календарь',
  'adm.settings.calendar.text': 'Рабочие дни и часы компании. По ним будут считаться SLA, сроки задач и отсрочки «в рабочих днях».',
  'adm.settings.days.help': 'Нажатый день — рабочий',
  'adm.settings.noDays': 'Отметьте хотя бы один рабочий день',
  'adm.settings.endBeforeStart': 'Конец рабочего дня раньше начала. Укажите время позже {start}.',
  'adm.settings.tz.help': 'Время в документах и сроках считается в этом поясе',
  'adm.settings.defaults': 'Параметры по умолчанию',
  'adm.settings.defaults.text': 'Подставляются в новые документы. В каждом документе значение можно поменять.',
  'adm.settings.org.help': 'От чьего имени выпускаются документы, если организация не выбрана',
  'adm.settings.noOrganization': '— не выбрана —',
  'adm.tz.Europe/Kaliningrad': 'Калининград, UTC+2',
  'adm.tz.Europe/Moscow': 'Москва, UTC+3',
  'adm.tz.Europe/Samara': 'Самара, UTC+4',
  'adm.tz.Asia/Yekaterinburg': 'Екатеринбург, UTC+5',
  'adm.tz.Asia/Omsk': 'Омск, UTC+6',
  'adm.tz.Asia/Novosibirsk': 'Новосибирск, UTC+7',
  'adm.tz.Asia/Krasnoyarsk': 'Красноярск, UTC+7',
  'adm.tz.Asia/Irkutsk': 'Иркутск, UTC+8',
  'adm.tz.Asia/Yakutsk': 'Якутск, UTC+9',
  'adm.tz.Asia/Vladivostok': 'Владивосток, UTC+10',
  'adm.tz.Asia/Magadan': 'Магадан, UTC+11',
  'adm.tz.Asia/Kamchatka': 'Камчатка, UTC+12',
  'adm.numbering.lead': 'Маска номера и период сброса счётчика для каждого типа документа. Типы документов фиксированы — добавить новый нельзя, поэтому на экране только правка маски.',
  'adm.numbering.ro': 'Маски меняет администратор системы.',
  'adm.numbering.forbidden': 'Раздел «Нумерация документов» вам недоступен',
  'adm.numbering.error': 'Не удалось загрузить настройки нумерации',
  'adm.numbering.count': 'типов: {count}',
  'adm.numbering.search': 'Документ или маска',
  'adm.numbering.section': 'Раздел',
  'adm.numbering.section.all': 'Все',
  'adm.numbering.section.sales': 'Продажи',
  'adm.numbering.section.warehouse': 'Склад',
  'adm.numbering.section.finance': 'Финансы',
  'adm.numbering.section.hr': 'Кадры',
  'adm.numbering.setup': 'Маски номеров не заданы',
  'adm.numbering.setup.text': 'Нумерация заводится миграцией. Пустой список значит, что она не прошла: документы не смогут получить номер — сообщите администратору системы.',
  'adm.numbering.empty': 'По запросу «{query}» документов нет',
  'adm.numbering.empty.text': 'Список типов фиксирован. Проверьте написание или сбросьте раздел.',
  'adm.numbering.reset': 'Сброс',
  'adm.numbering.current': 'Текущее значение',
  'adm.numbering.actions': 'Действия: {doc}',
  'adm.numbering.tokens': 'Токены маски: {YYYY} — год, {YY} — две цифры года, {MM} — месяц, {N…} — счётчик, число N — сколько цифр с ведущими нулями. Новая маска действует для документов, созданных после сохранения; выданные номера не меняются.',
  'adm.numbering.sheetTitle': '{doc} — маска и счётчик',
  'adm.numbering.form': 'Маска номера',
  'adm.numbering.mask.help': 'Один счётчик {N…} обязателен.',
  'adm.numbering.insert': 'Вставить:',
  'adm.numbering.reset.help': 'Никогда · Ежегодно — 1 января · Ежемесячно — 1-го числа. Сброс без года или месяца в маске повторит номера — сервер такую маску не примет.',
  'adm.numbering.previewOk': 'маска принята',
  'adm.numbering.current.help': 'Последний выданный номер. Следующий документ получит значение +1. Уменьшить счётчик нельзя — номера повторились бы.',
  'adm.numbering.note': 'Новая маска действует для документов, созданных после сохранения. Выданные номера не меняются.',
  'adm.numbering.fixFirst': 'Исправьте маску, чтобы сохранить',
  'adm.thresholds.lead': 'Когда документ уходит на согласование и кто его согласует. Правила одного типа документа — это шаги: каждый сработавший шаг добавляет согласующего, согласуют по порядку шагов.',
  'adm.thresholds.ro': 'Пороги меняет администратор системы.',
  'adm.thresholds.forbidden': 'Раздел «Пороги согласования» вам недоступен',
  'adm.thresholds.error': 'Не удалось загрузить правила согласования',
  'adm.thresholds.count': 'правил: {count}',
  'adm.thresholds.allTypes': 'Все типы',
  'adm.thresholds.activeOnly': 'Только включённые',
  'adm.thresholds.empty': 'Правил согласования нет',
  'adm.thresholds.empty.text': 'Сейчас документы проводятся без согласования — при любой скидке и сумме. Начните с порога скидки.',
  'adm.thresholds.noneHere': 'По этим условиям правил нет',
  'adm.thresholds.chain': 'Цепочка для «{type}»',
  'adm.thresholds.steps': 'шагов: {count}',
  'adm.thresholds.step': 'Шаг {n}',
  'adm.thresholds.chain.text': 'Если сработали несколько шагов — согласуют по порядку. Выключенные правила в цепочку не входят.',
  'adm.thresholds.byRole': 'роль «{role}»',
  'adm.thresholds.role': 'Роль',
  'adm.thresholds.user': 'Пользователь',
  'adm.thresholds.rule': 'Правило: {name}',
  'adm.thresholds.actions': 'Действия: {name}',
  'adm.thresholds.escalates': 'эскалация через {hours} ч',
  'adm.thresholds.discount': 'Скидка',
  'adm.thresholds.amount': 'Сумма',
  'adm.thresholds.from': 'от',
  'adm.thresholds.if': 'Если',
  'adm.thresholds.overline': 'Правило согласования',
  'adm.thresholds.editTitle': '{type} — шаг {n}',
  'adm.thresholds.newTitle': 'Новое правило',
  'adm.thresholds.step.help': 'Согласуют по порядку шагов',
  'adm.thresholds.condition.help': 'Сработает любое из заданных условий. Пустое поле — без условия по нему, а не ноль.',
  'adm.thresholds.needCondition': 'Задайте скидку или сумму — хотя бы одно',
  'adm.thresholds.approverKind': 'Кто согласует',
  'adm.thresholds.approver.help': 'Роль — согласует любой её обладатель. Пользователь — всегда один человек; на время отпуска — его замещающий.',
  'adm.thresholds.needApprover': 'Выберите согласующего',
  'adm.thresholds.escalate.help': 'Пусто — без эскалации',
  'adm.thresholds.ruleOn': 'Правило включено',
  'adm.currency.lead': 'Валюты для цен, счетов и закупок. Валюты не удаляются: на них ссылаются документы. Код существующей валюты не меняется.',
  'adm.currency.ro': 'Валюты добавляет администратор системы.',
  'adm.currency.forbidden': 'Справочник «Валюты» вам недоступен',
  'adm.currency.error': 'Не удалось загрузить справочник валют',
  'adm.currency.search': 'Код или название',
  'adm.currency.setup': 'Справочник валют пуст',
  'adm.currency.setup.text': 'Валюты заводятся миграцией; пустой список значит, что она не прошла. Без валют нельзя выставить ни один счёт.',
  'adm.currency.empty': 'Валюты «{query}» в справочнике нет',
  'adm.currency.addCode': 'Добавить {code}',
  'adm.currency.code': 'Код',
  'adm.currency.actions': 'Действия: {code}',
  'adm.currency.new': 'Новая валюта',
  'adm.currency.code.help': '3 латинские буквы, ISO 4217',
  'adm.currency.codeInvalid': '3 латинские буквы, ISO 4217 — введено {count}',
  'adm.currency.numeric.help': '3 цифры, ISO 4217',
  'adm.currency.numericInvalid': '3 цифры, ISO 4217',
  'adm.currency.codeLocked': 'Код нельзя изменить после создания',
  'adm.currency.numericLocked': 'Связан с кодом по ISO 4217',
  'adm.currency.newNote': 'После сохранения код изменить будет нельзя — проверьте его по ISO 4217.',
  'adm.currency.symbol.help': 'В печатных формах — после суммы',
  'adm.currency.editNote': 'На валюту ссылаются документы, поэтому её нельзя удалить, а код — изменить.',
  'adm.currency.fillCode': 'Заполните код, цифровой код и название',
  'adm.unit.lead': 'Единицы для товаров и строк документов. Код ОКЕИ попадает в УПД и счёт-фактуру, точность задаёт округление количества. Код единицы не меняется.',
  'adm.unit.ro': 'Единицы добавляет администратор системы.',
  'adm.unit.forbidden': 'Справочник «Единицы измерения» вам недоступен',
  'adm.unit.error': 'Не удалось загрузить единицы измерения',
  'adm.unit.search': 'Код, название, ОКЕИ',
  'adm.unit.setup': 'Справочник единиц пуст',
  'adm.unit.setup.text': 'Единицы заводятся миграцией; пустой список значит, что она не прошла. Без единиц нельзя завести товар.',
  'adm.unit.empty': 'Единицы «{query}» нет',
  'adm.unit.okei': 'Код ОКЕИ',
  'adm.unit.precision': 'Точность',
  'adm.unit.whole': '0 — целые',
  'adm.unit.digits': 'знаков: {count}',
  'adm.unit.actions': 'Действия: {name}',
  'adm.unit.note': 'Точность — знаков после запятой в количестве: «шт» — только целые, вес — до граммов. Количества хранятся с четырьмя знаками, больше задать нельзя.',
  'adm.unit.new': 'Новая единица',
  'adm.unit.code.help': 'Как в строке документа, до 6 символов',
  'adm.unit.codeLocked': 'Код не меняется: по нему находят товары импорт и интеграции',
  'adm.unit.okei.help': '3 цифры по ОКЕИ',
  'adm.unit.okeiInvalid': 'Код ОКЕИ — 3 цифры',
  'adm.unit.precision.help': 'Штучные единицы — 0, длина и площадь — 2, вес — 3',
  'adm.unit.example': 'пример:',
  'adm.unit.updNote': 'В УПД строка выйдет как «{code}», код {okei}.',
  'adm.reasons.title': 'Причины выигрыша и проигрыша',
  'adm.reasons.lead': 'Из этих списков менеджер выбирает причину, когда закрывает сделку; порядок здесь — порядок в списке выбора, меняется перетаскиванием. Причины не удаляются: на них ссылаются закрытые сделки. Ненужную причину отправьте в архив.',
  'adm.reasons.ro': 'Порядок и названия причин меняет администратор системы.',
  'adm.reasons.forbidden': 'Справочник причин вам недоступен',
  'adm.reasons.error': 'Не удалось загрузить причины',
  'adm.reasons.won': 'Причины выигрыша',
  'adm.reasons.lost': 'Причины проигрыша',
  'adm.reasons.sub': 'активных: {active} · в архиве: {archived}',
  'adm.reasons.empty.won': 'Причин выигрыша нет',
  'adm.reasons.empty.won.text': 'При закрытии сделки как выигранной причина не спрашивается, и отчёт «Почему выигрываем» пуст. Добавьте 3–6 причин.',
  'adm.reasons.empty.lost': 'Причин проигрыша нет',
  'adm.reasons.empty.lost.text': 'Проигранную сделку закрывают без причины — не видно, где теряются деньги. Добавьте хотя бы «Цена выше конкурента» и «Сроки поставки».',
  'adm.reasons.move': 'Переместить: {name}. Стрелки вверх/вниз',
  'adm.reasons.actions': 'Действия: {name}',
  'adm.reasons.rename': 'Переименовать',
  'adm.reasons.renameSave': 'Переименовать',
  'adm.reasons.archive': 'В архив',
  'adm.reasons.archived': 'В архиве — не предлагаются при закрытии сделки',
  'adm.reasons.archivedGrip': 'В архиве, не перемещается',
  'adm.reasons.restore': 'Вернуть',
  'adm.reasons.restoreOf': 'Вернуть из архива: {name}',
  'adm.reasons.inArchive': 'в архиве',
  'adm.reasons.addHint': 'появится последней в списке',
  'adm.reasons.keyboard': 'Клавиатура: фокус на ручке, ↑/↓ — переместить. Порядок сохраняется сразу.',
  'adm.reasons.was': 'Было: «{name}». До 60 символов.',
  'adm.reasons.kindLocked': 'Вид не меняется: иначе переписались бы закрытые сделки',
  'adm.reasons.codeLocked': 'По коду причину находят интеграции',
  'adm.reasons.code.help': 'Латиница, без пробелов; потом не меняется',
  'adm.reasons.renameWarn': 'Новое название появится в закрытых сделках и в отчётах. Если смысл причины другой — добавьте новую, а эту отправьте в архив.',
  'adm.funnel.lead': 'Путь сделки от первого контакта до оплаты: порядок этапов, вероятность и лимит дней. Вероятность этапа задаёт взвешенную сумму воронки в отчётах и на дашборде.',
  'adm.funnel.ro': 'Порядок этапов, вероятности и лимиты меняет администратор системы.',
  'adm.funnel.forbidden': 'Настройка воронок вам недоступна',
  'adm.funnel.error': 'Не удалось загрузить воронки',
  'adm.funnel.empty': 'Воронок пока нет',
  'adm.funnel.empty.text': 'Пока нет ни одной воронки, менеджеры не могут завести сделку.',
  'adm.funnel.list': 'Воронки',
  'adm.funnel.addShort': 'Воронка',
  'adm.funnel.meta': 'этапов: {stages} · открытых сделок: {open}',
  'adm.funnel.default': 'по умолчанию',
  'adm.funnel.archived': 'в архиве',
  'adm.funnel.archiveNote': 'Архивная воронка не принимает новые сделки; закрытые сделки в ней остаются в отчётах.',
  'adm.funnel.stagesOf': 'Этапы воронки «{name}»',
  'adm.funnel.counts': 'открытых: {open} + закрывающих: {closing}',
  'adm.funnel.dragHint': 'Порядок — перетаскиванием за ручку или ↑/↓',
  'adm.funnel.more': 'Действия с воронкой {name}',
  'adm.funnel.rename': 'Переименовать воронку',
  'adm.funnel.makeDefault': 'Сделать воронкой по умолчанию',
  'adm.funnel.archive': 'В архив',
  'adm.funnel.archive.default': 'Воронку по умолчанию нельзя отправить в архив — сначала сделайте основной другую.',
  'adm.funnel.restore': 'Вернуть из архива',
  'adm.funnel.total': 'Открытых сделок в воронке: {count}',
  'adm.funnel.limitNote': 'Лимит дней — после него сделка помечается «Застряла» в списке и на доске',
  'adm.funnel.create': 'Создать воронку',
  'adm.funnel.description': 'Описание',
  'adm.stage.probability': 'Вероятность',
  'adm.stage.limit': 'Лимит на этапе',
  'adm.stage.limitDays': 'Лимит дней на этапе',
  'adm.stage.days': 'дн.: {count}',
  'adm.stage.daysSuffix': 'дн.',
  'adm.stage.move': 'Переместить этап {name}. Стрелки вверх/вниз',
  'adm.stage.pinned': 'Этап {name} закреплён в конце',
  'adm.stage.colorOf': 'Цвет: {color}',
  'adm.stage.actions': 'Действия с этапом {name}',
  'adm.stage.edit': 'Изменить этап…',
  'adm.stage.remove.deals': 'На этапе открытые сделки ({count}). Удалить можно только этап, на котором не было ни одной сделки; этап можно переименовать.',
  'adm.stage.remove.last': 'Это единственный открытый этап воронки',
  'adm.stage.removeConfirm': 'Удалить этап «{name}»?',
  'adm.stage.removeConfirm.text': 'Если через этап проходили сделки — даже закрытые или удалённые, — сервер удаление отклонит: отчёт о конверсии читает историю переходов.',
  'adm.stage.closingSep': 'Закрывающие — всегда в конце',
  'adm.stage.overline': 'Этап воронки «{funnel}»',
  'adm.stage.overlineOf': 'Этап воронки «{funnel}» · {n} из {of}',
  'adm.stage.name.help': 'Видят менеджеры на доске, в карточке сделки и в отчётах. Переименование не трогает сделки.',
  'adm.stage.position.help': 'Место среди открытых этапов',
  'adm.stage.color.help': '{color} · цвет помогает на доске, но этап всегда подписан названием',
  'adm.stage.probability.terminal': 'У закрывающего этапа вероятность задана: выигрыш — 100 %, проигрыш — 0 %',
  'adm.stage.was': 'Было: {value} %',
  'adm.stage.limit.help': 'Пусто — без лимита',
  'adm.stage.probabilityMoves': 'Изменится вероятность у открытых сделок этапа: {count}',
  'adm.stage.probabilityMoves.text': 'Вероятность сделки — снимок этапа, поэтому новая переносится на его открытые сделки; закрытые не меняются.',
  'adm.stage.type.help': 'Тип этапа после создания не меняется',
  'adm.stage.now': 'Сейчас на этапе',
  'adm.stage.openCount': 'открытых сделок: {count}',
  'adm.rule.title': 'Правила распределения лидов',
  'adm.rule.lead': 'Кому достаётся новый лид с сайта, звонка или почты. Ответственный назначается сразу при поступлении — лид без подходящего правила ждёт в общей очереди.',
  'adm.rule.ro': 'Порядок правил, участников и включение меняет администратор системы.',
  'adm.rule.forbidden': 'Правила распределения лидов вам недоступны',
  'adm.rule.error': 'Не удалось загрузить правила',
  'adm.rule.order.title': 'Правила проверяются сверху вниз; лид получает первое подходящее.',
  'adm.rule.order.text': 'Выключенные правила пропускаются. Поэтому узкие условия ставьте выше общих.',
  'adm.rule.empty': 'Правил распределения пока нет',
  'adm.rule.empty.text': 'Все новые лиды попадают в общую очередь. Добавьте правило, чтобы заявки сразу получали ответственного.',
  'adm.rule.listLabel': 'Правила распределения, по порядку проверки',
  'adm.rule.head': 'Правило и условия',
  'adm.rule.members': 'Участники',
  'adm.rule.and': 'и',
  'adm.rule.department': 'отдел: {name}',
  'adm.rule.more': 'ещё {count}',
  'adm.rule.enabledOf': 'Правило {name} включено',
  'adm.rule.actions': 'Действия с правилом {name}',
  'adm.rule.move': 'Переместить правило {name}. Стрелки вверх/вниз',
  'adm.rule.queueSep': 'Если ни одно правило не подошло — всегда последним',
  'adm.rule.queuePinned': 'Общая очередь закреплена последней',
  'adm.rule.queue.title': 'Все остальные лиды',
  'adm.rule.queue.target': 'Общая очередь — забирает любой менеджер',
  'adm.rule.queue.text': 'Лид без подходящего правила не теряется: он ждёт в очереди, пока кто-то не возьмёт его себе.',
  'adm.rule.deleteConfirm': 'Удалить правило «{name}»?',
  'adm.rule.deleteConfirm.text': 'Уже назначенные лиды останутся у своих ответственных; новые лиды пойдут по следующим правилам.',
  'adm.rule.overline': 'Правило {n} из {of}',
  'adm.rule.appliesToNew': 'Изменения применятся к новым лидам',
  'adm.rule.conditionsAll': 'Условия — должны выполняться все',
  'adm.rule.noConditions': 'Без условий — правило подходит любому лиду',
  'adm.rule.conditionField': 'Поле условия {n}',
  'adm.rule.equals': 'равно',
  'adm.rule.removeCondition': 'Убрать условие {n}',
  'adm.rule.addCondition': 'Добавить условие',
  'adm.rule.fieldsHint': 'Поля: источник, UTM-метки, компания',
  'adm.rule.strategy.round_robin.text': 'Лиды раздаются участникам по кругу, каждому по одному — в порядке списка.',
  'adm.rule.strategy.by_load.text': 'Лид получает тот, у кого сейчас меньше всего лидов в работе.',
  'adm.rule.strategy.by_region.text': 'Лид получает менеджер, за которым закреплена территория лида; если такого нет — ищется выше по дереву территорий.',
  'adm.rule.strategy.manual.text': 'Правило только отбирает лиды — ответственного назначают вручную.',
  'adm.rule.department.help': 'Отдел, из которого берутся участники',
  'adm.rule.membersCount': 'Участники — {count}',
  'adm.rule.members.help': 'По кругу идут в этом порядке. Уволенного сотрудника в правило добавить нельзя.',
  'adm.rule.activeLabel': 'Правило включено',
  'adm.tags.title': 'Теги и сегменты',
  'adm.tags.lead': 'Теги — ручные метки, которые менеджеры ставят на записи. Сегменты — сохранённые фильтры: в списках они открываются одной кнопкой и пересчитываются сами.',
  'adm.tags.ro': 'Общие теги и сегменты меняет администратор системы; личные сегменты можно сохранять из любого списка.',
  'adm.tags.forbidden': 'Управление тегами вам недоступно',
  'adm.tags.error': 'Не удалось загрузить теги',
  'adm.tags.tab.tags': 'Теги',
  'adm.tags.tab.segments': 'Сегменты',
  'adm.tags.search': 'Название тега',
  'adm.tags.add': 'Добавить тег',
  'adm.tags.empty': 'Тегов пока нет',
  'adm.tags.empty.text': 'Теги помогают отмечать то, чего нет в полях карточки: «Ключевой», «Стоп-отгрузка», «Не звонить». Создайте общий набор — менеджеры будут выбирать из него.',
  'adm.tags.notFound': 'Тега «{query}» нет',
  'adm.tags.actions': 'Действия с тегом {name}',
  'adm.tags.note': 'Удаление тега снимает его со всех записей; сами записи не меняются. Цвет — подсказка, тег всегда подписан названием.',
  'adm.tags.deleteConfirm': 'Удалить тег «{name}»?',
  'adm.tags.deleteConfirm.text': 'Тег снимется со всех записей сразу, а сегменты, построенные по нему, перестанут находить эти записи.',
  'adm.tags.new': 'Новый тег',
  'adm.tags.new.sub': 'Общий — будет доступен всем, у кого есть права на помечаемые записи',
  'adm.tags.edit': 'Изменить тег',
  'adm.tags.form': 'Тег',
  'adm.tags.create': 'Создать тег',
  'adm.tags.renameHelp': 'Новое название появится на всех помеченных записях и в фильтрах',
  'adm.tags.preview': 'Предпросмотр',
  'adm.tags.previewName': 'Тег',
  'adm.tags.previewHint': 'так в фильтре и в карточке',
  'adm.segments.search': 'Название сегмента',
  'adm.segments.entity': 'Сущность',
  'adm.segments.all': 'Все',
  'adm.segments.sharedOnly': 'Только общие',
  'adm.segments.error': 'Не удалось загрузить сегменты',
  'adm.segments.empty': 'Сегментов пока нет',
  'adm.segments.empty.text': 'Сегмент — это сохранённый фильтр. Настройте фильтр в списке контрагентов, сделок, контактов или лидов и нажмите «Сохранить как сегмент».',
  'adm.segments.notFound': 'По этим условиям сегментов нет',
  'adm.segments.name': 'Название',
  'adm.segments.filter': 'Сохранённый фильтр',
  'adm.segments.noFilter': 'без условий — весь список',
  'adm.segments.count': 'Записей',
  'adm.segments.access': 'Доступ',
  'adm.segments.shared': 'Общий',
  'adm.segments.mine': 'Личный · мой',
  'adm.segments.private': 'Личный',
  'adm.segments.actions': 'Действия с сегментом {name}',
  'adm.segments.makeShared': 'Сделать общим',
  'adm.segments.makePrivate': 'Сделать личным',
  'adm.segments.delete': 'Удалить сегмент',
  'adm.segments.deleteConfirm': 'Удалить сегмент «{name}»?',
  'adm.segments.deleteConfirm.text': 'Сегмент пропадёт из списков у всех, кто его видел. Записи не меняются.',
  'adm.segments.note': 'Число записей считается в вашей области видимости: у руководителя и менеджера оно разное. Личный сегмент видит только владелец; администратор может сделать его общим.',
  'adm.fields.title': 'Дополнительные поля',
  'adm.fields.lead': 'Поля, которых нет в стандартной карточке. Они появляются в карточке, колонках и фильтрах списка и в импорте — сразу, без релиза.',
  'adm.fields.ro': 'Поля добавляет и скрывает администратор системы.',
  'adm.fields.forbidden': 'Настройка дополнительных полей вам недоступна',
  'adm.fields.error': 'Не удалось загрузить поля',
  'adm.fields.count': 'полей: {count}',
  'adm.fields.empty': 'У сущности «{entity}» нет дополнительных полей',
  'adm.fields.empty.text': 'Карточка показывает только стандартные поля. Добавьте своё — например «Отрасль» списком, чтобы фильтровать записи и строить по ней отчёты.',
  'adm.fields.options': 'Значения списка',
  'adm.fields.requiredBadge': 'обязательное',
  'adm.fields.actions': 'Действия с полем {code}',
  'adm.fields.note': 'Обязательное поле требует значение при создании и правке; у старых записей оно может быть пустым. Скрытое поле пропадает с карточек и из списков, значения в записях остаются.',
  'adm.fields.hideConfirm': 'Скрыть поле «{label}»?',
  'adm.fields.hideConfirm.text': 'Поле пропадёт с карточек, из колонок и фильтров. Значения останутся в записях, но вернуть поле с этого экрана нельзя.',
  'adm.fields.newTitle': 'Новое поле: {entity}',
  'adm.fields.newSub': 'Появится в карточке, в фильтрах и в импорте',
  'adm.fields.create': 'Создать поле',
  'adm.fields.code.help': 'Латиница, цифры и _, начинается с буквы; нельзя изменить после создания',
  'adm.fields.codeInvalid': 'Код — латиница, цифры и _, без пробелов, начинается с буквы',
  'adm.fields.codeTaken': 'Поле с кодом {code} уже есть: {entity}',
  'adm.fields.codeFree': 'Код свободен',
  'adm.fields.use': 'Использовать',
  'adm.fields.useHelp': 'Подставим транслитерацию названия',
  'adm.fields.optionN': 'Значение {n}',
  'adm.fields.removeOption': 'Удалить значение {n}',
  'adm.fields.addOption': 'Добавить значение',
  'adm.fields.optionsOrder': 'Порядок — как в выпадающем списке карточки',
  'adm.fields.required.on': 'Новые и изменяемые записи нельзя будет сохранить без значения. У существующих поле останется пустым, пока его не заполнят.',
  'adm.fields.required.off': 'Выключено: поле можно оставить пустым.',
  'record.hr.leave.rejectionReason': 'Причина отказа',
  'record.hr.leave.noRejectionReason': 'Причина не указана — заявка отклонена до того, как причину стали сохранять.',
  'record.hr.leave.rejectReasonHelp': 'Обязательна: сотрудник увидит её в карточке заявки.',
  'record.hr.transfer.positionsFailed': 'Справочник должностей не загрузился — должность останется текущей.',
  'adm.users.lastLogin': 'Последний вход',
  'adm.users.neverSeen': 'не входил',
  'payments.fiscal.col.action': 'Действие',
  'payments.fiscal.retryOne': 'Повторить',
  'payments.fiscal.retryOne.busy': 'Отправляем…',
  'payments.fiscal.retryOne.label': 'Повторить отправку чека {receipt}',
  'payments.fiscal.retryOne.notDue': 'Следующая попытка назначена на {at}: раньше ОФД дёргать не стоит',
  'payments.fiscal.retryOne.registered': 'Чек {receipt} зарегистрирован в ОФД',
  'payments.fiscal.retryOne.failed': 'Попытка не прошла — статус «{status}»: {error}',
  'payments.import.openOriginal': 'Открыть ту загрузку',
  'payments.imports.title': 'История загрузок',
  'payments.imports.empty': 'По этому счёту выписку ещё не загружали',
  'payments.imports.col.at': 'Когда',
  'payments.imports.col.file': 'Файл',
  'payments.imports.col.lines': 'Строк в файле',
  'payments.imports.col.new': 'Новых',
  'payments.imports.col.duplicates': 'Повторов',
  'payments.imports.col.by': 'Кто загрузил',
  'payments.imports.noFile': 'без имени файла',
  'payments.imports.repeat': 'повтор',
  'payments.imports.open': 'Открыть',
  'payments.imports.close': 'Свернуть',
  'payments.imports.opened': 'Загрузка «{file}»',
  'payments.imports.summary': 'строк {lines}, новых {imported}, повторов {duplicates}',
  'payments.imports.noOwnLines': 'Своих строк у этой загрузки нет: всё, что в ней было, уже принесла более ранняя.',
  'payments.imports.lines': 'Строки загрузки',
  'payments.imports.processed': 'Проведена',
  'record.pay.made.title': 'Уже разнесено',
  'record.pay.made.error': 'Не удалось загрузить разнесения платежа',
  'record.pay.made.empty': 'Платёж ещё ни на один счёт не разнесён',
  'record.pay.made.at': 'Когда',
  'record.pay.made.rule': 'Как',
  'record.pay.made.amount': 'Сумма',
  'record.pay.made.rule.auto': 'автосверка',
  'record.pay.made.rule.manual': 'вручную',
  'record.contact.col.stage': 'Стадия',
  'record.contact.col.amount': 'Сумма',
  'record.contact.col.closeOn': 'Закрытие',
  'record.wh.feed.title': 'Движения и обсуждение',
  'record.wh.feed.error': 'Не удалось загрузить ленту документа',
  'record.wh.feed.empty': 'Документ ещё ничего не двигал и его не обсуждали',
  'timeline.kind.change': 'Изменение',
  'timeline.kind.movement': 'Движение',
  'timeline.kind.document': 'Документ',
  'timeline.kind.attachment': 'Файл',
  'timeline.kind.approval': 'Согласование',
  'timeline.more': 'Показать раньше',
  'timeline.moreFailed': 'Не удалось загрузить более ранние события',
  'timeline.beginning': 'Это начало истории',
  'timeline.onDeal': 'по сделке {number}',
  'timeline.document.invoice': 'Счёт',
  'timeline.document.quote': 'КП',
  'timeline.document.act': 'Акт',
  'timeline.document.upd': 'УПД',
  'timeline.document.torg12': 'ТОРГ-12',
  'timeline.document.invoice_factura': 'Счёт-фактура',
  'timeline.documentStatus.sent': 'выставлен',
  'timeline.documentStatus.partially_paid': 'оплачен частично',
  'timeline.documentStatus.paid': 'оплачен',
  'timeline.documentStatus.overdue': 'просрочен',
  'timeline.documentStatus.cancelled': 'аннулирован',
  'timeline.documentStatus.issued': 'выпущен',
  'timeline.documentStatus.signed': 'подписан',
  'timeline.scan.pending': 'проверяется антивирусом',
  'timeline.scan.clean': 'проверен',
  'timeline.scan.infected': 'заражён — скачивание закрыто',
  'timeline.scan.failed': 'проверка не удалась — скачивание закрыто',
  'record.feed.filter.documents': 'Документы',
  'record.composer.mention': 'Упомянуть',
  'record.composer.mentionPlaceholder': 'Имя коллеги',
  'record.composer.mentionFailed': 'Не удалось найти коллег',
  'record.composer.mentionFound': 'Найденные коллеги',
  'record.composer.mentioned': 'Упомянутые',
  'record.composer.unmention': 'Убрать упоминание: {name}',
  'timeline.change.INSERT': 'создан',
  'timeline.change.UPDATE': 'изменён',
  'timeline.change.DELETE': 'удалён',
  'timeline.change.TAGS': 'теги',
  'timeline.movement.receipt': 'приход',
  'timeline.movement.putaway': 'размещение',
  'timeline.movement.transfer': 'перемещение',
  'timeline.movement.pick': 'отбор',
  'timeline.movement.ship': 'отгрузка',
  'timeline.movement.return': 'возврат',
  'timeline.movement.write_off': 'списание',
  'timeline.movement.adjust': 'корректировка',
  'timeline.movement.count': 'пересчёт',
  // audit entity types (all journal classes)
  'adm.entity.AcquiringWebhook': 'Уведомление эквайринга',
  'adm.entity.ApprovalDelegation': 'Замещение',
  'adm.entity.ApprovalRequest': 'Запрос согласования',
  'adm.entity.ApprovalStep': 'Шаг согласования',
  'adm.entity.Attachment': 'Вложение',
  'adm.entity.AutomationRule': 'Правило автоматизации',
  'adm.entity.BankAccount': 'Расчётный счёт',
  'adm.entity.BankStatementImport': 'Загрузка выписки',
  'adm.entity.BankStatementLine': 'Строка выписки',
  'adm.entity.Candidate': 'Кандидат',
  'adm.entity.CandidateApplication': 'Отклик кандидата',
  'adm.entity.CertificationReminder': 'Напоминание о сертификате',
  'adm.entity.CostLayer': 'Слой себестоимости',
  'adm.entity.CounterpartyBankAccount': 'Счёт контрагента',
  'adm.entity.CustodyBillingRecord': 'Начисление за хранение',
  'adm.entity.CustodyDailySnapshot': 'Срез ответственного хранения',
  'adm.entity.CustodyTariff': 'Тариф хранения',
  'adm.entity.CustomerBalance': 'Баланс клиента',
  'adm.entity.DealContact': 'Участник сделки',
  'adm.entity.DocumentSignature': 'Подпись документа',
  'adm.entity.DocumentTemplate': 'Шаблон документа',
  'adm.entity.DunningAction': 'Ступень взыскания',
  'adm.entity.EmployeeAssignment': 'Назначение сотрудника',
  'adm.entity.EmployeeDocument': 'Кадровый документ',
  'adm.entity.EntityComment': 'Комментарий',
  'adm.entity.FiscalOperation': 'Фискальная операция',
  'adm.entity.FiscalReceipt': 'Фискальный чек',
  'adm.entity.FiscalReceiptItem': 'Строка чека',
  'adm.entity.GoodsReceiptItem': 'Строка приёмки',
  'adm.entity.GoodsReturn': 'Возврат поставщику',
  'adm.entity.GoodsReturnItem': 'Строка возврата',
  'adm.entity.InvoiceItem': 'Позиция счёта',
  'adm.entity.KpiDefinition': 'Показатель KPI',
  'adm.entity.KpiTarget': 'Цель KPI',
  'adm.entity.LeaveBalance': 'Остаток отпуска',
  'adm.entity.MarketingSpend': 'Маркетинговые затраты',
  'adm.entity.MarkingOperation': 'Операция маркировки',
  'adm.entity.Notification': 'Уведомление',
  'adm.entity.OnboardingChecklist': 'Чек-лист адаптации',
  'adm.entity.OnboardingTask': 'Задача адаптации',
  'adm.entity.OnboardingTemplate': 'Шаблон адаптации',
  'adm.entity.OnboardingTemplateTask': 'Задача шаблона адаптации',
  'adm.entity.OneCConflict': 'Конфликт обмена с 1С',
  'adm.entity.OneCConnection': 'Подключение к 1С',
  'adm.entity.OneCExchangeEntry': 'Запись обмена с 1С',
  'adm.entity.OneCExchangeRun': 'Сеанс обмена с 1С',
  'adm.entity.OneCLink': 'Связь с 1С',
  'adm.entity.PaymentAllocation': 'Разнесение платежа',
  'adm.entity.PaymentIntent': 'Намерение оплаты',
  'adm.entity.Permission': 'Право',
  'adm.entity.PickTask': 'Задание на отбор',
  'adm.entity.PickTaskLine': 'Строка задания на отбор',
  'adm.entity.PriceList': 'Прайс-лист',
  'adm.entity.PriceListItem': 'Строка прайс-листа',
  'adm.entity.PrimaryDocumentItem': 'Строка первичного документа',
  'adm.entity.ProductBatch': 'Партия товара',
  'adm.entity.QuoteItem': 'Позиция КП',
  'adm.entity.ReceiptMarkingCode': 'Код маркировки приёмки',
  'adm.entity.RecurringInvoice': 'Регулярный счёт',
  'adm.entity.SalesOrder': 'Заказ клиента',
  'adm.entity.SalesOrderItem': 'Позиция заказа',
  'adm.entity.SalesPlan': 'План продаж',
  'adm.entity.SavedView': 'Сохранённое представление',
  'adm.entity.SerialNumber': 'Серийный номер',
  'adm.entity.ShipmentItem': 'Строка отгрузки',
  'adm.entity.ShipmentPackage': 'Грузовое место',
  'adm.entity.ShipmentPackageItem': 'Содержимое места',
  'adm.entity.Stock': 'Остаток',
  'adm.entity.StockReservation': 'Резерв',
  'adm.entity.StockRevaluation': 'Переоценка',
  'adm.entity.StockTransferItem': 'Строка перемещения',
  'adm.entity.StockWriteOff': 'Списание',
  'adm.entity.StockWriteOffItem': 'Строка списания',
  'adm.entity.StocktakeLine': 'Строка пересчёта',
  'adm.entity.StorageCell': 'Ячейка склада',
  'adm.entity.StorageZone': 'Зона склада',
  'adm.entity.SupportMessage': 'Сообщение обращения',
  'adm.entity.SupportTicket': 'Обращение',
  'adm.entity.Territory': 'Территория',
  'adm.entity.TimeEntry': 'Запись табеля',
  'adm.entity.TrainingCourse': 'Учебный курс',
  'adm.entity.TrainingRecord': 'Обучение сотрудника',
  // Конструктор отчётов: границы диапазона в фильтре «между».
  'report.filter.from': 'от',
  'report.filter.to': 'до',

  'payments.item.marketing': 'Маркетинг и реклама',

  // Налоги (V57): ставки кодом с периодами, основная 22 % с 2026 года.
  'nav.adminTaxRates': 'Налоги',
  'column.tax_rate_code': 'Ставка НДС',
  'card.taxRate.pick': 'Выберите ставку',
  'record.product.taxNotEffective': 'Ставка {code} сегодня не действует',
  'adm.tax.lead': 'Ставки НДС кодом и периодами действия. Товар хранит код ставки, документ — процент на свою дату: основная ставка — 20 % до 31.12.2025 и 22 % с 01.01.2026. Ставку, по которой выставлены документы, не правят, а закрывают датой и заводят новый период.',
  'adm.tax.ro': 'Ставки налога настраивает администратор системы.',
  'adm.tax.add': 'Добавить ставку',
  'adm.tax.search': 'Код, название или признак чека',
  'adm.tax.forbidden': 'Нет доступа к справочнику налогов',
  'adm.tax.error': 'Не удалось загрузить ставки налога',
  'adm.tax.setup': 'Ставок налога нет',
  'adm.tax.setup.text': 'Без ставок не выставить ни счёт, ни чек. Справочник засевается миграцией — если он пуст, её надо проверить.',
  'adm.tax.empty': 'Ничего не найдено по «{query}»',
  'adm.tax.code': 'Код',
  'adm.tax.name': 'Название',
  'adm.tax.kind': 'Вид',
  'adm.tax.percent': 'Ставка',
  'adm.tax.ofd': 'Признак в чеке',
  'adm.tax.period': 'Действует',
  'adm.tax.state': 'Состояние',
  'adm.tax.usage': 'Ссылки',
  'adm.tax.usage.hint': 'Строки документов, выставленных по этой ставке, и товары с её кодом',
  'adm.tax.usage.value': 'строк {lines} · товаров {products}',
  'adm.tax.newPeriod': 'Новый период',
  'adm.tax.newPeriodOf': 'Новый период {code}',
  'adm.tax.new': 'Новая ставка',
  'adm.tax.form': 'Ставка налога',
  'adm.tax.delete': 'Удалить',
  'adm.tax.deleteBlockedLines': 'По ставке выставлены документы ({count} строк) — её можно только закрыть датой',
  'adm.tax.deleteBlockedProducts': 'Это последний период кода, указанного у товаров ({count})',
  'adm.tax.deleteConfirm': 'Удалить ставку «{name}»?',
  'adm.tax.deleteConfirm.text': 'Документов по ней нет. После удаления новые строки по этому периоду выставить будет нельзя.',
  'adm.tax.actions': 'Действия со ставкой {code}',
  'adm.tax.kind.standard': 'Основная',
  'adm.tax.kind.reduced': 'Пониженная',
  'adm.tax.kind.special': 'Специальная (УСН)',
  'adm.tax.kind.zero': 'Нулевая',
  'adm.tax.kind.exempt': 'Без НДС',
  'adm.tax.estimatedShort': 'расчётная',
  'adm.tax.openEnded': 'без срока',
  'adm.tax.state.active': 'Действует',
  'adm.tax.state.future': 'Будет действовать',
  'adm.tax.state.closed': 'Закрыта',
  'adm.tax.codeInvalid': 'Латиница в нижнем регистре, цифры и подчёркивание; начинается с буквы',
  'adm.tax.code.help': 'По коду товар находит свою ставку; новый период того же налога заводится тем же кодом',
  'adm.tax.codeLocked': 'Код не меняется: по нему товары находят ставку',
  'adm.tax.periodInvalid': 'Окончание раньше начала',
  'adm.tax.frozen': 'По ставке выставлены документы ({count} строк): процент, вид, признак чека и начало действия не меняются — иначе прошлые документы поменяли бы смысл. Закройте ставку датой окончания и заведите новый период.',
  'adm.tax.estimated': 'Расчётная ставка',
  'adm.tax.estimated.label': 'Налог выделяется из суммы как r/(100+r) — для авансов и предоплат',
  'adm.tax.estimated.help': 'Например, 22/122. В строках счетов и сделок не применяется — только в чеке',
  'adm.tax.ofd.pick': 'Выберите признак',
  'adm.tax.ofd.help': 'Реквизит ставки в чеке (ФФД, тег 1199). Перечень задан форматом фискальных данных и сужен по проценту и расчётности',
  'adm.tax.ofd.none': 'Для такого процента в перечне ФФД нет признака — чек по такой ставке не пробить',
  'adm.tax.validFrom': 'Действует с',
  'adm.tax.validTo': 'Действует по',
  'adm.tax.validTo.help': 'Пусто — без срока. Дата включительно',
  // Склады и топология: склады, зоны, ячейки, генератор ячеек
  'nav.warehouses': 'Склады и топология',
  'topo.lead': 'Склады, зоны хранения и ячейки. Код склада и зоны печатается в штрихкоде каждой ячейки и потому не меняется; ячейку с товаром, резервом или открытым заданием можно только заблокировать.',
  'topo.ro': 'Склады, зоны и ячейки видны, но менять их может только заведующий этого склада или администратор.',
  'topo.forbidden': 'Нет доступа к топологии склада',
  'topo.error': 'Не удалось загрузить склады',
  'topo.active': 'Активен',
  'topo.inactive': 'Неактивен',
  'topo.pick': 'Выберите…',
  'topo.codeInvalid': 'От 1 до 32 букв, цифр, «_» или «-» — без точек и пробелов',
  'topo.code.help': 'Входит в штрихкод ячейки (СКЛАД.ЗОНА.ЯЧЕЙКА) и после сохранения не меняется',
  'topo.code.locked': 'Код не меняется: он напечатан на этикетках ячеек',
  'topo.strategy.help': 'Какие партии списываются первыми. Зона может задать свою',
  'topo.strategy.FIFO': 'FIFO — первым пришёл, первым ушёл',
  'topo.strategy.FEFO': 'FEFO — ближайший срок годности первым',
  'topo.strategy.LIFO': 'LIFO — последним пришёл, первым ушёл',
  'topo.strategy.MANUAL': 'Вручную — выбирает сборщик',
  'topo.wh.add': 'Добавить склад',
  'topo.wh.new': 'Новый склад',
  'topo.wh.form': 'Склад',
  'topo.wh.search': 'Поиск по коду, названию, адресу',
  'topo.wh.setup': 'Складов пока нет',
  'topo.wh.setup.text': 'Заведите склад, затем его зоны и ячейки — без них приёмке некуда размещать товар.',
  'topo.wh.empty': 'Ничего не найдено по «{query}»',
  'topo.wh.code': 'Код',
  'topo.wh.name': 'Название',
  'topo.wh.organization': 'Организация',
  'topo.wh.organization.help': 'Чьи запасы лежат на складе. После сохранения не меняется',
  'topo.wh.organization.locked': 'Организация не меняется: вместе с ней без документа переехал бы весь остаток',
  'topo.wh.address': 'Адрес',
  'topo.wh.manager': 'Заведующий',
  'topo.wh.manager.help': 'Сотрудник из кадров. Заведующий правит зоны и ячейки своего склада',
  'topo.wh.managerIs': 'заведующий {name}',
  'topo.wh.strategy': 'Стратегия отбора',
  'topo.wh.strategyIs': 'отбор {strategy}',
  'topo.wh.crossDock': 'Кросс-докинг',
  'topo.wh.crossDock.help': 'Товар может идти с приёмки сразу в отгрузку, минуя размещение',
  'topo.wh.crossDockShort': 'кросс-докинг',
  'topo.wh.active': 'Активен',
  'topo.wh.active.help': 'Неактивный склад остаётся в истории; закрытый склад делают неактивным, а не удаляют',
  'topo.wh.zones': 'Зоны',
  'topo.wh.cells': 'Ячейки',
  'topo.wh.state': 'Состояние',
  'topo.wh.editOf': 'Изменить склад {code}',
  'topo.wh.delete': 'Удалить склад',
  'topo.wh.deleteConfirm': 'Удалить склад {code}?',
  'topo.wh.deleteConfirm.text': 'Вместе со складом удалятся его зоны и ячейки. Склад с остатком или незавершёнными документами сервер не удалит — такой склад делают неактивным.',
  'topo.cells.summary': '{cells} · занято {occupied} · блок. {blocked}',
  'topo.cells.summary.hint': 'Всего ячеек · с товаром · заблокировано',
  'topo.zones': 'Зоны хранения',
  'topo.zone.add': 'Добавить зону',
  'topo.zone.new': 'Новая зона',
  'topo.zone.form': 'Зона хранения',
  'topo.zone.setup': 'Зон пока нет',
  'topo.zone.setup.text': 'Зона задаёт режим хранения: стеллажи с ячейками, паллеты, напольное, ответственное хранение, карантин, брак.',
  'topo.zone.code': 'Код',
  'topo.zone.name': 'Название',
  'topo.zone.mode': 'Режим хранения',
  'topo.zone.regime': 'Температура',
  'topo.zone.strategy': 'Стратегия',
  'topo.zone.priority': 'Приоритет',
  'topo.zone.priority.help': 'Меньше — раньше предлагается при размещении',
  'topo.zone.inherit': 'Как у склада ({strategy})',
  'topo.zone.inherited': '(склад)',
  'topo.zone.owner': 'Владелец товара',
  'topo.zone.owner.help': 'Клиент, чей товар хранится в зоне: ему выставляется счёт за хранение. Поиск — по названию или ИНН',
  'topo.zone.ownerIs': 'владелец: {name}',
  'topo.zone.tempMin': 'Температура от, °C',
  'topo.zone.tempMax': 'Температура до, °C',
  'topo.zone.temp.help': 'Пусто — типовые границы режима',
  'topo.zone.tempNumber': 'Температура — число',
  'topo.zone.tempInverted': 'Нижняя граница выше верхней',
  'topo.zone.active': 'Активна',
  'topo.zone.active.help': 'Неактивная зона не предлагается при размещении',
  'topo.zone.noCells': 'без ячеек',
  'topo.zone.noCells.text': 'Режим «{mode}» хранит товар без ячеек — на уровне зоны.',
  'topo.zone.actions': 'Действия с зоной {code}',
  'topo.zone.delete': 'Удалить зону',
  'topo.zone.deleteBlocked': 'В зоне занято ячеек: {count} — сначала переместите товар',
  'topo.zone.deleteConfirm': 'Удалить зону {code}?',
  'topo.zone.deleteConfirm.text': 'Вместе с зоной удалятся её ячейки ({count}). Зону с товаром, резервом или открытыми заданиями сервер не удалит.',
  'topo.mode.addressed': 'Адресное (ячейки)',
  'topo.mode.pallet': 'Паллетное',
  'topo.mode.bulk': 'Напольное',
  'topo.mode.custody': 'Ответственное хранение',
  'topo.mode.quarantine': 'Карантин',
  'topo.mode.cross_dock': 'Кросс-док',
  'topo.mode.defect': 'Брак',
  'topo.mode.addressed.help': 'Стеллажи с адресными ячейками: ряд, стеллаж, ярус, позиция',
  'topo.mode.pallet.help': 'Хранение паллетами по SSCC, без ячеек',
  'topo.mode.bulk.help': 'Напольное хранение крупногабарита, без ячеек',
  'topo.mode.custody.help': 'Товар клиента: не продаётся как наш, хранение выставляется владельцу',
  'topo.mode.quarantine.help': 'Принятое, но не проверенное — из карантина не отбирают',
  'topo.mode.cross_dock.help': 'С приёмки сразу в отгрузку, минуя размещение',
  'topo.mode.defect.help': 'Брак и отбракованное — отдельно от товара на продажу',
  'topo.regime.ambient': 'Обычная',
  'topo.regime.chilled': 'Охлаждение',
  'topo.regime.frozen': 'Заморозка',
  'topo.regime.hazardous': 'Опасные грузы',
  'topo.cells.title': 'Ячейки зоны {zone}',
  'topo.cells.truncated': 'показано {shown} из {total} — сузьте рядом',
  'topo.cells.search': 'Код ячейки',
  'topo.cells.row': 'Ряд',
  'topo.cells.anyRow': 'Все ряды',
  'topo.cells.any': 'Все',
  'topo.cells.blockedFilter': 'Блокировка',
  'topo.cells.blockedYes': 'Заблокированные',
  'topo.cells.blockedNo': 'Рабочие',
  'topo.cells.occupiedFilter': 'Занятость',
  'topo.cells.occupiedYes': 'Занятые',
  'topo.cells.occupiedNo': 'Пустые',
  'topo.cells.bulk': 'Действия с выбранными ячейками',
  'topo.cells.selected': 'Выбрано: {count}',
  'topo.cells.selectAll': 'Выбрать все показанные ячейки',
  'topo.cells.selectOne': 'Выбрать ячейку {code}',
  'topo.cells.block': 'Заблокировать',
  'topo.cells.unblock': 'Разблокировать',
  'topo.cells.clear': 'Снять выбор',
  'topo.cells.blockConfirm': 'Заблокировать выбранные ячейки ({count})?',
  'topo.cells.reason': 'Причина блокировки',
  'topo.cells.reason.help': 'Обязательна: блокировка без причины переживает свой повод',
  'topo.cells.setup': 'Ячеек пока нет',
  'topo.cells.setup.text': 'Сгенерируйте их по шаблону: диапазоны рядов, стеллажей, ярусов и позиций.',
  'topo.cells.empty': 'Нет ячеек под эти фильтры',
  'topo.cells.code': 'Код',
  'topo.cells.address': 'Ряд / стеллаж / ярус / позиция',
  'topo.cells.capacity': 'Ёмкость',
  'topo.cells.dims': 'Д×Ш×В, мм',
  'topo.cells.abc': 'ABC',
  'topo.cells.abc.help': 'Класс оборачиваемости: ходовой товар (A) предлагается ближе к отгрузке',
  'topo.cells.state': 'Состояние',
  'topo.cells.unlimited': 'без ограничений',
  'topo.cells.kg': '{value} кг',
  'topo.cells.m3': '{value} м³',
  'topo.cells.pallets': '{value} пал.',
  'topo.cells.blockedBadge': 'Заблокирована',
  'topo.cells.reserveBadge': 'Запасная',
  'topo.cells.stockBadge': 'Товар',
  'topo.cells.reservedBadge': 'Резерв',
  'topo.cells.taskBadge': 'Задание',
  'topo.cells.free': 'свободна',
  'topo.cells.actions': 'Действия с ячейкой {code}',
  'topo.cells.delete': 'Удалить ячейку',
  'topo.cells.deleteConfirm': 'Удалить ячейку {code}?',
  'topo.cells.deleteConfirm.text': 'Ячейка пуста. После удаления её код можно завести заново генератором.',
  'topo.cells.busy.stock': 'на ячейке товар',
  'topo.cells.busy.reserved': 'на её товар есть резерв',
  'topo.cells.busy.task': 'её ждёт открытое задание',
  'topo.cells.busy.blockInstead': 'удалить нельзя, только заблокировать',
  'topo.cells.form': 'Ячейка',
  'topo.cells.limits.help': 'Пустое значение — без ограничения, а не ноль: подсказка размещения так его и понимает.',
  'topo.cells.maxWeight': 'Макс. вес, кг',
  'topo.cells.maxVolume': 'Макс. объём, м³',
  'topo.cells.maxPallets': 'Паллетомест',
  'topo.cells.length': 'Длина, мм',
  'topo.cells.width': 'Ширина, мм',
  'topo.cells.height': 'Высота, мм',
  'topo.cells.limitInvalid': 'Ограничения — положительные числа',
  'topo.cells.pickable': 'Отбор из ячейки',
  'topo.cells.pickable.help': 'Выключено — запасная ячейка: из неё пополняют места отбора, а маршрут сборщика её обходит',
  'topo.gen.open': 'Сгенерировать ячейки',
  'topo.gen.overline': 'Зона {zone}',
  'topo.gen.title': 'Генератор ячеек',
  'topo.gen.subtitle': 'Не больше {max} ячеек за раз. Существующие коды пропускаются',
  'topo.gen.row': 'Ряды',
  'topo.gen.rack': 'Стеллажи',
  'topo.gen.tier': 'Ярусы',
  'topo.gen.position': 'Позиции',
  'topo.gen.from': '{axis}: от',
  'topo.gen.to': '{axis}: до',
  'topo.gen.mask': 'Маска кода',
  'topo.gen.mask.help': '{ROW}, {RACK}, {TIER}, {POS}; «:2» дополняет число нулями до двух знаков. Пример: {ROW}-{RACK:2}-{TIER:2}-{POS} → A-06-04-2. Диапазон — числа (1…12) или буквы (A…F); пустой — координата не используется',
  'topo.gen.defaults': 'Ёмкость и признаки новых ячеек',
  'topo.gen.preview': 'Предпросмотр',
  'topo.gen.previewing': 'Считаем…',
  'topo.gen.previewTitle': 'Предпросмотр генератора',
  'topo.gen.create': 'Создать ячейки: {count}',
  'topo.gen.createNeedsPreview': 'Сначала предпросмотр',
  'topo.gen.summary': 'Шаблон описывает {total}: будет создано {create}, уже есть {existing}',
  'topo.gen.codes': 'Коды:',
  'topo.gen.skipped': 'Пропускаются (уже есть):',
  'topo.gen.nothingNew': 'Все ячейки шаблона уже есть — создавать нечего',
  'topo.gen.stale': 'Шаблон изменился после предпросмотра — обновите его',
  'topo.gen.done': 'Создано ячеек: {created}, пропущено существующих: {skipped}',
  'topo.wh.manager.locked': 'Заведующего назначает администратор: иначе заведующий мог бы забрать себе чужой склад',
  'topo.wh.notMine': 'не ваш склад',
  'topo.wh.notMine.hint': 'Править можно только склады, где вы заведующий',
  'topo.pick.search': 'Начните вводить имя',

  // Товар целиком (V60): форма, фото, характеристики, дерево категорий.
  'nav.productCategories': 'Категории товаров',
  'column.uom_id': 'Единица',
  'column.storage_condition': 'Условия хранения',
  'column.is_marked': 'Маркировка',
  'column.is_batch_tracked': 'Партионный учёт',
  'column.is_serial_tracked': 'Серийный учёт',
  'value.sales.product.storage_condition.ambient': 'Обычные',
  'value.sales.product.storage_condition.chilled': 'Охлаждение',
  'value.sales.product.storage_condition.frozen': 'Заморозка',
  'value.sales.product.storage_condition.hazardous': 'Опасный груз',
  'product.create.title': 'Новый товар',
  'product.create.submit': 'Создать товар',
  'product.edit.open': 'Редактировать',
  'product.edit.title': 'Правка товара',
  'product.edit.save': 'Сохранить',
  'product.form.section.main': 'Основное',
  'product.form.section.description': 'Описание',
  'product.form.section.accounting': 'Учёт и хранение',
  'product.form.section.marking': 'Маркировка',
  'product.form.needSkuName': 'Укажите артикул и название',
  'product.form.fix': 'Исправьте поля, отмеченные красным',
  'product.form.number': 'Нужно неотрицательное число',
  'product.form.integer': 'Нужно целое неотрицательное число',
  'product.form.noCategory': 'Без категории',
  'product.form.uomDefault': 'Штука (по умолчанию)',
  'product.form.description': 'Описание товара',
  'product.form.descriptionHelp': 'Абзацы разделяйте пустой строкой. Разметка не поддерживается — текст выводится как есть.',
  'product.form.tracking': 'Учёт единиц',
  'product.form.trackingHelp': 'Партии — остаток по партиям со сроками; серийные номера — каждая единица отдельно',
  'product.form.shelfLifeDays': 'Срок годности, дней',
  'product.form.reorderPoint': 'Точка дозаказа',
  'product.form.reorderHelp': 'При остатке ниже этого числа система предложит закупку',
  'product.form.volumeM3': 'Объём, м³',
  'product.form.lengthMm': 'Длина, мм',
  'product.form.widthMm': 'Ширина, мм',
  'product.form.heightMm': 'Высота, мм',
  'product.form.markedHelp': 'Товар подлежит маркировке «Честный ЗНАК»: при приёмке и отгрузке сканируется код DataMatrix',
  'product.form.marked.on': 'Подлежит маркировке',
  'product.form.marked.off': 'Не маркируется',
  'product.form.lockedHelp': 'Не меняется: по товару уже есть движения',
  'product.form.lockedNote': 'По товару уже есть движения или остаток — единица, тип и признаки учёта зафиксированы. Если они заданы неверно, заведите новый товар.',
  'product.form.conflict': 'Товар изменил кто-то другой, пока вы правили. Закройте форму и откройте снова — увидите свежие данные.',
  'product.tracking.none': 'Без партий и серий',
  'product.tracking.batch': 'Партии',
  'product.tracking.serial': 'Серийные номера',
  'product.tab.overview': 'Описание',
  'product.tab.photos': 'Фото',
  'product.card.error': 'Не удалось загрузить товар',
  'product.description.empty': 'Описания нет',
  'product.description.emptyText': 'Добавьте его через «Редактировать».',
  'product.dimensions': 'Габариты (Д × Ш × В)',
  'product.mm': 'мм',
  'product.badge.marked': 'Маркировка',
  'product.attr.title': 'Характеристики',
  'product.attr.empty': 'Характеристик нет',
  'product.attr.emptyText': 'Например: «Материал — сталь», «Длина — 120 мм».',
  'product.attr.edit': 'Изменить характеристики',
  'product.attr.add': 'Добавить характеристику',
  'product.attr.save': 'Сохранить характеристики',
  'product.attr.name': 'Название',
  'product.attr.value': 'Значение',
  'product.attr.unit': 'Единица',
  'product.attr.actions': 'Действия',
  'product.attr.nameOf': 'Название характеристики {index}',
  'product.attr.valueOf': 'Значение характеристики {index}',
  'product.attr.unitOf': 'Единица характеристики {index}',
  'product.attr.up': 'Поднять характеристику {index}',
  'product.attr.down': 'Опустить характеристику {index}',
  'product.attr.remove': 'Удалить характеристику {index}',
  'product.attr.duplicate': 'Характеристика «{name}» указана дважды',
  'product.attr.incomplete': 'У каждой характеристики должны быть название и значение',
  'product.photo.upload': 'Загрузить фото',
  'product.photo.uploading': 'Загружаем: {count}',
  'product.photo.choose': 'Выбрать фото',
  'product.photo.rules': 'JPEG, PNG или WebP, до {mb} МБ. Можно выбрать несколько.',
  'product.photo.full': 'Достигнут предел — {max} фото у товара',
  'product.photo.empty': 'Фото нет',
  'product.photo.emptyText': 'Загрузите одно или несколько — первое станет главным.',
  'product.photo.list': 'Фото товара',
  'product.photo.show': 'Показать фото {name}',
  'product.photo.main': 'Главное',
  'product.photo.makeMain': 'Сделать главным',
  'product.photo.left': 'Сдвинуть {name} левее',
  'product.photo.right': 'Сдвинуть {name} правее',
  'product.photo.delete': 'Удалить фото {name}',
  'product.photo.deleteTitle': 'Удалить фото?',
  'product.photo.deleteConfirm': 'Удалить фото',
  'product.photo.deleteText': 'Фото «{name}» будет удалено из галереи и из хранилища.',
  'product.photo.deleteMainText': 'Фото «{name}» — главное. Главным станет следующее по порядку.',
  'product.photo.none': 'Фото нет',
  'product.photo.openGallery': 'Открыть галерею',
  'product.photo.state.pending': 'Проверяется антивирусом',
  'product.photo.state.loading': 'Загружается',
  'product.photo.state.rejected': 'Не прошло проверку',
  'category.lead': 'Дерево разделов каталога. Удалить можно только пустую категорию — без товаров и подкатегорий.',
  'category.ro': 'Править категории может тот, у кого есть право на правку номенклатуры.',
  'category.addRoot': 'Новая категория',
  'category.addChild': 'Добавить подкатегорию',
  'category.edit': 'Переименовать или перенести',
  'category.delete': 'Удалить',
  'category.notEmpty': 'Нельзя: товаров {products}, подкатегорий {children}',
  'category.empty': 'Категорий пока нет',
  'category.emptyText': 'Заведите первую — товары можно будет разложить по разделам.',
  'category.collapse': 'Свернуть «{name}»',
  'category.expand': 'Развернуть «{name}»',
  'category.counts': 'товаров {products} · подкатегорий {children}',
  'category.menu': 'Действия с категорией «{name}»',
  'category.deleteTitle': 'Удалить категорию «{name}»?',
  'category.deleteText': 'Категория пуста — товары и подкатегории в ней не останутся без раздела.',
  'category.createTitle': 'Новая категория',
  'category.editTitle': 'Категория',
  'category.name': 'Название',
  'category.parent': 'Родительская категория',
  'category.parentHelp': 'Выберите другую, чтобы перенести категорию вместе с её подкатегориями. Внутрь собственной ветки перенести нельзя.',
  'category.root': 'Корень каталога',
  'nav.priceLists': 'Прайс-листы',
  'nav.salesPlans': 'Планы продаж',
  'plans.lead': 'План на период против факта — выигранных сделок, закрытых в этом периоде. Руководитель видит свой отдел, менеджер — себя',
  'plans.quarter': 'Квартал',
  'plans.quarter.label': '{q} квартал {year}',
  'plans.quarter.prev': 'Предыдущий квартал',
  'plans.quarter.next': 'Следующий квартал',
  'plans.add': 'Задать план',
  'plans.employees': 'По менеджерам',
  'plans.employees.empty': 'На этот квартал планов по менеджерам нет',
  'plans.employees.empty.text': 'Выполнение считается от плана: без цифры показать нечего',
  'plans.departments': 'По отделам',
  'plans.departments.empty': 'На этот квартал планов по отделам нет',
  'plans.forbidden': 'Нет доступа к планам продаж',
  'plans.error': 'Планы не загрузились',
  'plans.unnamed': 'Без имени',
  'plans.col.employee': 'Менеджер',
  'plans.col.department': 'Отдел',
  'plans.col.period': 'Период',
  'plans.col.planned': 'План',
  'plans.col.actual': 'Факт',
  'plans.col.completion': 'Выполнение',
  'plans.col.detail': 'Подробнее',
  'plans.col.month': 'Месяц',
  'plans.col.cumulative': 'Нарастающим итогом',
  'plans.wholeQuarter': 'Весь квартал',
  'plans.open': 'Прогноз и месяцы: {name}',
  'plans.forecastAndMonths': 'Прогноз и месяцы',
  'plans.actions': 'Действия с планом: {name}',
  'plans.percent': '{value} %',
  'plans.noTarget': 'Цель не задана',
  'plans.noTarget.hint': 'План нулевой: процент выполнения не считается — «не ставили» и «не выполнил» разные вещи',
  'plans.detail': 'План продаж',
  'plans.detail.planned': 'План: {amount}',
  'plans.close': 'Закрыть',
  'plans.forecast': 'Прогноз на конец периода',
  'plans.forecast.employeeOnly': 'Прогноз считается только по плану менеджера: воронка привязана к человеку',
  'plans.forecast.error': 'Прогноз не загрузился',
  'plans.forecast.actual': 'Заработано',
  'plans.forecast.pipeline': 'Взвешенная воронка',
  'plans.forecast.projected': 'Прогноз',
  'plans.forecast.verdict': 'Итог',
  'plans.forecast.onTrack': 'Идёт к плану',
  'plans.forecast.behind': 'Не дотягивает до плана',
  'plans.months': 'По месяцам',
  'plans.months.error': 'Разбивка по месяцам не загрузилась',
  'plans.form': 'План продаж',
  'plans.new': 'Новый план',
  'plans.form.forbidden': 'Нет права задавать планы',
  'plans.form.kind': 'Кому',
  'plans.form.kind.employee': 'Менеджеру',
  'plans.form.kind.department': 'Отделу',
  'plans.form.choose': '— выберите —',
  'plans.form.employee.help': 'Только те, кому вы вправе задать план',
  'plans.form.nobody': 'Нет сотрудников, которым вы вправе задать план',
  'plans.form.from': 'Начало периода',
  'plans.form.to': 'Конец периода',
  'plans.form.period.help': 'По умолчанию — выбранный квартал',
  'plans.form.periodInvalid': 'Конец периода раньше начала',
  'plans.form.amount': 'Сумма плана',
  'plans.form.amountInvalid': 'Сумма — неотрицательное число, не больше двух знаков после запятой',
  'plans.form.currency': 'Валюта',
  'plans.form.currencyInvalid': 'Трёхбуквенный код валюты, например RUB',
  'plans.revise': 'Изменить сумму',
  'plans.revise.title': 'Изменить план: {name}',
  'plans.revise.help': 'Период и кому задан план не меняются — это был бы уже другой план',
  'pl.lead': 'Цены товаров по прайсам. Строка сделки или КП без цены берёт цену из прайса клиента, а если его нет — из действующего прайса с наибольшим приоритетом в валюте документа; при равенстве — из прайса по умолчанию',
  'pl.ro': 'Прайсы и цены можно смотреть, но не менять: нужно право правки прайс-листов',
  'pl.add': 'Новый прайс-лист',
  'pl.new': 'Новый прайс-лист',
  'pl.form': 'Прайс-лист',
  'pl.search': 'Поиск по коду и названию',
  'pl.forbidden': 'Прайс-листы недоступны',
  'pl.error': 'Не удалось загрузить прайс-листы',
  'pl.empty': 'Прайс-листов пока нет',
  'pl.empty.text': 'Без прайса цену в строке сделки и КП вводят вручную',
  'pl.notFound': 'Ничего не найдено по «{query}»',
  'pl.code': 'Код',
  'pl.code.help': 'Необязательно — без кода будет назначен PL-NNNNNN',
  'pl.codeLocked': 'Код не меняется: по нему видно, откуда цена в документе',
  'pl.name': 'Название',
  'pl.currency': 'Валюта',
  'pl.currency.help': 'Код ISO из трёх букв: RUB, USD, EUR. Все цены прайса — в этой валюте',
  'pl.currencyInvalid': 'Три латинские буквы',
  'pl.currencyLocked': 'В прайсе уже есть цены — валюта не меняется: цены переименовались бы, а не пересчитались. Заведите новый прайс',
  'pl.period': 'Срок',
  'pl.period.open': 'без границы',
  'pl.period.always': 'бессрочно',
  'pl.periodInvalid': 'Окончание раньше начала',
  'pl.validFrom': 'Действует с',
  'pl.validFrom.help': 'Пусто — с любой даты',
  'pl.validUntil': 'Действует по',
  'pl.validUntil.help': 'Пусто — бессрочно; включительно',
  'pl.priority': 'Приоритет',
  'pl.priority.help': 'Больше — важнее: акция с приоритетом 10 перекрывает базовый прайс с 0',
  'pl.priorityIs': 'приоритет {priority}',
  'pl.state': 'Состояние',
  'pl.state.active': 'действует',
  'pl.state.inactive': 'выключен',
  'pl.state.outOfPeriod': 'вне срока',
  'pl.items': 'Цен',
  'pl.counterparties': 'Клиентов',
  'pl.counterpartiesIs': 'назначен клиентам: {count}',
  'pl.default': 'По умолчанию',
  'pl.default.help': 'Один на валюту и день: второй прайс по умолчанию с пересекающимся сроком сервер не примет',
  'pl.default.on': 'Прайс по умолчанию',
  'pl.default.off': 'Обычный прайс',
  'pl.active': 'Активен',
  'pl.active.help': 'Выключенный прайс не оценивает документы и не показывается в ценах товара',
  'pl.actions': 'Действия с прайсом {code}',
  'pl.delete': 'Удалить прайс',
  'pl.deleteBlocked': 'Назначен клиентам ({count}) — они остались бы без цен',
  'pl.deleteConfirm': 'Удалить прайс «{name}»?',
  'pl.deleteConfirm.text': 'Цены в уже выставленных документах не изменятся — документ хранит свою цену. Новые строки этот прайс оценивать перестанет',
  'pl.prices': 'Цены',
  'pl.items.search': 'Артикул или название',
  'pl.items.add': 'Добавить товары',
  'pl.items.addTitle': 'Добавить товары в прайс',
  'pl.items.addSubtitle': 'У каждого товара своя цена в {currency}',
  'pl.items.addCount': 'Добавить: {count}',
  'pl.items.pick': 'Товар',
  'pl.items.pickHint': 'Найдите товар по названию и выберите — можно несколько',
  'pl.items.chosen': 'Выбранные товары',
  'pl.items.unpick': 'Убрать «{name}» из выбора',
  'pl.items.refused': 'Не добавлены:',
  'pl.items.empty': 'В прайсе нет цен',
  'pl.items.empty.text': 'Добавьте товары или загрузите цены из CSV',
  'pl.items.notFound': 'Нет товаров по «{query}»',
  'pl.sku': 'Артикул',
  'pl.product': 'Товар',
  'pl.uom': 'Ед.',
  'pl.price': 'Цена, {currency}',
  'pl.priceFor': 'Цена {sku}',
  'pl.priceInvalid': 'Число не меньше нуля, до четырёх знаков после запятой',
  'pl.editPrice': 'Изменить цену {sku}',
  'pl.fromQuantity': 'от {quantity}',
  'pl.productInactive': 'выведен из продажи',
  'pl.removeItem': 'Убрать {sku} из прайса',
  'pl.removeItem.confirm': 'Убрать {sku} из прайса?',
  'pl.removeItem.do': 'Убрать',
  'pl.removeItem.text': 'Строки сделок и КП без цены перестанут получать цену этого товара из прайса',
  'pl.import': 'Импорт CSV',
  'pl.import.title': 'Импорт цен из CSV',
  'pl.import.format': 'Две колонки с заголовком: «Артикул» и «Цена» (разделитель — точка с запятой или запятая, дробная часть — через запятую или точку). Цена товара, уже бывшего в прайсе, заменяется; нового — добавляется',
  'pl.import.file': 'Файл',
  'pl.import.run': 'Загрузить',
  'pl.import.running': 'Загружаем…',
  'pl.import.summary': 'Добавлено: {created}, обновлено: {updated}, с ошибкой: {failed}',
  'pl.import.errors': 'Строки с ошибкой',
  'pl.import.line': 'Строка',
  'pl.import.column': 'Колонка',
  'pl.import.reason': 'Причина',
  'pl.product.title': 'Цены товара по прайсам',
  'pl.product.forbidden': 'Нет доступа к прайс-листам',
  'pl.product.none': 'Сегодня цен по прайсам нет',
  'pl.product.none.text': 'Товар не входит ни в один действующий прайс — в строке документа цену вводят вручную',
  'pl.product.list': 'Прайс-лист',
  'pl.product.price': 'Цена',
  'pl.product.from': 'От количества',
  'pl.product.discount': 'база {base}, скидка {percent} %',
  'product.tab.prices': 'Цены',
  // ------------------------------------------------- ревизия #82–#94 (октябрь 2026)
  'record.inv.submitApproval': 'На согласование',
  'record.inv.approval.submitted': 'Счёт отправлен на согласование.',
  'record.inv.approval.notRequired': 'Пороги не перейдены — согласование не нужно, счёт можно отправлять.',
  'record.inv.line.add': 'Добавить позицию',
  'record.inv.line.added': 'Позиция добавлена, итоги пересчитаны.',
  'record.inv.line.removed': 'Позиция убрана, итоги пересчитаны.',
  'record.inv.line.remove': 'Убрать позицию «{line}»',
  'record.inv.line.actions': 'Действия с позицией',
  'dashboard.none.title': 'Дашбордов пока нет',
  'dashboard.none.text': 'Соберите первый дашборд из сохранённых отчётов — он будет открываться при входе.',
  'dashboard.none.textReadOnly': 'Вам ещё не открыли ни одного дашборда. Создать его может руководитель или аналитик.',
  'dashboard.none.create': 'Создать первый дашборд',
  'dashboard.noWidgets.title': 'На дашборде пока нет виджетов',
  'dashboard.noWidgets.textReadOnly': 'Виджеты добавляет владелец дашборда.',
  'dashboard.noWidgets.add': 'Добавить виджет',
  'dashboard.widget.empty': 'Отчёт под виджетом не вернул ни одной строки',
  'rb.saveChanges': 'Сохранить изменения',
  'rb.saveAsNew': 'Сохранить как новый',
  'leave.create.title': 'Заявка на отсутствие',
  'leave.create.submit': 'Подать заявку',
  'leave.create.from': 'С',
  'leave.create.to': 'По',
  'leave.create.comment': 'Комментарий',
  'leave.create.needEmployee': 'Выберите сотрудника',
  'leave.create.needDates': 'Укажите даты начала и конца',
  'leave.create.badPeriod': 'Конец раньше начала',
  'leave.create.employeeHelp': 'Пусто — заявка от вашего имени. Маршрут согласования построит система.',
  'leave.create.employeeHelpNoCard': 'У вашей учётной записи нет карточки сотрудника — выберите, за кого подаёте.',
  'record.hr.leave.cancel': 'Отменить заявку',
  'record.hr.leave.cancelTitle': 'Отменить заявку на отсутствие?',
  'record.hr.leave.cancelText': 'Заявка будет отменена сегодняшним днём. Если отпуск уже согласован, списанные дни вернутся на остаток.',
  'record.hr.leave.cancelled': 'Заявка отменена.',
  // Задачи, встречи, напоминания, календарь (#110–#113)
  'nav.calendar': 'Календарь',
  'tasks.new': 'Новая задача',
  'tasks.noRecord': 'Без записи',
  'cal.title': 'Календарь',
  'cal.view': 'Вид календаря',
  'cal.view.day': 'День',
  'cal.view.week': 'Неделя',
  'cal.view.month': 'Месяц',
  'cal.prev': 'Назад',
  'cal.next': 'Вперёд',
  'cal.today': 'Сегодня',
  'cal.newTask': 'Задача',
  'cal.newMeeting': 'Встреча',
  'cal.grid': 'Сетка календаря',
  'cal.empty': 'В этот период задач и встреч нет',
  'cal.forbidden.title': 'Нет доступа к календарю',
  'cal.forbidden.text': 'Календарь показывает задачи и встречи — для него нужно право на задачи и активности.',
  'cal.forbiddenPeople.text': 'Среди выбранных есть сотрудник, чей календарь вам не открыт: ваше право — на свои задачи или на свой отдел. Уберите его из выбора.',
  'cal.error.title': 'Календарь не загрузился',
  'cal.noPeople.title': 'Не выбрано, чей календарь показать',
  'cal.noPeople.text': 'У учётной записи нет карточки сотрудника, поэтому своего календаря нет. Выберите сотрудников, чьи календари вам открыты.',
  'cal.slot.title': 'Новое на это время',
  'cal.slot.text': 'Запланировать на {when}:',
  'cal.slot.task': 'Задачу',
  'cal.slot.meeting': 'Встречу',
  'cal.openDay': 'Открыть день {when}',
  'cal.more': 'ещё {count}',
  'cal.people.me': 'Только я',
  'cal.people.department': 'Мой отдел',
  'cal.people.pick': 'Сотрудники',
  'cal.people.filter': 'Найти по имени или отделу',
  'cal.people.done': 'Готово',
  'cal.people.ownOnly': 'Вам открыт только свой календарь',
  'cal.people.legend': 'Чьи календари на сетке',
  'cal.people.error': 'Список сотрудников не загрузился',
  'cal.kind.task': 'Задача',
  'cal.kind.meeting': 'Встреча',
  'cal.kind.call': 'Звонок',
  'cal.details.close': 'Закрыть',
  'cal.conflict': 'Пересекается с другой встречей того же человека',
  'cal.conflict.short': 'пересечение',
  'cal.when': 'Когда',
  'cal.status': 'Статус',
  'cal.organizer': 'Организатор',
  'cal.record': 'Запись',
  'cal.noRecord': 'Без записи',
  'cal.participants': 'Участники',
  'cal.participant.employee': 'сотрудник',
  'cal.participant.contact': 'контакт клиента',
  'cal.contact.hidden': 'Контакт клиента (нет доступа)',
  'cal.moveTo': 'Перенести на',
  'cal.moveTo.help': 'То же, что перетащить на сетке: встреча сохранит длительность',
  'cal.move': 'Перенести',
  'cal.readOnly': 'Перенести и изменить может организатор или его руководитель',
  'cal.edit': 'Изменить',
  'cal.plan': 'Запланировать',
  'cal.plan.task': 'Задача…',
  'cal.plan.meeting': 'Встреча…',
  'cal.remind.default': 'По настройкам компании',
  'cal.remind.none': 'Не напоминать',
  'cal.remind.0': 'В момент начала',
  'cal.remind.5': 'За 5 минут',
  'cal.remind.10': 'За 10 минут',
  'cal.remind.15': 'За 15 минут',
  'cal.remind.30': 'За 30 минут',
  'cal.remind.60': 'За час',
  'cal.remind.120': 'За 2 часа',
  'cal.remind.1440': 'За сутки',
  'cal.remind.before': 'за {minutes} мин',
  'cal.repeat.none': 'Не повторять',
  'cal.repeat.daily': 'Каждый день',
  'cal.repeat.weekly': 'Каждую неделю',
  'cal.repeat.monthly': 'Каждый месяц',
  'cal.repeat.until': 'до {date}',
  'cal.form.task.overline': 'Задача',
  'cal.form.task.new': 'Новая задача',
  'cal.form.task.edit': 'Изменить задачу',
  'cal.form.task.create': 'Поставить задачу',
  'cal.form.meeting.overline': 'Встреча',
  'cal.form.meeting.new': 'Новая встреча',
  'cal.form.meeting.edit': 'Изменить встречу',
  'cal.form.meeting.create': 'Назначить встречу',
  'cal.form.save': 'Сохранить',
  'cal.form.needSubject': 'Нужна тема',
  'cal.form.needDueForRepeat': 'У повторяющейся задачи должен быть срок — от него считается следующая',
  'cal.form.needAssignee': 'Задаче без записи нужен исполнитель — иначе её не увидит никто',
  'cal.form.needStart': 'Нужно начало встречи',
  'cal.form.endBeforeStart': 'Встреча должна заканчиваться позже, чем начинается',
  'cal.form.subject': 'Тема',
  'cal.form.due': 'Срок',
  'cal.form.remind': 'Напомнить',
  'cal.form.assignee': 'Исполнитель',
  'cal.form.assignee.ownHelp': 'Вы можете ставить задачи только себе',
  'cal.form.assignee.none': 'Не выбран',
  'cal.form.me': '{name} (я)',
  'cal.form.repeat': 'Повтор',
  'cal.form.until': 'Повторять до',
  'cal.form.until.help': 'Пусто — без конца. Следующая задача появится, когда текущая выполнена или отменена',
  'cal.form.body': 'Описание',
  'cal.form.agenda': 'Повестка',
  'cal.form.start': 'Начало',
  'cal.form.end': 'Конец',
  'cal.form.location': 'Место или ссылка',
  'cal.form.location.help': 'Адрес, переговорная или ссылка на видеозвонок',
  'cal.form.employees': 'Сотрудники',
  'cal.form.employees.help': 'Выбрано: {count}. Приглашённые получат уведомление',
  'cal.form.employees.filter': 'Найти по имени или отделу',
  'cal.form.contacts': 'Контакты клиента',
  'cal.form.contacts.remove': 'Убрать {name}',
  'adm.settings.reminders': 'Напоминания',
  'adm.settings.reminders.text': 'За сколько до встречи или срока задачи приходит уведомление, если в форме не выбрано своё.',
  'adm.settings.reminder': 'Напоминать за, минут',
  'adm.settings.reminder.help': 'Действует для задач и встреч, поставленных после сохранения; уже запланированные сохраняют своё',
  'adm.settings.reminder.invalid': 'Целое число минут от 0 до 10080 (неделя)',
  // Почта: письма клиенту с карточки и шаблоны (#117)
  'nav.adminMail': 'Почта',
  'mail.write': 'Написать письмо',
  'mail.record.deal': 'Письмо по сделке',
  'mail.record.counterparty': 'Письмо клиенту',
  'mail.record.contact': 'Письмо контакту',
  'mail.record.invoice': 'Письмо по счёту',
  'mail.form': 'Письмо',
  'mail.close': 'Закрыть',
  'mail.send': 'Отправить',
  'mail.sending': 'Отправляем…',
  'mail.draft.error': 'Не удалось подготовить письмо',
  'mail.notConnected': 'Почта не подключена: письмо запишется в ленту с отказом и клиенту не уйдёт. Подключение — в администрировании, раздел «Почта».',
  'mail.template': 'Шаблон',
  'mail.template.blank': 'Без шаблона',
  'mail.template.none': 'Шаблонов для этой карточки нет',
  'mail.to': 'Кому',
  'mail.to.help': 'Адрес из контактов клиента или любой другой',
  'mail.recipients': 'Контакты клиента',
  'mail.subject': 'Тема',
  'mail.body': 'Текст',
  'mail.missing': 'Нечего подставить: {list}. На их месте в тексте пусто — допишите вручную',
  'mail.attachments': 'Вложения',
  'mail.attachment.invoicePdf': 'печатная форма счёта',
  'mail.attachment.unavailable.pending': 'ещё проверяется антивирусом',
  'mail.attachment.unavailable.infected': 'заблокирован антивирусом',
  'mail.attachment.unavailable.failed': 'проверка не удалась',
  'mail.attachment.unavailable.missing': 'файла нет в хранилище',
  'mail.result.title': 'Письмо',
  'mail.result.sent': 'Отправлено: {to}',
  'mail.result.failed': 'Почтовый сервер не ответил — письмо в очереди повтора, следующая попытка {when}.',
  'mail.result.rejected': 'Не отправлено: {reason}',
  'mail.result.pending': 'Письмо записано, состояние отправки пока неизвестно',
  'mail.feed.pending': 'ждёт отправки',
  'mail.feed.sending': 'отправляется',
  'mail.feed.sent': 'отправлено',
  'mail.feed.failed': 'в очереди повтора',
  'mail.feed.failedBecause': 'в очереди повтора: {reason}',
  'mail.feed.rejected': 'не отправлено',
  'mail.feed.rejectedBecause': 'не отправлено: {reason}',
  'nav.mailInbox': 'Разбор почты',
  'mail.noSubject': '(без темы)',
  'mail.feed.inbound': 'Входящее',
  'mail.feed.reply': 'ответ на наше письмо',
  'mail.feed.files': 'вложения: {files}',
  'mailbox.title': 'Входящая почта: IMAP-ящики',
  'mailbox.lead': 'Письма из этих ящиков попадают в ленту карточки клиента: ответ на письмо из CRM — в тот же тред, письмо известного контакта — в его карточку, остальные — в очередь разбора.',
  'mailbox.add': 'Подключить ящик',
  'mailbox.form': 'Настройки ящика',
  'mailbox.name': 'Название',
  'mailbox.kind': 'Вид',
  'mailbox.kind.shared': 'Общий',
  'mailbox.kind.personal': 'Личный',
  'mailbox.kind.personalOf': 'Личный: {owner}',
  'mailbox.owner': 'Владелец',
  'mailbox.owner.noAccess': 'Список пользователей — отдельное право (пользователи); владельца можно оставить прежним',
  'mailbox.folder': 'Папка',
  'mailbox.enabled': 'Опрашивать ящик',
  'mailbox.server': 'Сервер',
  'mailbox.state': 'Состояние',
  'mailbox.pollNow': 'Проверить сейчас',
  'mailbox.empty': 'Ни одного ящика не подключено',
  'mailbox.empty.text': 'Входящие письма в CRM не попадают, пока не подключён хотя бы один IMAP-ящик',
  'mailbox.error': 'Список ящиков не загрузился',
  'mailbox.forbidden': 'Ящики — учётные данные почты',
  'mailbox.delete.confirm': 'Отключить ящик «{name}»?',
  'mailbox.delete.text': 'Опрос прекратится. Уже полученные письма останутся в карточках клиентов.',
  'mailbox.status.idle': 'ещё не опрашивался',
  'mailbox.status.ok': 'опрошен {at}',
  'mailbox.status.failed': 'сервер недоступен, повтор {at}: {error}',
  'mailbox.status.rejected': 'сервер отказал, опрос остановлен до сохранения настроек: {error}',
  'mailbox.poll.ok': '«{name}»: получено писем {received}, из них в разбор {unmatched}',
  'mailbox.poll.failed': '«{name}»: сервер недоступен — {error}',
  'mailbox.poll.rejected': '«{name}»: сервер отказал — {error}',
  'mailbox.poll.busy': '«{name}»: ящик уже опрашивается',
  'mailbox.poll.disabled': '«{name}»: опрос выключен или не хватает настроек',
  'inbox.title': 'Разбор входящей почты',
  'inbox.lead': 'Письма, отправителя которых система не нашла среди контактов и контрагентов. Подсказка по домену почты — только подсказка: прикрепляет письмо человек.',
  'inbox.ro': 'Прикреплять и отклонять письма может только тот, у кого есть право на разбор почты.',
  'inbox.forbidden': 'Очередь разбора почты закрыта',
  'inbox.error': 'Очередь разбора не загрузилась',
  'inbox.empty': 'Неразобранных писем нет',
  'inbox.empty.text': 'Все полученные письма сопоставлены с карточками',
  'inbox.noSender': 'отправитель не указан',
  'inbox.files': 'Вложения',
  'inbox.skipped': 'Не сохранены: {files}',
  'inbox.suggestion': 'Возможно, это {name} — по домену почты',
  'inbox.attachTo': 'Прикрепить к',
  'inbox.target.counterparty': 'Контрагент',
  'inbox.target.contact': 'Контакт',
  'inbox.target.deal': 'Сделка',
  'inbox.attach': 'Прикрепить',
  'inbox.dismiss': 'Не по делу',
  'adm.resource.mail.inbox': 'Разбор входящей почты',
  'mail.anchor.any': 'Любая карточка',
  'mail.anchor.deal': 'Сделка',
  'mail.anchor.counterparty': 'Контрагент',
  'mail.anchor.contact': 'Контакт',
  'mail.anchor.invoice': 'Счёт',
  'mail.adm.title': 'Почта',
  'mail.adm.lead': 'Подключение почтового сервера и шаблоны писем клиентам. Переменные подставляются из карточки, с которой пишут письмо.',
  'mail.adm.add': 'Новый шаблон',
  'mail.adm.templates': 'Шаблоны писем',
  'mail.adm.forbidden': 'Нет доступа к шаблонам писем',
  'mail.adm.error': 'Не удалось загрузить шаблоны',
  'mail.adm.empty': 'Шаблонов пока нет',
  'mail.adm.empty.text': 'Менеджеры могут писать и без шаблона; шаблон избавляет от набора одного и того же',
  'mail.adm.name': 'Название',
  'mail.adm.anchor': 'Для карточки',
  'mail.adm.anchor.help': 'От этого зависит, какие переменные доступны',
  'mail.adm.state': 'Состояние',
  'mail.adm.actions': 'Действия',
  'mail.adm.actionsOf': 'Действия с шаблоном «{name}»',
  'mail.adm.edit': 'Изменить шаблон',
  'mail.adm.disable': 'Выключить',
  'mail.adm.enable': 'Включить',
  'mail.adm.delete': 'Удалить',
  'mail.adm.delete.confirm': 'Удалить шаблон «{name}»?',
  'mail.adm.delete.text': 'Отправленные письма останутся в лентах; шаблон перестанет предлагаться',
  'mail.adm.form': 'Шаблон письма',
  'mail.adm.variables': 'Переменные',
  'mail.adm.variables.help': 'Нажмите, чтобы вставить в текст. Неизвестная переменная или переменная другой карточки не сохранится',
  'mail.conn.title': 'Подключение SMTP',
  'mail.conn.forbidden': 'Подключение почты закрыто',
  'mail.conn.forbidden.text': 'Учётные данные почтового сервера — отдельное право (интеграции)',
  'mail.conn.error': 'Не удалось загрузить подключение почты',
  'mail.conn.off': 'Почта выключена: письма с карточек записываются в ленту с отказом и клиентам не уходят',
  'mail.conn.enabled': 'Отправлять письма',
  'mail.conn.host': 'Сервер',
  'mail.conn.port': 'Порт',
  'mail.conn.security': 'Шифрование',
  'mail.conn.security.starttls': 'STARTTLS',
  'mail.conn.security.ssl': 'SSL/TLS',
  'mail.conn.security.none': 'Без шифрования',
  'mail.conn.username': 'Логин',
  'mail.conn.password': 'Пароль',
  'mail.conn.password.set': 'Пароль сохранён; пустое поле оставит его прежним',
  'mail.conn.password.unset': 'Пароль не задан',
  'mail.conn.password.clear': 'Стереть пароль',
  'mail.conn.from': 'Адрес отправителя',
  'mail.conn.fromName': 'Имя отправителя',
  'mail.conn.saved': 'Сохранено',

  // ИИ (#126)
  'nav.adminAi': 'ИИ',
  'adm.action.use': 'Использование',
  'adm.resource.ai.assistant': 'Функции ИИ',
  'ai.adm.title': 'ИИ',
  'ai.adm.lead': 'Провайдер языковой модели, включение на организацию, расход токенов и промпты. Персональные данные маскируются до отправки провайдеру',
  'ai.adm.forbidden': 'Настройки ИИ закрыты',
  'ai.conn.title': 'Подключение провайдера',
  'ai.conn.forbidden': 'Подключение провайдера закрыто',
  'ai.conn.forbidden.text': 'Ключ провайдера, расход и журнал вызовов — отдельное право (интеграции)',
  'ai.conn.error': 'Не удалось загрузить подключение ИИ',
  'ai.conn.off': 'ИИ выключен: функции ИИ отказывают с объяснением и к провайдеру ничего не отправляют',
  'ai.conn.masking': 'ФИО, телефоны, почта, паспорт, СНИЛС, ИНН, карты и счета заменяются метками до отправки и восстанавливаются в ответе. В журнале — только число замен, не значения',
  'ai.conn.enabled': 'ИИ включён',
  'ai.conn.provider': 'Провайдер',
  'ai.conn.provider.none': 'Не выбран',
  'ai.conn.endpoint': 'Адрес API',
  'ai.conn.endpoint.help': 'Пусто — публичный адрес провайдера',
  'ai.conn.folderId': 'Каталог (folderId)',
  'ai.conn.scope': 'Область доступа (scope)',
  'ai.conn.scope.help': 'Как выдано в личном кабинете GigaChat',
  'ai.conn.authEndpoint': 'Адрес авторизации',
  'ai.conn.model': 'Модель',
  'ai.conn.model.help': 'Пусто — модель провайдера по умолчанию',
  'ai.conn.embeddingModel': 'Модель эмбеддингов',
  'ai.conn.secret': 'Ключ доступа',
  'ai.conn.secret.set': 'Ключ сохранён; пустое поле оставит его прежним',
  'ai.conn.secret.unset': 'Ключ не задан',
  'ai.conn.secret.clear': 'Стереть ключ',
  'ai.conn.limit': 'Лимит токенов на пользователя в месяц',
  'ai.conn.limit.help': 'Исчерпавший лимит получает отказ до обращения к провайдеру',
  'ai.conn.priceInput': 'Цена 1000 токенов запроса, ₽',
  'ai.conn.priceOutput': 'Цена 1000 токенов ответа, ₽',
  'ai.conn.priceEmbedding': 'Цена 1000 токенов эмбеддингов, ₽',
  'ai.conn.price.help': 'Пусто — стоимость не считается и показывается прочерком, а не нулём',
  'ai.conn.timeout': 'Таймаут запроса, с',
  'ai.conn.saved': 'Сохранено',
  'ai.conn.check': 'Проверить подключение',
  'ai.conn.checking': 'Проверяем…',
  'ai.check.result': 'Результат проверки',
  'ai.check.ok': 'Провайдер ответил',
  'ai.check.rejected': 'Провайдер отказал',
  'ai.check.unavailable': 'Провайдер недоступен',
  'ai.org.title': 'Организации',
  'ai.org.lead': 'ИИ включается на юрлицо: сотрудники выключенной организации получают отказ с объяснением',
  'ai.org.empty': 'Организаций нет',
  'ai.org.name': 'Организация',
  'ai.org.state': 'ИИ',
  'ai.org.switch': 'ИИ для «{name}»',
  'ai.usage.title': 'Расход по пользователям',
  'ai.usage.month': 'Месяц',
  'ai.usage.limit': 'Лимит на пользователя: {limit} токенов в месяц',
  'ai.usage.empty': 'В этом месяце к ИИ не обращались',
  'ai.usage.user': 'Пользователь',
  'ai.usage.system': 'Система',
  'ai.usage.calls': 'Вызовов',
  'ai.usage.failures': 'Сбоев',
  'ai.usage.input': 'Токенов запроса',
  'ai.usage.output': 'Токенов ответа',
  'ai.usage.cost': 'Стоимость',
  'ai.usage.cost.unknown': 'Цена за токены не задана хотя бы для одного вызова',
  'ai.cost.unknown': 'не задана',
  'ai.calls.title': 'Журнал вызовов',
  'ai.calls.lead': 'Кто, когда, какой промпт и сколько токенов. Текст запросов и ответов не хранится',
  'ai.calls.empty': 'Вызовов ещё не было',
  'ai.calls.at': 'Когда',
  'ai.calls.prompt': 'Промпт',
  'ai.calls.embed': 'эмбеддинги',
  'ai.calls.provider': 'Провайдер',
  'ai.calls.status': 'Итог',
  'ai.calls.status.succeeded': 'успешно',
  'ai.calls.status.failed': 'недоступен',
  'ai.calls.status.rejected': 'отказ',
  'ai.calls.status.pending': 'в работе',
  'ai.calls.masked': 'Замаскировано',
  'ai.calls.tokens': 'Токенов',
  'ai.prompts.title': 'Промпты',
  'ai.prompts.lead': 'Правка — новая версия; журнал помнит, какой версией получен ответ, прежнюю можно вернуть',
  'ai.prompts.forbidden': 'Промпты закрыты',
  'ai.prompts.forbidden.text': 'Реестр промптов — справочник раздела (настройки системы)',
  'ai.prompts.empty': 'Промптов нет',
  'ai.prompts.add': 'Новый промпт',
  'ai.prompts.code': 'Код',
  'ai.prompts.code.help': 'Латиница, цифры, точка, дефис; по нему промпт вызывает функция',
  'ai.prompts.active': 'Действует',
  'ai.prompts.variables': 'Переменные',
  'ai.prompts.history': 'Версии',
  'ai.prompts.versions': 'версий: {count}',
  'ai.prompts.activate': 'Действующая версия {code}',
  'ai.prompts.actions': 'Действия',
  'ai.prompts.newVersion': 'Новая версия',
  'ai.prompts.newVersionOf': 'Новая версия {code}',
  'ai.prompts.form': 'Промпт',
  'ai.prompts.format': 'Формат ответа',
  'ai.prompts.format.text': 'Текст',
  'ai.prompts.format.json': 'JSON',
  'ai.prompts.temperature': 'Температура',
  'ai.prompts.maxTokens': 'Предел ответа, токенов',
  'ai.prompts.description': 'Описание',
  'ai.prompts.system': 'Инструкция (system)',
  'ai.prompts.user': 'Запрос',
  'ai.prompts.user.help': 'Переменные — в двойных фигурных скобках; значения подставляет функция, переменная без значения — отказ, а не скобки в запросе',

  // Автосценарии (#116)
  'nav.adminAutomation': 'Автосценарии',
  'adm.auto.title': 'Автосценарии',
  'adm.auto.lead': 'Правило следит за событием — новая запись, смена поля или стадии, срок — проверяет условия и выполняет действия. Правила одной группы выполняются сверху вниз. Удалить правило нельзя: на него ссылается журнал запусков, его выключают.',
  'adm.auto.count': 'правил: {count}',
  'adm.auto.ro': 'Правила, их порядок и включение меняет администратор системы. Журнал запусков доступен для чтения.',
  'adm.auto.add': 'Новое правило',
  'adm.auto.forbidden': 'Автосценарии вам недоступны',
  'adm.auto.error': 'Не удалось загрузить автосценарии',
  'adm.auto.empty': 'Правил пока нет',
  'adm.auto.empty.text': 'Соберите первое: событие, условия и действие — без SQL.',
  'adm.auto.move': 'Переместить «{name}»: стрелки вверх и вниз',
  'adm.auto.enabledOf': 'Правило «{name}» включено',
  'adm.auto.journalOf': 'Журнал правила «{name}»',
  'adm.auto.journal': 'Журнал',
  'adm.auto.editOf': 'Изменить правило «{name}»',
  'adm.auto.previous': '{label} — прежнее значение',
  'adm.auto.and': 'и',
  'adm.auto.or': 'или',
  'adm.auto.if': 'если',
  'adm.auto.rawSummary': 'Условия сложнее конструктора — открываются текстом JSON',
  'adm.auto.always': 'Всегда — без условий',
  'adm.auto.overline': 'Автосценарий',
  'adm.auto.rearmHint': 'Сохранение взводит правило заново: сроки, наступившие раньше, не сработают',
  'adm.auto.form': 'Правило автосценария',
  'adm.auto.name': 'Название',
  'adm.auto.description': 'Зачем правило',
  'adm.auto.description.help': 'Для тех, кто будет разбираться, почему что-то произошло',
  'adm.auto.entity': 'Сущность',
  'adm.auto.entityImmutable': 'Сущность правила не меняется: условия названы полями этой сущности. Нужна другая — заведите новое правило',
  'adm.auto.trigger': 'Событие',
  'adm.auto.trigger.created': 'Запись создана',
  'adm.auto.trigger.field_changed': 'Поле изменилось',
  'adm.auto.trigger.stage_changed': 'Стадия сменилась',
  'adm.auto.trigger.sla_breached': 'Нарушен срок',
  'adm.auto.trigger.scheduled': 'По времени',
  'adm.auto.slaMeans': 'Срок нарушен, когда {what}',
  'adm.auto.timer': 'Когда',
  'adm.auto.timerAmount': 'Сколько',
  'adm.auto.timerUnit': 'Единица',
  'adm.auto.timerDirection': 'До или после',
  'adm.auto.timerAnchor': 'От чего отсчитывать',
  'adm.auto.timerCustom': 'Срок, ISO-8601',
  'adm.auto.timer.help': 'Не больше года в любую сторону. Сроки, прошедшие до сохранения правила, не срабатывают',
  'adm.auto.unit.M': 'минут',
  'adm.auto.unit.H': 'часов',
  'adm.auto.unit.D': 'дней',
  'adm.auto.after': 'после',
  'adm.auto.before': 'до',
  'adm.auto.conditions': 'Условия',
  'adm.auto.rawText': 'Условия этого правила сложнее, чем умеет конструктор (отрицание или больше двух уровней), и правятся текстом. Сервер проверит их при сохранении',
  'adm.auto.rawLabel': 'Условия, JSON',
  'adm.auto.rawInvalid': 'Условия — не JSON: проверьте скобки и кавычки',
  'adm.auto.rootGroup': 'Условия правила',
  'adm.auto.groupN': 'Группа {n}',
  'adm.auto.modeOf': '{where}: как сочетать',
  'adm.auto.mode.all': 'Все условия',
  'adm.auto.mode.any': 'Любое из условий',
  'adm.auto.emptyGroup': 'Пустая группа',
  'adm.auto.removeGroup': 'Удалить группу {n}',
  'adm.auto.addConditionTo': 'Добавить условие: {where}',
  'adm.auto.addCondition': 'Условие',
  'adm.auto.addGroup': 'Группа условий',
  'adm.auto.condField': 'Поле условия {n}',
  'adm.auto.condOp': 'Сравнение условия {n}',
  'adm.auto.condValue': 'Значение условия {n}',
  'adm.auto.condRemove': 'Удалить условие {n}',
  'adm.auto.true': 'да',
  'adm.auto.false': 'нет',
  'adm.auto.listHint': 'значения через запятую',
  'adm.auto.actions': 'Действия',
  'adm.auto.noActions': 'Правило без действий не сохранить: оно заполняло бы журнал «сработало», ничего не делая',
  'adm.auto.addAction': 'Действие',
  'adm.auto.placeholders': 'В тексте можно подставить поле записи: {number}, {title}',
  'adm.auto.actionN': 'Действие {n}',
  'adm.auto.actionType': 'Что сделать, действие {n}',
  'adm.auto.actionRemove': 'Удалить действие {n}',
  'adm.auto.action.create_task': 'Создать задачу',
  'adm.auto.action.notify': 'Уведомить',
  'adm.auto.action.assign': 'Назначить ответственного',
  'adm.auto.action.send_email': 'Отправить письмо',
  'adm.auto.action.webhook': 'Вызвать веб-хук',
  'adm.auto.param.create_task.subject': 'Тема задачи',
  'adm.auto.param.create_task.dueInHours': 'Срок, часов',
  'adm.auto.param.create_task.assigneeEmployeeId': 'Исполнитель (по умолчанию — ответственный)',
  'adm.auto.param.notify.recipient': 'Кого уведомить',
  'adm.auto.param.notify.title': 'Заголовок',
  'adm.auto.param.notify.message': 'Текст',
  'adm.auto.param.notify.kind': 'Вид',
  'adm.auto.param.assign.to': 'Кому передать',
  'adm.auto.param.assign.employeeId': 'Сотрудник',
  'adm.auto.param.send_email.template': 'Шаблон письма',
  'adm.auto.param.send_email.to': 'Кому (по умолчанию — основной контакт сделки)',
  'adm.auto.param.webhook.url': 'Адрес',
  'adm.auto.option.notify.kind.info': 'Информация',
  'adm.auto.option.notify.kind.warning': 'Предупреждение',
  'adm.auto.option.notify.kind.task': 'Задача',
  'adm.auto.option.assign.to.employee': 'Указанному сотруднику',
  'adm.auto.option.assign.to.manager': 'Руководителю ответственного',
  'adm.auto.recipient.responsible': 'Ответственному',
  'adm.auto.recipient.manager': 'Руководителю ответственного',
  'adm.auto.recipient.role': 'Всем с ролью',
  'adm.auto.recipient.user': 'Пользователю',
  'adm.auto.recipient.role.value': 'Код роли',
  'adm.auto.recipient.user.value': 'Идентификатор пользователя',
  'adm.auto.activeLabel': 'Правило включено',
  'adm.auto.conflict': 'Правило успели изменить — закройте форму и откройте его заново',
  'adm.auto.record': 'Запись',
  'adm.auto.record.help': 'Журнал и проверка — по одной записи: почему правило на ней сработало или нет',
  'adm.auto.allRecords': 'Все записи',
  'adm.auto.show': 'Показать',
  'adm.auto.evaluate': 'Проверить условия сейчас',
  'adm.auto.evaluate.help': 'Ничего не выполняет: только показывает, сработало бы правило и почему',
  'adm.auto.verdict': 'Проверка условий',
  'adm.auto.wouldFire': 'Условия выполнены — правило сработало бы',
  'adm.auto.wouldNotFire': 'Условия не выполнены — правило не сработало бы',
  'adm.auto.met': 'выполнено',
  'adm.auto.notMet': 'не выполнено',
  'adm.auto.actual': 'значение «{value}»',
  'adm.auto.actualNone': 'значение не задано',
  'adm.auto.kind.all': 'все из',
  'adm.auto.kind.any': 'любое из',
  'adm.auto.kind.not': 'не',
  'adm.auto.runs': 'Запуски правила',
  'adm.auto.actionRuns': 'Исполнение действий',
  'adm.auto.noRuns': 'Правило ещё не запускалось',
  'adm.auto.noRunsOnRecord': 'На этой записи правило не запускалось',
  'adm.auto.noRuns.text': 'Запуск появляется, когда происходит событие правила; выключенное правило не запускается. Проверить условия можно и без запуска',
  'adm.auto.col.when': 'Когда',
  'adm.auto.col.record': 'Запись',
  'adm.auto.col.result': 'Итог',
  'adm.auto.col.why': 'Причина',
  'adm.auto.col.action': 'Действие',
  'adm.auto.col.outcome': 'Исход',
  'adm.auto.runsOf': 'Запуски на записи {record}',
  'adm.auto.run.matched': 'Сработало',
  'adm.auto.run.notMatched': 'Не сработало',
  'adm.auto.run.failed': 'Ошибка',
  'adm.auto.run.acted': 'действий: {count}',
  'adm.auto.run.depth': 'в цепочке правил, глубина {depth}',
  'adm.auto.outcome.done': 'Выполнено',
  'adm.auto.outcome.rejected': 'Отказ',
  'adm.auto.outcome.failed': 'Сбой, будет повтор',

  // Телефония (#122)
  'nav.adminTelephony': 'Телефония',
  'nav.messengerInbox': 'Разбор мессенджеров',
  'nav.adminMessengers': 'Мессенджеры',
  'timeline.kind.message': 'Сообщение',
  'messenger.channel.telegram': 'Telegram',
  'messenger.channel.whatsapp': 'WhatsApp',
  'messenger.direction.inbound': 'Клиент',
  'messenger.direction.outbound': 'Мы',
  'messenger.delivery.received': 'Получено',
  'messenger.delivery.pending': 'В очереди',
  'messenger.delivery.sending': 'Отправляется',
  'messenger.delivery.sent': 'Отправлено',
  'messenger.delivery.failed': 'Не доставлено — повтор позже',
  'messenger.delivery.rejected': 'Отказ',
  'messenger.reply.title': 'Ответ в мессенджер',
  'messenger.reply.chat': 'Чат',
  'messenger.reply.text': 'Текст ответа',
  'messenger.reply.send': 'Отправить',
  'messenger.reply.sending': 'Отправляется…',
  'messenger.reply.sent': 'Отправлено в чат клиента',
  'messenger.reply.failed': 'Мессенджер не ответил: сообщение записано и уйдёт повтором',
  'messenger.reply.rejected': 'Не отправлено: {reason}',
  'messenger.reply.unusable.telegram': 'Telegram не подключён: ответ получит отказ, пока администратор не задаст токен бота',
  'messenger.reply.unusable.whatsapp': 'WhatsApp не подключён: ответ получит отказ, пока администратор не задаст настройки Meta',
  'messenger.reply.windowClosed': 'Клиент писал в WhatsApp больше 24 часов назад (последнее сообщение — {at}). Вне окна WhatsApp запрещает свободный текст, нужен утверждённый шаблон, а шаблоны в CRM не подключены. Позвоните клиенту или напишите письмо.',
  'messenger.inbox.title': 'Разбор мессенджеров',
  'messenger.inbox.lead': 'Чаты Telegram и WhatsApp, собеседника которых система не узнала. Привяжите диалог к контакту — его сообщения попадут в ленту карточки.',
  'messenger.inbox.ro': 'Только просмотр: привязывать диалоги может тот, у кого есть право на разбор',
  'messenger.inbox.forbidden': 'Очередь разбора мессенджеров доступна с правом на неё',
  'messenger.inbox.error': 'Не удалось загрузить очередь разбора',
  'messenger.inbox.empty': 'Неопознанных диалогов нет',
  'messenger.inbox.empty.text': 'Все, кто писал в Telegram и WhatsApp, узнаны и уже в карточках.',
  'messenger.inbox.messages': 'Последние сообщения',
  'messenger.inbox.suggestion': 'Возможно, это {name}: этот @username записан в карточке контакта. Проверьте, прежде чем привязывать.',
  'messenger.inbox.attachTo': 'Привязать к',
  'messenger.inbox.attach': 'Привязать',
  'messenger.adm.title': 'Мессенджеры',
  'messenger.adm.lead': 'Бот Telegram и номер WhatsApp Business: сообщения клиентов — в ленту карточки, ответ менеджера — в тот же чат.',
  'messenger.adm.forbidden': 'Настройки мессенджеров доступны с правом на интеграции',
  'messenger.adm.error': 'Не удалось загрузить настройки мессенджеров',
  'messenger.adm.incomplete': 'Настроен не полностью',
  'messenger.adm.webhook.telegram': 'Адрес вебхука для Telegram (регистрируется кнопкой ниже — setWebhook с секретом):',
  'messenger.adm.webhook.whatsapp': 'Callback URL для Meta (WhatsApp → Configuration → Webhook, поле messages):',
  'messenger.adm.enabled.telegram': 'Telegram включён',
  'messenger.adm.enabled.whatsapp': 'WhatsApp включён',
  'messenger.adm.endpoint': 'Адрес API',
  'messenger.adm.endpoint.telegram': 'По умолчанию https://api.telegram.org',
  'messenger.adm.endpoint.whatsapp': 'По умолчанию https://graph.facebook.com/v21.0',
  'messenger.adm.phoneNumberId': 'Phone number ID',
  'messenger.adm.phoneNumberId.help': 'Идентификатор номера отправителя из кабинета Meta (WhatsApp → API Setup)',
  'messenger.adm.token.telegram': 'Токен бота (от @BotFather)',
  'messenger.adm.token.whatsapp': 'Постоянный токен доступа (System User)',
  'messenger.adm.secret': 'Секрет вебхука (secret_token)',
  'messenger.adm.appSecret': 'App secret (подпись X-Hub-Signature-256)',
  'messenger.adm.verifyToken': 'Verify token (подтверждение вебхука)',
  'messenger.adm.secret.set': 'Сохранён. Пустое поле оставляет прежнее значение.',
  'messenger.adm.secret.unset': 'Не задан',
  'messenger.adm.saved': 'Сохранено',
  'messenger.adm.register': 'Зарегистрировать вебхук в Telegram',
  'messenger.adm.registered': 'Telegram принял адрес {url}',
  'messenger.adm.events': 'Журнал вебхуков',
  'messenger.adm.events.empty': 'Вебхуков от мессенджеров ещё не было',
  'messenger.adm.events.at': 'Получено',
  'messenger.adm.events.channel': 'Канал',
  'messenger.adm.events.status': 'Итог',
  'messenger.adm.events.detail': 'Подробности',
  'messenger.event.processed': 'Принято',
  'messenger.event.duplicate': 'Повтор',
  'messenger.event.ignored': 'Служебное',
  'messenger.event.rejected': 'Отклонено',
  'messenger.event.failed': 'Ошибка',
  'telephony.call': 'Позвонить',
  'telephony.call.pending': 'Соединяю…',
  'telephony.call.ordered': 'АТС соединяет: сначала зазвонит ваш телефон, после ответа — {number}',
  'telephony.call.rejected': 'АТС отказала в звонке: {reason}',
  'telephony.call.unavailable': 'АТС не ответила — наберите номер вручную. Звонок записан в ленту как запланированный.',
  'telephony.incoming.title': 'Входящий звонок',
  'telephony.incoming.close': 'Закрыть',
  'telephony.incoming.hidden': 'Номер скрыт',
  'telephony.incoming.open': 'Открыть карточку',
  'telephony.incoming.unknown': 'Новый номер',
  'telephony.incoming.createLead': 'Создать лид',
  'telephony.incoming.others': 'Ещё карточек с этим номером: {count}',
  'telephony.entity.contact': 'Контакт',
  'telephony.entity.counterparty': 'Контрагент',
  'telephony.entity.lead': 'Лид',
  'telephony.entity.deal': 'Сделка',
  'telephony.direction.inbound': 'Входящий',
  'telephony.direction.outbound': 'Исходящий',
  'telephony.duration.minutes': '{minutes} мин {seconds} с',
  'telephony.duration.seconds': '{seconds} с',
  'telephony.recording': 'Запись разговора',
  'telephony.recording.play': 'Прослушать запись',
  'telephony.recording.loading': 'Загружаю запись…',
  'telephony.recording.link': 'Запись разговора',
  'telephony.adm.title': 'Телефония',
  'telephony.adm.lead': 'Подключение облачной АТС Mango Office: звонок с карточки, окно входящего, звонки с записью в ленте.',
  'telephony.adm.forbidden': 'Настройки телефонии доступны с правом на интеграции',
  'telephony.adm.error': 'Не удалось загрузить настройки телефонии',
  'telephony.adm.connection': 'Подключение АТС',
  'telephony.adm.webhook': 'Адрес для АТС (Mango Office → «Интеграции» → «API» → адрес внешней системы):',
  'telephony.adm.enabled': 'Телефония включена',
  'telephony.adm.endpoint': 'Адрес API АТС',
  'telephony.adm.endpoint.help': 'Для Mango Office — https://app.mango-office.ru/vpbx',
  'telephony.adm.line': 'Номер линии для исходящих',
  'telephony.adm.line.help': 'Необязательно: без него АТС выберет линию сама',
  'telephony.adm.apiKey': 'Ключ (vpbx_api_key)',
  'telephony.adm.salt': 'Соль подписи (vpbx_api_salt)',
  'telephony.adm.secret.set': 'Сохранён. Пустое поле оставляет прежнее значение.',
  'telephony.adm.secret.unset': 'Не задан',
  'telephony.adm.extensions': 'Добавочные номера сотрудников',
  'telephony.adm.extensions.help': 'По добавочному АТС называет, чей телефон звонит: окно входящего уходит этому сотруднику, звонок с карточки начинается с его телефона.',
  'telephony.adm.extensions.empty': 'Добавочные не сопоставлены: окно входящего уйдёт ответственному за клиента, звонить с карточки никто не сможет.',
  'telephony.adm.employee': 'Сотрудник',
  'telephony.adm.extension': 'Добавочный',
  'telephony.adm.add': 'Добавить',
  'telephony.adm.remove': 'Убрать',
  'telephony.adm.saved': 'Сохранено',
  'telephony.adm.events': 'Журнал событий АТС',
  'telephony.adm.events.empty': 'Событий от АТС ещё не было',
  'telephony.adm.events.at': 'Получено',
  'telephony.adm.events.type': 'Событие',
  'telephony.adm.events.status': 'Итог',
  'telephony.adm.events.detail': 'Подробности',
  'nav.adminIntegrations': 'Интеграции',
  'integrations.title': 'Интеграции',
  'integrations.lead': 'Все подключения к внешним системам, push-каналы и исходящие вебхуки на события CRM. Учётные данные хранятся зашифрованными и наружу не отдаются.',
  'integrations.forbidden': 'Интеграции доступны с правом на интеграции',
  'integrations.error': 'Не удалось загрузить данные интеграций',
  'integrations.connections': 'Подключения',
  'integrations.col.name': 'Подключение',
  'integrations.col.state': 'Состояние',
  'integrations.col.credentials': 'Учётные данные',
  'integrations.col.check': 'Проверка соединения',
  'integrations.col.where': 'Где настраивается',
  'integrations.credentials.set': 'Заданы',
  'integrations.credentials.unset': 'Не заданы',
  'integrations.check': 'Проверить соединение',
  'integrations.check.never': 'Ещё не проверялось',
  'integrations.check.none': 'Проверки нет: проверяется первым вызовом',
  'integrations.check.ok': 'Работает',
  'integrations.check.failed': 'Ошибка',
  'integrations.where.screen': 'Открыть настройки',
  'integrations.where.push': 'Ниже, в push-каналах',
  'integrations.where.messenger': 'На экране мессенджеров',
  'integrations.where.stub': 'Заглушка: реального адаптера пока нет',
  'integrations.where.other': 'Неизвестное подключение: настраивается через REST',
  'integrations.push': 'Push-каналы',
  'integrations.push.lead': 'Секрет только записывается: сервер отвечает, задан ли он, но не какой. Пустое поле оставляет прежнее значение.',
  'integrations.push.webpush': 'Push в браузер (Web Push)',
  'integrations.push.fcm': 'Push на Android (FCM)',
  'integrations.push.rustore': 'Push RuStore',
  'integrations.push.enabled': 'Канал включён',
  'integrations.push.incomplete': 'Включён, но настроен не полностью',
  'integrations.push.vapid': 'Создать ключи VAPID',
  'integrations.push.field.publicKey': 'Публичный ключ VAPID',
  'integrations.push.field.subject': 'Контакт VAPID (mailto: или https:)',
  'integrations.push.field.projectId': 'Идентификатор проекта',
  'integrations.push.field.clientEmail': 'Адрес сервисного аккаунта',
  'integrations.push.field.endpoint': 'Адрес API',
  'integrations.push.field.tokenUri': 'Адрес выдачи токена',
  'integrations.push.secret.webpush': 'Закрытый ключ VAPID',
  'integrations.push.secret.fcm': 'Закрытый ключ сервисного аккаунта (PEM)',
  'integrations.push.secret.rustore': 'Сервисный токен проекта',
  'integrations.secret.kept': 'Сохранён. Пустое поле оставляет прежнее значение.',
  'integrations.secret.unset': 'Не задан',
  'integrations.saved': 'Сохранено',
  'integrations.cancel': 'Отмена',
  'integrations.webhooks': 'Исходящие вебхуки',
  'integrations.webhooks.lead': 'Внешний адрес получает POST на выбранные события. Тело подписано HMAC-SHA256 секретом подписки: заголовок X-CRM-Signature «t=<время>,v1=<подпись>» от «<время>.<тело>». Недоступный получатель (5xx, нет ответа) получает повторы с нарастающей паузой, отказ (4xx) не повторяется. Адреса внутренней сети запрещены.',
  'integrations.webhooks.add': 'Добавить подписку',
  'integrations.webhooks.edit': 'Изменить',
  'integrations.webhooks.empty': 'Подписок нет: события CRM никуда не отправляются',
  'integrations.webhooks.subscriptions': 'Подписки',
  'integrations.webhooks.name': 'Название',
  'integrations.webhooks.url': 'Адрес получателя',
  'integrations.webhooks.url.help': 'https://… во внешней сети; внутренние адреса запрещены',
  'integrations.webhooks.events': 'События',
  'integrations.webhooks.active': 'Подписка включена',
  'integrations.webhooks.stats': 'Доставки',
  'integrations.webhooks.counts': 'доставлено {delivered}, ждёт {waiting}, потеряно {lost}',
  'integrations.webhooks.journal': 'Журнал',
  'integrations.webhooks.actions': 'Действия',
  'integrations.webhooks.ping': 'Проверить получателя',
  'integrations.webhooks.ping.ok': 'Получатель ответил',
  'integrations.webhooks.ping.rejected': 'Получатель отказал',
  'integrations.webhooks.ping.unavailable': 'Получатель недоступен',
  'integrations.webhooks.rotate': 'Новый секрет',
  'integrations.webhooks.rotate.confirm': 'Выпустить новый секрет? Прежний перестанет действовать сразу, и получатель начнёт отказывать, пока его не заменят.',
  'integrations.webhooks.delete': 'Удалить',
  'integrations.webhooks.delete.confirm': 'Удалить подписку? Журнал доставок останется, ждущие доставки не уйдут.',
  'integrations.webhooks.secret': 'Секрет подписи',
  'integrations.webhooks.secret.once': 'Секрет подписки «{name}» — скопируйте его сейчас: он показывается один раз, потом его можно только перевыпустить.',
  'integrations.webhooks.secret.hide': 'Скопировал, скрыть',
  'integrations.journal': 'Журнал доставок',
  'integrations.journal.all': 'Показать все подписки',
  'integrations.journal.status': 'Состояние доставки',
  'integrations.journal.status.any': 'Все состояния',
  'integrations.journal.empty': 'Доставок ещё не было',
  'integrations.journal.at': 'Время',
  'integrations.journal.subscription': 'Подписка',
  'integrations.journal.event': 'Событие',
  'integrations.journal.state': 'Состояние',
  'integrations.journal.attempts': 'Попытки',
  'integrations.journal.attemptsCount': 'Попыток: {count}',
  'integrations.journal.attemptsTitle': 'Попытки доставки',
  'integrations.journal.next': 'Следующая попытка',
  'integrations.journal.result': 'Итог',
  'integrations.journal.code': 'Код ответа',
  'integrations.journal.answer': 'Ответ получателя',
  'integrations.journal.retry': 'Повторить сейчас',
  'integrations.delivery.pending': 'Ожидает',
  'integrations.delivery.sending': 'Отправляется',
  'integrations.delivery.delivered': 'Доставлено',
  'integrations.delivery.failed': 'Не доставлено, будет повтор',
  'integrations.delivery.rejected': 'Отклонено получателем',
  'integrations.delivery.abandoned': 'Брошено после всех попыток',
  'telephony.event.received': 'Принято',
  'telephony.event.processed': 'Обработано',
  'telephony.event.ignored': 'Без действий',
  'telephony.event.rejected': 'Отклонено: подпись',
  'telephony.event.failed': 'Сбой',
  'summary.title': 'Резюме переговоров',
  'summary.button': 'Резюме',
  'summary.again': 'Составить заново',
  'summary.from': 'С',
  'summary.to': 'По',
  'summary.intro': 'Сводка писем, звонков, сообщений и комментариев за период — каждое утверждение со ссылкой на запись, из которой оно взято.',
  'summary.state.working': 'Резюме готовится…',
  'summary.state.failed': 'Резюме не составлено',
  'summary.section.agreements': 'Договорённости',
  'summary.section.openQuestions': 'Открытые вопросы',
  'summary.section.nextSteps': 'Следующий шаг',
  'summary.section.empty': 'Нет',
  'summary.unsupported.title': 'Без подтверждения источником',
  'summary.unsupported.hint': 'Модель сказала это, не сославшись на запись, которую ей передали, — не принимайте на веру.',
  'summary.unsupported.no_source': 'нет ссылки',
  'summary.unsupported.unknown_source': 'ссылка на несуществующий источник {labels}',
  'summary.unknownLabels': 'модель сослалась и на несуществующее: {labels}',
  'summary.sources': 'Источников в запросе: {count}',
  'summary.omitted': 'Не вошли в запрос: {count} более ранних записей периода',
  'summary.notInFeed': 'Эта запись не загружена в ленту — нажмите «Показать раньше»',
  'summary.untranscribed': 'без расшифровки',
  'summary.fragment': 'Звонок {clock}',
  'summary.callButton': 'Резюме звонка',
  'summary.requestedAt': 'Составлено {at}',
  'transcript.button': 'Расшифровать',
  'transcript.show': 'Расшифровка',
  'transcript.hide': 'Скрыть расшифровку',
  'transcript.loading': 'Загрузка…',
  'transcript.state.pending': 'Расшифровка в очереди',
  'transcript.state.submitted': 'Запись распознаётся…',
  'transcript.state.failed': 'Сервис распознавания не ответил, повторим: {error}',
  'transcript.state.rejected': 'Не расшифровано: {error}',
  'transcript.retry': 'Расшифровать снова',
  'transcript.refresh': 'Обновить',
  'transcript.empty': 'В записи не распознано ни слова',
  'speechkit.title': 'Распознавание речи (Yandex SpeechKit)',
  'speechkit.intro': 'Расшифровка записей звонков. Ключ — API-ключ сервисного аккаунта Yandex Cloud с ролью ai.speechkit-stt.user (можно тот же, что у YandexGPT).',
  'speechkit.enabled': 'Включено',
  'speechkit.endpoint': 'Адрес API распознавания',
  'speechkit.operationEndpoint': 'Адрес API операций',
  'speechkit.folderId': 'Идентификатор каталога (необязательно)',
  'speechkit.model': 'Модель',
  'speechkit.apiKey': 'API-ключ',
  'speechkit.apiKeySet': 'Ключ сохранён — оставьте поле пустым, чтобы не менять',
  'speechkit.save': 'Сохранить',
  'speechkit.saved': 'Сохранено',
  'speechkit.usable': 'Подключено',
  'speechkit.notUsable': 'Не подключено',
  // Lead scoring (#129)
  'nav.leadScoreModel': 'Оценка лидов',
  'admin.rule.field.scoreClass': 'Оценка лида',
  'column.score_class': 'Оценка',
  'column.score_probability': 'Вероятность конверсии',
  'column.score_method': 'Чем оценён',
  'column.scored_at': 'Оценён',
  'value.sales.lead.score_class.hot': 'Горячий',
  'value.sales.lead.score_class.warm': 'Тёплый',
  'value.sales.lead.score_class.cold': 'Холодный',
  'value.sales.lead.score_method.model': 'Модель',
  'value.sales.lead.score_method.rule': 'Правило',
  'leadScore.title': 'Оценка лида',
  'leadScore.loading': 'Загружаем оценку…',
  'leadScore.error': 'Не удалось загрузить оценку',
  'leadScore.none': 'Оценки пока нет: новый лид оценивается в течение минуты после поступления',
  'leadScore.rescore': 'Пересчитать',
  'leadScore.rescoring': 'Пересчитываем…',
  'leadScore.why': 'Почему так',
  'leadScore.byModel': 'Вероятность конверсии {probability} — модель',
  'leadScore.byRule': 'Правило, не модель: {points} балл(ов)',
  'leadScore.byRuleInsufficient': 'Правило, не модель (мало лидов с исходом): {points} балл(ов)',
  'leadScore.text.analyzed': 'Текст заявки (ИИ): {signals}',
  'leadScore.text.no_text': 'В заявке нет текста для разбора',
  'leadScore.text.pending': 'Текст заявки ждёт разбора ИИ',
  'leadScore.text.unavailable': 'Текст заявки не разобран: ИИ недоступен',
  'leadScore.text.failed': 'Провайдер ИИ не ответил — разбор будет повторён',
  'leadScore.text.rejected': 'ИИ не смог разобрать текст заявки',
  'leadScore.intent.high': 'намерение высокое',
  'leadScore.intent.medium': 'намерение среднее',
  'leadScore.intent.low': 'намерение слабое',
  'leadScore.intent.none': 'не про покупку',
  'leadScore.signal.urgent': 'срочно',
  'leadScore.signal.budget': 'назван бюджет',
  'leadScore.signal.spam': 'похоже на спам',
  'leadScore.value.yes': 'да',
  'leadScore.value.no': 'нет',
  'leadScore.factorLine': '{factor} — {effect} ({kind})',
  'leadScore.kind.model': 'модель',
  'leadScore.kind.rule': 'правило',
  'leadScore.kind.text': 'текст',
  'leadScore.factor.intent': 'Намерение по тексту: {value}',
  'leadScore.factor.source': 'Источник: {value}',
  'leadScore.feature.source': 'Источник: {value}',
  'leadScore.model.lead': 'Логистическая регрессия на лидах с исходом «конвертирован/отклонён». Пока лидов мало, лиды оцениваются правилом баллов — без вероятности.',
  'leadScore.model.forbidden': 'Отчёт о модели оценки лидов вам недоступен',
  'leadScore.model.coverage': 'Открытые лиды: моделью — {model}, правилом — {rule}, не оценены — {unscored}',
  'leadScore.model.none.title': 'Модель ещё не обучалась',
  'leadScore.model.none.text': 'Лиды оцениваются правилом баллов. Для обучения нужно не меньше {min} лидов с исходом.',
  'leadScore.model.insufficient.title': 'Мало данных для модели',
  'leadScore.model.insufficient.text': '{message}. Попытка от {date}. Пока лиды оцениваются правилом, без вероятности.',
  'leadScore.model.summary': 'Обучена {date}: {train} лидов в обучении, {holdout} — в отложенной выборке (поступившие с {from}). Горячий — от {hot}, тёплый — от {warm}.',
  'leadScore.model.textLearned': 'Сигналы текста заявки (ИИ) учтены моделью: в обучении были лиды с разобранным текстом.',
  'leadScore.model.textByRule': 'Модель ещё не видела лидов с разобранным текстом — текст учитывается фиксированными поправками правила.',
  'leadScore.model.origins': 'Признаки обучения: снимок при приёме — {intake}, журнал создания — {journal}. Не вошли в обучение — {excluded}: о них нет записи, какими они пришли, а нынешняя строка описывает уже квалификацию, а не заявку.',
  'leadScore.model.col.baseline': 'Без модели',
  'leadScore.model.aucHint': 'Ранжирование: модель против правила баллов',
  'leadScore.model.baselineNote': 'AUC сравнивается с правилом баллов; log-loss и Brier — со «всегда средней конверсией»: у правила баллы, а не вероятность.',
  'leadScore.model.col.leads': 'Лидов',
  'leadScore.model.col.actual': 'Конвертировано',
  'leadScore.model.rates': 'Конверсия: в обучении {train}, в отложенной выборке {holdout}',
  'leadScore.factor.has_phone': 'Телефон указан: {value}',
  'leadScore.feature.has_phone': 'Телефон указан',
  'leadScore.factor.has_email': 'Почта указана: {value}',
  'leadScore.feature.has_email': 'Почта указана',
  'leadScore.factor.corporate_email': 'Почта на домене компании: {value}',
  'leadScore.feature.corporate_email': 'Почта на домене компании',
  'leadScore.factor.has_company': 'Компания названа: {value}',
  'leadScore.feature.has_company': 'Компания названа',
  'leadScore.factor.has_inn': 'ИНН указан: {value}',
  'leadScore.feature.has_inn': 'ИНН указан',
  'leadScore.factor.known_client': 'Уже известный клиент: {value}',
  'leadScore.feature.known_client': 'Уже известный клиент',
  'leadScore.factor.has_utm': 'Пришёл с рекламной меткой (UTM): {value}',
  'leadScore.feature.has_utm': 'Пришёл с рекламной меткой (UTM)',
  'leadScore.factor.message_words': 'Слов в сообщении: {value}',
  'leadScore.feature.message_words': 'Длина сообщения (лог)',
  'leadScore.factor.text_read': 'Текст разобран ИИ: {value}',
  'leadScore.feature.text_read': 'Текст разобран ИИ',
  'leadScore.factor.intent_high': 'Высокое намерение купить: {value}',
  'leadScore.feature.intent_high': 'Высокое намерение купить',
  'leadScore.factor.intent_low': 'Слабое намерение: {value}',
  'leadScore.feature.intent_low': 'Слабое намерение',
  'leadScore.factor.urgent': 'Срочно: {value}',
  'leadScore.feature.urgent': 'Срочно',
  'leadScore.factor.budget_mentioned': 'Назван бюджет или объём: {value}',
  'leadScore.feature.budget_mentioned': 'Назван бюджет или объём',
  'leadScore.factor.spam': 'Спам: {value}',
  'leadScore.feature.spam': 'Спам',

  // Задачи, предложенные ИИ (#131)
  'notifications.kind.task_proposed': 'Задачи, предложенные ИИ',
  'proposals.title': 'Предложено ИИ',
  'proposals.error': 'Не удалось загрузить предложенные задачи',
  'proposals.due': 'Срок: {date}',
  'proposals.noDue': 'Без срока: {reason}',
  'proposals.basis': 'Основание: «{text}»',
  'proposals.basisUnverified': 'Основание (в тексте дословно не найдено): {text}',
  'proposals.assignee': 'Исполнитель: {name}',
  'proposals.noAssignee': 'Исполнитель не определён',
  'proposals.accept': 'Подтвердить',
  'proposals.notAssignable': 'Предложенного исполнителя назначить вы не можете — выберите другого',
  'proposals.edit': 'Изменить и подтвердить',
  'proposals.dismiss': 'Отклонить',
  'proposals.me': 'Я',
  'proposals.onLeave': 'в отпуске по {until}',
  'proposals.load': 'задач на 3 дня: {count}',
  'proposals.form.subject': 'Тема задачи',
  'proposals.form.due': 'Срок',
  'proposals.form.assignee': 'Исполнитель',
  'proposals.form.submit': 'Создать задачу',
  'proposals.form.cancel': 'Отмена',
  'proposals.source.emailIn': 'письмо клиента {date}',
  'proposals.source.emailOut': 'наше письмо {date}',
  'proposals.source.call': 'звонок {date}',
  'proposals.source.comment': 'комментарий {date}',
  'aiTasks.title': 'Задачи из писем, звонков и комментариев',
  'aiTasks.intro':
    'ИИ читает сопоставленные письма, расшифрованные звонки и комментарии и предлагает задачи с ' +
    'исполнителем и сроком; задача появляется только после подтверждения. Каждый источник — расход ' +
    'токенов; пришедшее при выключенной функции позже не разбирается.',
  'aiTasks.enabled': 'Предлагать задачи',

  // Следующий шаг по сделке (#133)
  'nextStep.title': 'Следующий шаг',
  'nextStep.error': 'Не удалось загрузить рекомендации',
  'nextStep.none': 'Открытых рекомендаций нет',
  'nextStep.kind.quote_unanswered': 'КП без ответа',
  'nextStep.kind.stage_stuck': 'Застряла на стадии',
  'nextStep.kind.no_activity': 'Нет контакта',
  'nextStep.deal': 'Сделка {number}',
  'nextStep.reason': 'Повод:',
  'nextStep.opener': 'Начать разговор: «{text}»',
  'nextStep.source.ai': 'Повод предложен ИИ',
  'nextStep.source.template': 'Повод — шаблон системы',
  'nextStep.accept': 'Создать задачу',
  'nextStep.dismiss': 'Отклонить',
  'nextStep.dismissReason': 'Причина (необязательно)',
  'nextStep.dismissConfirm': 'Отклонить',
  'nextStep.cancel': 'Отмена',
  'nextStep.decidedBy': 'Решает ответственный: {name}',
  'nextStep.notYours': 'Решать рекомендацию по этой сделке вы не можете',
  'nextStep.history': 'Решения по рекомендациям: {count}',
  'nextStep.status.accepted': 'принята',
  'nextStep.status.dismissed': 'отклонена',
  'nextStep.status.resolved': 'неактуальна',
  'nextStep.status.open': 'открыта',
  'nextStepAdmin.title': 'Повод для следующего шага по сделке',
  'nextStepAdmin.intro':
    'Рекомендации «позвонить по КП без ответа», «сделка застряла», «давно нет контакта» находятся ' +
    'правилами всегда. Включённый, ИИ пишет к каждой новой рекомендации готовый повод для звонка — это ' +
    'расход токенов; выключенный — показывается шаблон, и он подписан как шаблон.',
  'nextStepAdmin.enabled': 'Писать повод с помощью ИИ',

  // Черновик ответа клиенту (#134)
  'replyDraft.title': 'Черновик ответа ИИ',
  'replyDraft.button': 'Черновик ответа',
  'replyDraft.again': 'Новый черновик',
  'replyDraft.working': 'Черновик готовится',
  'replyDraft.inserted': 'Черновик вставлен в поле — прочитайте и поправьте перед отправкой',
  'replyDraft.failed': 'Черновик не получился: {reason}',
  'replyDraft.basis': 'На что опирался черновик',
  'replyDraft.contracts': 'Действующие договоры',
  'replyDraft.history': 'Записи истории',
  'replyDraft.cited': 'упомянут в ответе',
  'replyDraft.noContracts': 'Действующих договоров нет — условия в черновике не из договора',
  'replyDraft.contractsWithheld': 'У клиента есть договоры, которые вам не видны: в черновик они не попали',
  'replyDraft.unknown': 'Модель сослалась на записи, которых ей не давали: {labels}',
  'replyDraft.noKnowledgeBase': 'Базы знаний компании в CRM нет: регламенты и общие правила черновик не учитывает',
  'replyDraft.review': 'Сам черновик никуда не уходит: отправляет только кнопка «Отправить»',
  'mail.reply.button': 'Ответить',
  'mail.reply.title': 'Ответ на письмо',
  'mail.reply.loading': 'Открываем ответ…',

  // Ассистент по данным CRM (#136)
  'nav.assistant': 'Ассистент',
  'assistant.lead':
    'Спросите словами — ассистент ответит по данным CRM со ссылками на записи. Он видит ровно то, что ' +
    'видите вы: на чужие данные ответом будет отказ, а не пустой список.',
  'assistant.examples':
    'Например: «какие сделки Иванова зависли на КП больше двух недель», «мои сделки без движения больше ' +
    'месяца», «что известно о клиенте Ромашка», «выручка по менеджерам».',
  'assistant.question': 'Вопрос ассистенту',
  'assistant.placeholder': 'Ваш вопрос (Ctrl+Enter — отправить)',
  'assistant.ask': 'Спросить',
  'assistant.thinking': 'Ищу ответ…',
  'assistant.newChat': 'Новый разговор',
  'assistant.failed': 'Ассистент не ответил',
  'assistant.exchange': 'Вопрос и ответ',
  'assistant.understood': 'Понято как',
  'assistant.tool.deals_stalled': 'сделки, зависшие на стадии',
  'assistant.tool.report': 'отчёт',
  'assistant.tool.search': 'поиск по записям',
  'assistant.tool.none': 'вопрос вне умений ассистента',
  'assistant.refused': 'Отказ:',
  'assistant.empty': 'Ничего не найдено.',
  'assistant.candidates': 'Подходящие сотрудники',
  'assistant.records': 'Записи ответа',
  'assistant.table': 'Результат отчёта',
  'assistant.dropped': 'Модель сослалась на записи, которых ей не давали ({labels}) — ссылки убраны',
  // Клиенты в зоне риска (#135)
  'nav.clientRisk': 'Клиенты в зоне риска',
  'notifications.kind.client_risk': 'Клиенты в зоне риска',
  'clientRisk.intro':
    'Риск считается правилом по фактам — молчание после наших писем и звонков, жалобы и их тон ' +
    '(разбор обращений ИИ), платёжная дисциплина, падение закупок, близкий срок счёта. Веса заданы ' +
    'рассуждением, а не обучены на данных: балл — не вероятность ухода. «В зоне риска» — от {high} ' +
    'баллов, «присмотреться» — от {medium}. Перестал отвечать — {touches} и больше наших обращений ' +
    'без ответа, первое не меньше {silence} дн. назад; жалобы — за {complaints} дн.; скоро срок — ' +
    'в ближайшие {due} дн. Пересчёт — раз в час и при открытии карточки клиента.',
  'clientRisk.filter': 'Уровень риска',
  'clientRisk.filter.all': 'Все',
  'clientRisk.filter.high': 'В зоне риска',
  'clientRisk.filter.medium': 'Присмотреться',
  'clientRisk.level.high': 'в зоне риска',
  'clientRisk.level.medium': 'присмотреться',
  'clientRisk.level.low': 'риска нет',
  'clientRisk.col.client': 'Клиент',
  'clientRisk.col.level': 'Уровень',
  'clientRisk.col.score': 'Балл',
  'clientRisk.col.reasons': 'Причины',
  'clientRisk.col.responsible': 'Ответственный',
  'clientRisk.col.since': 'В зоне риска с',
  'clientRisk.empty': 'Клиентов в зоне риска нет',
  'clientRisk.emptyText': 'Среди клиентов, которые вам видны, ни один не набрал баллов риска при последнем пересчёте',
  'clientRisk.truncated': 'Показаны первые 500 клиентов — сузьте уровень',
  'clientRisk.noResponsible': 'не назначен',
  'clientRisk.nobodyTold': 'Уведомить некого: у ответственного нет учётной записи',
  'clientRisk.error': 'Риск клиента не удалось получить',
  'clientRisk.card.title': 'Риск ухода клиента',
  'clientRisk.card.score': 'балл {score} из 100',
  'clientRisk.card.since': 'с {at}',
  'clientRisk.card.rule': 'Оценка по правилу с весами, заданными рассуждением, — не прогноз модели',

  // ------------------------------------------------- #94: недоделанные экраны поверх готового API
  // Дашборды: перетаскивание, правка и обновление виджета, круговая, спидометр, тепловая карта.
  'dashboard.layout.hint': 'Перетащите виджет за ручку ⠿ на место другого или переставьте стрелками — раскладка сохраняется сразу',
  'dashboard.widget.drag': 'Перетащить виджет «{title}»',
  'dashboard.widget.moveEarlier': 'Переставить «{title}» раньше',
  'dashboard.widget.moveLater': 'Переставить «{title}» позже',
  'dashboard.widget.edit': 'Изменить',
  'dashboard.widget.editTitle': 'Виджет «{title}»',
  'dashboard.widget.save': 'Сохранить виджет',
  'dashboard.widget.cancelEdit': 'Отмена',
  'dashboard.widget.height': 'Высота (рядов)',
  'dashboard.widget.refreshNow': 'Обновить',
  'dashboard.widget.pie.other': 'Остальное',
  'dashboard.widget.pie.negative':
    'Круговая не рисуется: среди значений есть отрицательные, а у отрицательной доли нет сектора — показано таблицей',
  'dashboard.widget.gauge.noScale':
    'Шкалы нет: спидометру нужна вторая величина в строке отчёта (например, план рядом с фактом)',
  'dashboard.widget.gauge.label': '{value} из {scale}',
  'dashboard.widget.gauge.over': 'Выше шкалы',
  'dashboard.widget.heatmap.needsTwo':
    'Тепловой карте нужны два измерения и величина — в отчёте одно измерение, показано таблицей',
  // Подписки: список и карточка.
  'nav.subscriptions': 'Подписки',
  'column.frequency': 'Периодичность',
  'column.day_of_month': 'День месяца',
  'column.next_run_on': 'Следующее выставление',
  'value.billing.recurring.frequency.weekly': 'Еженедельно',
  'value.billing.recurring.frequency.monthly': 'Ежемесячно',
  'value.billing.recurring.frequency.quarterly': 'Ежеквартально',
  'value.billing.recurring.frequency.yearly': 'Ежегодно',
  'record.sub.active': 'Действует',
  'record.sub.stopped': 'Остановлена',
  'record.sub.contract': 'По договору',
  'record.sub.schedule': 'Расписание',
  'record.sub.day': '{day}-го числа',
  'record.sub.period': 'Срок',
  'record.sub.since': 'с {date}, бессрочно',
  'record.sub.ended': 'Срок подписки истёк',
  'record.sub.template': 'Строки счёта',
  'record.sub.sections': 'Разделы подписки',
  'record.sub.noLines': 'В шаблоне нет строк',
  'record.sub.stop': 'Остановить',
  'record.sub.stop.title': 'Остановить подписку «{name}»?',
  'record.sub.stop.text': 'Счета по подписке перестанут выставляться. Клиент об этом не узнает — предупредите его сами.',
  'record.sub.resume': 'Возобновить',
  'record.sub.resume.title': 'Возобновить подписку «{name}»',
  'record.sub.resume.text':
    'Пропущенные за время остановки периоды не выставляются: следующий счёт — в ближайший срок после выбранной даты.',
  'record.sub.resume.on': 'Возобновить с',
  'record.sub.resume.missing': 'Укажите дату возобновления',
  // Конструктор отчётов: журнал запусков.
  'rb.runs.title': 'Запуски отчёта',
  'rb.runs.empty': 'Отчёт ещё не запускали',
  'rb.runs.rows': 'строк: {count}',
  'rb.runs.status.queued': 'в очереди',
  'rb.runs.status.running': 'выполняется',
  'rb.runs.status.completed': 'выполнен',
  'rb.runs.status.failed': 'сбой',
  // Почта: повтор недоставленного письма.
  'mail.result.retryNow': 'Повторить сейчас',
  // Склад: открытие инвентаризации, оформление приёмки и перемещения.
  'stocktake.create.title': 'Новая инвентаризация',
  'stocktake.create.submit': 'Открыть инвентаризацию',
  'stocktake.create.pickWarehouse': 'Выберите склад',
  'stocktake.create.pickZone': 'Выберите зону',
  'stocktake.create.pickCell': 'Выберите ячейку',
  'stocktake.create.cellSearch': 'Поиск ячейки',
  'stocktake.create.cellsTruncated': 'Показаны не все ячейки — уточните поиск',
  'stocktake.create.productHelp': 'Один товар по всем ячейкам этого склада',
  'stocktake.create.blind': 'Слепой пересчёт',
  'stocktake.create.blindHelp': 'Ожидаемое количество не покажется счётчику — его скрывает сервер',
  'stocktake.create.needWarehouse': 'Выберите склад',
  'stocktake.create.needZone': 'Выберите зону',
  'stocktake.create.needCell': 'Выберите ячейку',
  'stocktake.create.needProduct': 'Выберите товар',
  'stocktake.create.noTopology': 'Нет доступа к справочнику складов — список складов не загрузить',
  'whdoc.create.pickWarehouse': 'Выберите склад',
  'whdoc.create.needWarehouse': 'Выберите склад',
  'whdoc.create.needLines': 'У каждой строки нужны товар и количество больше нуля',
  'whdoc.create.noTopology': 'Нет доступа к справочнику складов — список складов не загрузить',
  'whdoc.lines': 'Строки',
  'whdoc.line': 'Строка {n}',
  'whdoc.addLine': 'Добавить строку',
  'whdoc.removeLine': 'Убрать строку',
  'whdoc.quantity': 'Количество',
  'whdoc.unitCost': 'Цена закупки',
  'whdoc.unitCostHelp': 'Без цены приход не создаст слоя себестоимости',
  'whdoc.receipt.title': 'Новая приёмка',
  'whdoc.receipt.submit': 'Открыть приёмку',
  'whdoc.receipt.kind': 'Вид приёмки',
  'whdoc.receipt.planned': 'Плановая — с ожидаемым',
  'whdoc.receipt.unplanned': 'Внеплановая — без строк',
  'whdoc.receipt.unplannedHelp': 'Строки наберёт кладовщик сканером; всё доехавшее прочитается как излишек',
  'whdoc.transfer.title': 'Новое перемещение',
  'whdoc.transfer.submit': 'Оформить перемещение',
  'whdoc.transfer.fromCell': 'Откуда взять',
  'whdoc.transfer.pickCell': 'Выберите ячейку',
  'whdoc.transfer.cellOption': 'Ячейка {cell}, свободно {available}',
  'whdoc.transfer.noStock': 'Этого товара нет на складе-отправителе',
  'whdoc.transfer.overAvailable': 'Свободно только {available} — отправка не пройдёт',
  'whdoc.transfer.needWarehouses': 'Выберите склад-отправитель и склад-получатель',
  'whdoc.transfer.sameWarehouse': 'Склад-получатель совпадает с отправителем',
  'whdoc.transfer.needLines': 'У каждой строки нужны товар, ячейка и количество больше нуля',

  // #109: narrow screens — navigation drawer, list cards.
  'nav.openMenu': 'Открыть меню',
  'nav.closeMenu': 'Закрыть меню',
  'list.cards.label': 'Записи',
  'list.cards.sortBy': 'Сортировка',
  'list.cards.sortAscending': 'По возрастанию — нажмите, чтобы обратить',
  'list.cards.sortDescending': 'По убыванию — нажмите, чтобы обратить',

  // #88: XLSX export of lists, reports and schedules.
  'export.xlsx': 'Выгрузить в Excel (XLSX)',
  'rb.exportXlsx': 'Экспорт в Excel',
  'rb.exportXlsxOf': 'Выгрузить «{name}» в Excel',
  'rm.format.xlsx': 'Excel (XLSX)',
  'rm.format.csv': 'CSV',
}
